/* Intellikids diploma-maker op de website (R137): gegenereerd door _build/r137/bouw-shopify.mjs uit diploma-maker/js */
window.IKDMU = function (p) { var m = window.IKDM && window.IKDM.map; var k = String(p).replace(/^assets\//, ""); return (m && m[k]) || p; };
(function () {
  var grootGolf = 0;
  function kop() {
    var r = document.getElementById("ikdm"); var h = document.querySelector(".section-header") || document.querySelector("header"); if (!r || !h) { return; }
    var sticky = window.getComputedStyle(h).position === "sticky";
    var golf = Math.round(parseFloat(window.getComputedStyle(h, "::after").height) || 0);
    var klein = h.classList.contains("scrolled-past-header");
    if (!klein && (window.pageYOffset || 0) < 1) { grootGolf = golf; }
    var groot = Math.max(grootGolf, window.innerWidth >= 990 ? 120 : 60);
    var hoofd = document.getElementById("MainContent"); var pad = hoofd ? (parseFloat(window.getComputedStyle(hoofd).paddingTop) || 0) : 0;
    r.style.setProperty("--ikdm-kop", (sticky ? Math.round(h.getBoundingClientRect().height) : 0) + "px");
    r.style.setProperty("--ikdm-golf", (sticky ? golf : 0) + "px");
    r.style.setProperty("--ikdm-vrij", Math.max(0, groot + 6 - pad - 14) + "px");
  }
  var wacht = false;
  var rust = 0; function plan() { window.clearTimeout(rust); rust = window.setTimeout(kop, 200); if (wacht) { return; } wacht = true; (window.requestAnimationFrame || window.setTimeout)(function () { wacht = false; kop(); }, 16); }
  window.IKDMKop = kop;
  window.addEventListener("resize", function () { grootGolf = 0; plan(); });
  window.addEventListener("scroll", plan, { passive: true });
  window.addEventListener("load", kop);
  if (window.ResizeObserver) { var hh = document.querySelector(".section-header") || document.querySelector("header"); if (hh) { new window.ResizeObserver(plan).observe(hh); } }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", kop); } else { kop(); }
}());
window.IKDMScroll = function () { if (window.IKDMKop) { window.IKDMKop(); } try { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); } catch (e) { window.scroll(0, 0); } if (window.IKDMKop) { window.IKDMKop(); } };

/* ---- inhoud.js ---- */
/*
 * Intellikids diploma-maker (besloten testversie, R127)
 * Goedgekeurde inhoud: spellen, prestaties en thema's.
 *
 * Claimregels (R125, aangescherpt in R134):
 * - Prestaties beschrijven wat het kind deed, niet wat het kan: alleen positieve activiteiten en ontdekkingen
 *   ("Geoefend met...", "...ontdekt", "Gespeeld met..."). Geen "opnieuw geprobeerd", herkansing of verwijzing naar eerdere moeite.
 * - Nooit: slim, meester, geleerd, beheerst, kent, knap in, klaar voor school,
 *   leeftijden, groep, ontwikkeling, motoriek, concentratie of therapie.
 * - Elke productgebonden zin verwijst naar iets wat in de productbeschrijving staat.
 *   De bron staat per zin in het veld "bron".
 */
(function () {
  'use strict';

  // R134: "zin" is nu de zelfstandige tekst die op het diploma staat (en in de keuze), bijvoorbeeld "Geoefend met de gespen".
  // Bron = waar het onderdeel in de productinformatie staat (blogcontracten en productsets, docs/BLOGS-TOEKOMST-03).
  var spellen = [
    {
      id: 'activiteitenboek',
      naam: 'Activiteitenboek',
      uitleg: 'Busy Board met gespen, vormen en meer',
      kleur: 'blauw',
      prestaties: [
        { id: 'gespen', zin: 'Geoefend met de gespen', bron: 'gespen staan in alle vijf de activiteitenboeken' },
        { id: 'vormen', zin: 'De vormen ontdekt', bron: 'vormen staan in alle vijf de activiteitenboeken' },
        { id: 'nieuw', zin: 'Iets nieuws ontdekt', bron: 'algemeen, geen productclaim' },
        { id: 'spelen', zin: 'Fijn gespeeld met het activiteitenboek', bron: 'algemeen, geen productclaim' }
      ]
    },
    {
      id: 'rekenwonder',
      naam: 'Rekenwonder',
      uitleg: 'Houten cijfers, telstokjes en rekenkaarten',
      kleur: 'koraal',
      prestaties: [
        { id: 'sommen', zin: 'Geoefend met sommen maken', bron: 'houten cijfers en rekenkaarten met opgaven' },
        { id: 'telstokjes', zin: 'De telstokjes ontdekt', bron: 'telstokjes' },
        { id: 'rekenkaart', zin: 'Een nieuwe rekenkaart ontdekt', bron: 'rekenkaarten met opgaven' },
        { id: 'cijfers', zin: 'Gespeeld met de houten cijfers', bron: 'houten cijfers' }
      ]
    },
    {
      id: 'spellingwonder',
      naam: 'Spellingwonder',
      uitleg: 'Houten letters en woordkaarten',
      kleur: 'lila',
      prestaties: [
        { id: 'woorden', zin: 'Geoefend met woorden leggen', bron: '"zoek de houten letters en leg het woord"' },
        { id: 'letters', zin: 'Geoefend met letters herkennen', bron: '52 houten letters (de activiteit zelf is een algemene omschrijving, geen productclaim)' },
        { id: 'woordkaart', zin: 'Een nieuwe woordkaart ontdekt', bron: '114 woordkaarten' },
        { id: 'spelen', zin: 'Gespeeld met de houten letters', bron: '52 houten letters' }
      ]
    },
    {
      id: 'tekenwonder',
      naam: 'Tekenwonder',
      uitleg: 'Tekenkaarten, stap voor stap',
      kleur: 'geel',
      prestaties: [
        { id: 'stappen', zin: 'Stap voor stap een tekening gemaakt', bron: '"laat stap voor stap zien hoe je iets tekent"' },
        { id: 'tekenkaart', zin: 'Een nieuwe tekenkaart ontdekt', bron: '30 herbruikbare tekenkaarten' },
        { id: 'plezier', zin: 'Met plezier getekend', bron: 'algemeen, geen productclaim' },
        { id: 'stiften', zin: 'Getekend met de uitwisbare stiften', bron: '4 uitwisbare stiften' }
      ]
    },
    {
      id: 'vermenigvuldigwonder',
      naam: 'Vermenigvuldigwonder',
      kaartnaam: 'Vermenigvuldig­wonder',
      uitleg: 'Tafelbord met houten blokjes',
      kleur: 'groen',
      prestaties: [
        { id: 'tafel', zin: 'Geoefend met de tafel van {tafel}', metTafel: true, bron: '"om tafels te oefenen"' },
        { id: 'blokjes', zin: 'De blokjes op het tafelbord ontdekt', bron: 'houten tafelbord met 100 blokjes' },
        { id: 'keersom', zin: 'Een keersom gemaakt', bron: '"waarop een kind keersommen letterlijk opbouwt"' },
        { id: 'dobbelstenen', zin: 'Gespeeld met de dobbelstenen en pionnen', bron: '2 dobbelstenen en 4 pionnen' }
      ]
    }
  ];

  // Vijf kinderthema's (R127d). De panda is de vaste mascotte van de app en geen thema.
  // Elke uitleg noemt alleen wat er op het diploma te zien is.
  var themas = [
    { id: 'zeemeermin', naam: 'Zeemeermin', uitleg: 'Zeemeermin, schelpen, zeesterren en bubbels', kleur: 'zee' },
    { id: 'dinosaurus', naam: 'Dinosaurus', uitleg: 'Dinosaurus, blaadjes, ei en pootafdrukken', kleur: 'mos' },
    { id: 'dieren', naam: 'Dieren & natuur', uitleg: 'Konijntje, vogeltje en bloemen', kleur: 'groen' },
    { id: 'prinses', naam: 'Prinses', uitleg: 'Ronde bloemen, kroontje en een kleine prinses', kleur: 'roze' },
    { id: 'voertuigen', naam: 'Voertuigen', uitleg: 'Raceauto, trein, wegen en een bruggetje', kleur: 'blauw' },
    { id: 'ruimte', naam: 'Ruimte', uitleg: 'Raket, planeten, sterren en een satelliet', kleur: 'lila' }
  ];
  var standaardThema = 'dieren';

  var verboden = ['slim', 'meester', 'geleerd', 'beheerst', 'kent ', 'knap in', 'klaar voor', 'groep', 'montessori', 'ontwikkeling', 'motoriek', 'concentratie', 'therapie', 'officieel', 'erkend', 'tafeldiploma'];

  function zoekSpel(id) {
    for (var i = 0; i < spellen.length; i++) { if (spellen[i].id === id) { return spellen[i]; } }
    return null;
  }

  function zoekPrestatie(spelId, prestatieId) {
    var spel = zoekSpel(spelId);
    if (!spel) { return null; }
    for (var i = 0; i < spel.prestaties.length; i++) { if (spel.prestaties[i].id === prestatieId) { return spel.prestaties[i]; } }
    return null;
  }

  window.IKInhoud = Object.freeze({
    spellen: spellen,
    themas: themas,
    standaardThema: standaardThema,
    verboden: verboden,
    zoekSpel: zoekSpel,
    zoekPrestatie: zoekPrestatie
  });
}());


/* ---- pdf.js ---- */
/*
 * Intellikids diploma-maker (besloten testversie, R127; pdf met echte tekst in R128)
 * Minimale pdf-maker zonder externe bibliotheek.
 *  - maakPdf: één A4-pagina met één JPEG-afbeelding (de overige thema's). De naam komt daar alleen als pixels
 *    in de afbeelding, niet in de pdf-tekst of metadata.
 *  - maakPdfMetTekst: één A4-pagina met ingesloten TrueType-lettertypes (Prinsessendiploma, R128).
 */
(function () {
  'use strict';

  var A4_BREEDTE = '595.28';
  var A4_HOOGTE = '841.89';

  function maakPdf(jpeg, pxBreedte, pxHoogte) {
    var enc = new TextEncoder();
    var delen = [];
    var lengte = 0;
    var posities = [];

    function voeg(d) {
      var b = typeof d === 'string' ? enc.encode(d) : d;
      delen.push(b);
      lengte += b.length;
    }
    function object(n, inhoud) {
      posities[n] = lengte;
      voeg(n + ' 0 obj\n' + inhoud + '\nendobj\n');
    }

    voeg('%PDF-1.4\n%âãÏÓ\n');
    object(1, '<< /Type /Catalog /Pages 2 0 R >>');
    object(2, '<< /Type /Pages /Kids [3 0 R] /Count 1 >>');
    object(3, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + A4_BREEDTE + ' ' + A4_HOOGTE + '] ' +
      '/Resources << /XObject << /Im0 4 0 R >> /ProcSet [/PDF /ImageC] >> /Contents 5 0 R >>');

    posities[4] = lengte;
    voeg('4 0 obj\n<< /Type /XObject /Subtype /Image /Width ' + pxBreedte + ' /Height ' + pxHoogte +
      ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpeg.length + ' >>\nstream\n');
    voeg(jpeg);
    voeg('\nendstream\nendobj\n');

    var tekenen = 'q ' + A4_BREEDTE + ' 0 0 ' + A4_HOOGTE + ' 0 0 cm /Im0 Do Q';
    object(5, '<< /Length ' + enc.encode(tekenen).length + ' >>\nstream\n' + tekenen + '\nendstream');
    object(6, '<< /Title (Diploma Intellikids) /Producer (Intellikids diploma-maker testversie) >>');

    var xref = lengte;
    var tabel = 'xref\n0 7\n0000000000 65535 f \n';
    for (var i = 1; i <= 6; i++) { tabel += String(posities[i]).padStart(10, '0') + ' 00000 n \n'; }
    voeg(tabel);
    voeg('trailer\n<< /Size 7 /Root 1 0 R /Info 6 0 R >>\nstartxref\n' + xref + '\n%%EOF\n');

    return new Blob(delen, { type: 'application/pdf' });
  }

  /* ---------- pdf met echte tekst (R128, Prinsessendiploma) ---------- */
  // Eén A4-pagina met ingesloten TrueType-lettertypes (Identity-H, met ToUnicode, dus selecteerbaar en doorzoekbaar),
  // een JPEG-decoratielaag en het logo met doorzichtigheid. De naam van het kind staat hier dus wel als tekst in het
  // bestand zelf (nodig voor scherpe, selecteerbare tekst), nooit in de bestandsnaam of de metagegevens.

  function bytesVanBase64(b64) {
    var bin = atob(b64);
    var uit = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) { uit[i] = bin.charCodeAt(i); }
    return uit;
  }
  function hex4(v) { return ('0000' + v.toString(16)).slice(-4); }
  function hexUni(cp) {
    if (cp > 0xffff) {
      var c = cp - 0x10000;
      return hex4(0xd800 + (c >> 10)) + hex4(0xdc00 + (c & 0x3ff));
    }
    return hex4(cp);
  }

  // opties: { titel, inhoud, fonts: [{ sleutel, def, gebruikt: { glyph: codepunt } }],
  //           afbeeldingen: [{ sleutel, soort: 'jpeg' | 'rgb', bytes, alfa?, b, h }] }
  function maakPdfMetTekst(o) {
    var enc = new TextEncoder();
    var delen = [];
    var lengte = 0;
    var posities = [];
    var volgend = 6;

    function voeg(d) {
      var b = typeof d === 'string' ? enc.encode(d) : d;
      delen.push(b);
      lengte += b.length;
    }
    function object(nr, inhoud) {
      posities[nr] = lengte;
      voeg(nr + ' 0 obj\n' + inhoud + '\nendobj\n');
    }
    function stroom(nr, woordenboek, bytes) {
      posities[nr] = lengte;
      voeg(nr + ' 0 obj\n<< ' + woordenboek + ' /Length ' + bytes.length + ' >>\nstream\n');
      voeg(bytes);
      voeg('\nendstream\nendobj\n');
    }

    var lettertypen = {};
    var xobjecten = {};
    var lettertypeObjecten = [];
    var afbeeldingObjecten = [];

    o.fonts.forEach(function (f) {
      lettertypen[f.sleutel] = volgend;
      lettertypeObjecten.push({ nr: volgend, f: f });
      volgend += 5;
    });
    o.afbeeldingen.forEach(function (im) {
      xobjecten[im.sleutel] = volgend;
      afbeeldingObjecten.push({ nr: volgend, im: im });
      volgend += im.alfa ? 2 : 1;
    });

    voeg('%PDF-1.5\n%âãÏÓ\n');
    object(1, '<< /Type /Catalog /Pages 2 0 R /Lang (nl-NL) >>');
    object(2, '<< /Type /Pages /Kids [3 0 R] /Count 1 >>');
    var fontRes = Object.keys(lettertypen).map(function (k) { return '/' + k + ' ' + lettertypen[k] + ' 0 R'; }).join(' ');
    var imRes = Object.keys(xobjecten).map(function (k) { return '/' + k + ' ' + xobjecten[k] + ' 0 R'; }).join(' ');
    object(3, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + A4_BREEDTE + ' ' + A4_HOOGTE + '] ' +
      '/Resources << /Font << ' + fontRes + ' >> /XObject << ' + imRes + ' >> /ProcSet [/PDF /Text /ImageC] >> /Contents 4 0 R >>');
    stroom(4, '', enc.encode(o.inhoud));
    object(5, '<< /Title (' + o.titel + ') /Producer (Intellikids diploma-maker testversie) >>');

    lettertypeObjecten.forEach(function (lo) {
      var a = lo.nr;
      var d = lo.f.def;
      var gids = Object.keys(lo.f.gebruikt).map(Number).sort(function (x, y) { return x - y; });
      var w = gids.map(function (g) { return g + ' [' + (d.breedte[g] || 0) + ']'; }).join(' ');
      object(a, '<< /Type /Font /Subtype /Type0 /BaseFont /' + d.ps + ' /Encoding /Identity-H /DescendantFonts [' + (a + 1) + ' 0 R] /ToUnicode ' + (a + 4) + ' 0 R >>');
      object(a + 1, '<< /Type /Font /Subtype /CIDFontType2 /BaseFont /' + d.ps + ' /CIDSystemInfo << /Registry (Adobe) /Ordering (Identity) /Supplement 0 >> ' +
        '/FontDescriptor ' + (a + 2) + ' 0 R /CIDToGIDMap /Identity /DW 0 /W [' + w + '] >>');
      object(a + 2, '<< /Type /FontDescriptor /FontName /' + d.ps + ' /Flags ' + d.flags + ' /FontBBox [' + d.bbox.join(' ') + '] /ItalicAngle ' + d.italic +
        ' /Ascent ' + d.asc + ' /Descent ' + d.desc + ' /CapHeight ' + d.cap + ' /StemV ' + d.stemV + ' /FontFile2 ' + (a + 3) + ' 0 R >>');
      stroom(a + 3, '/Filter /FlateDecode /Length1 ' + d.len1, bytesVanBase64(d.flate));
      var regels = gids.map(function (g) { return '<' + hex4(g) + '> <' + hexUni(lo.f.gebruikt[g]) + '>'; });
      var blokken = [];
      for (var i = 0; i < regels.length; i += 100) {
        var deel = regels.slice(i, i + 100);
        blokken.push(deel.length + ' beginbfchar\n' + deel.join('\n') + '\nendbfchar');
      }
      var cmap = '/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n' +
        '/CIDSystemInfo << /Registry (Adobe) /Ordering (UCS) /Supplement 0 >> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n' +
        '1 begincodespacerange\n<0000> <FFFF>\nendcodespacerange\n' + blokken.join('\n') + '\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend';
      stroom(a + 4, '', enc.encode(cmap));
    });

    afbeeldingObjecten.forEach(function (ao) {
      var im = ao.im;
      var basis = '/Type /XObject /Subtype /Image /Width ' + im.b + ' /Height ' + im.h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8';
      if (im.soort === 'jpeg') { stroom(ao.nr, basis + ' /Filter /DCTDecode', im.bytes); return; }
      stroom(ao.nr, basis + ' /Filter /FlateDecode' + (im.alfa ? ' /SMask ' + (ao.nr + 1) + ' 0 R' : ''), im.bytes);
      if (im.alfa) {
        stroom(ao.nr + 1, '/Type /XObject /Subtype /Image /Width ' + im.b + ' /Height ' + im.h + ' /ColorSpace /DeviceGray /BitsPerComponent 8 /Filter /FlateDecode', im.alfa);
      }
    });

    var xref = lengte;
    var tabel = 'xref\n0 ' + volgend + '\n0000000000 65535 f \n';
    for (var n = 1; n < volgend; n++) { tabel += String(posities[n]).padStart(10, '0') + ' 00000 n \n'; }
    voeg(tabel);
    voeg('trailer\n<< /Size ' + volgend + ' /Root 1 0 R /Info 5 0 R >>\nstartxref\n' + xref + '\n%%EOF\n');
    return new Blob(delen, { type: 'application/pdf' });
  }

  window.IKPdf = Object.freeze({ maakPdf: maakPdf, maakPdfMetTekst: maakPdfMetTekst });
}());


/* ---- prinses.js ---- */
/*
 * Intellikids diploma-maker (besloten testversie, R130): het Prinsessendiploma v5.
 *
 * Eén indeling (maakLayout) voor scherm, afbeelding, print en pdf. De indeling is een lijst eenvoudige
 * tekenopdrachten in een raster van 1050 x 1485 eenheden (A4 staand, 1 eenheid = 0,2 mm). Daaruit komen:
 *  - maakSvg(): inline SVG met echte <text>-lagen voor de voorbeelden en het directe printen;
 *  - tekenCanvas(): canvas voor de png-download en de kleine themakaart (raster is daar toegestaan);
 *  - pdfOpdrachten(): de pagina-inhoud van de download-pdf, met echte tekst en ingesloten lettertypes.
 * Letterbreedtes komen uit dezelfde tabellen als de pdf (js/pdf-fonts.js), zonder kerning, zodat alle uitvoer op
 * dezelfde plek afbreekt en centreert.
 *
 * Beeldmateriaal: alleen de decoratielaag (assets/prinses-decoratie.png: ronde bloemen, roze rand, prinses met
 * kasteel) en het originele logo (assets/logo-officieel.png). Kroontje, naamvlak, sterretjes en felicitatielint
 * zijn losse vormen (type 'v'); alle teksten zijn echte tekst.
 *
 * Velden: childName, gameName, achievement, date, presentedBy. Geen voorbeeldgegevens; een leeg veld geeft
 * witruimte (en de neutrale lijn onder datum en afzender). Niets wordt stilzwijgend afgekapt: past iets niet,
 * dan staat het in "meldingen" en toont de maker een duidelijke melding.
 */
(function () {
  'use strict';

  var B = 1050;
  var H = 1485;
  var PT = 595.2756 / B; // eenheid -> pdf-punt
  var CX = 525; // midden van de pagina: de tekstzone staat gecentreerd
  var CX_ONDER = 365; // midden van de datum- en afzenderzone, links van de prinses

  var BEELD = { decoratie: 'assets/prinses-decoratie.png', logo: 'assets/logo-officieel.png' };

  var KLEUR = {
    tekst: '#243e53',
    titel: '#ae527c',
    spel: '#855d99',
    goed: '#a64d76',
    label: '#617080',
    onderLijn: '#a5afb7',
    goud: '#e7bc64',
    naamVlak: '#eee5f8',
    wit: '#ffffff',
    ster: '#e5ba61',
    lintStaart: '#eab4ca',
    lintVlak: '#f8e2eb',
    kroonVul: '#f6d479',
    kroonRand: '#d9ab4f',
    kroonSteen: '#d695b4',
    kroonGlans: '#fff5c5',
    papier: '#FEFBF4'
  };

  var FONT = {
    kop: { canvas: '"IK Nunito", "Nunito", ui-rounded, "Segoe UI", system-ui, sans-serif', gewicht: '800' },
    tekst: { canvas: '"IK Nunito Sans", "Nunito Sans", "Segoe UI", system-ui, sans-serif', gewicht: '400' }
  };

  // Decoratielaag: afmetingen en de plek van de "inkt" (alles wat geen papierkleur is), gemeten in R130.
  var DECOR = { b: 1054, h: 1492, inkt: { x0: 18, x1: 1036, y0: 17, y1: 1452 } };
  var VEILIG_MM = 5.4;
  var LOGO = { x: 407, y: 91, b: 236, h: 53 };

  // Zones en grenzen (eenheden)
  var NAAM_ZONE = 560; // tekstbreedte binnen het naamvlak
  var NAAMVLAK_BREEDTE = 650; // standaardbreedte van het naamvlak; groeit mee tot NAAMVLAK_MAX
  var NAAMVLAK_MAX = 700; // daarbuiten raakt het vlak de bloemen links
  var NAAMVLAK_BOVEN = 474;
  var NAAMVLAK_HOOGTE = 188;
  var MIDDEN_ZONE = 640;
  var NAAM_MAX = 20;
  var AFZENDER_MAX = 30;
  var ONDER_ZONE = 340;
  var LINT_MAX_BOVEN = 872; // het lint schuift hooguit tot hier mee; lager raakt het de prinses

  function tabel(sleutel) {
    var t = window.IKPdfFonts && window.IKPdfFonts[sleutel];
    if (!t) { throw new Error('lettertypegegevens ontbreken: ' + sleutel); }
    return t;
  }

  /* ---------- meten (uit dezelfde tabellen als de pdf) ---------- */

  function breedte(tekst, sleutel, px) {
    var t = tabel(sleutel);
    var som = 0;
    Array.from(tekst).forEach(function (ch) {
      var g = t.cmap[ch.codePointAt(0)];
      if (g === undefined) { g = t.cmap[32]; }
      som += (t.breedte[g] || 0) / 1000 * px;
    });
    return som;
  }

  // Tekens die niet in de ingesloten lettertypen zitten (de pdf kan ze dan niet tonen).
  function onbekendeTekens(tekst) {
    var uit = [];
    var kop = tabel('kop');
    var tekstT = tabel('tekst');
    Array.from(String(tekst || '')).forEach(function (ch) {
      var c = ch.codePointAt(0);
      if (kop.cmap[c] === undefined || tekstT.cmap[c] === undefined) { if (uit.indexOf(ch) === -1) { uit.push(ch); } }
    });
    return uit;
  }

  /* ---------- tekst passen ---------- */

  function pasEnkel(tekst, sleutel, start, minimum, maxBreedte) {
    var px = start;
    while (px > minimum && breedte(tekst, sleutel, px) > maxBreedte) { px -= 0.5; }
    var w = breedte(tekst, sleutel, px);
    return { px: px, breedte: w, past: w <= maxBreedte + 0.01 };
  }

  function breekRegels(tekst, sleutel, px, maxBreedte) {
    var woorden = tekst.split(' ');
    var regels = [];
    var regel = '';
    woorden.forEach(function (w) {
      var proef = regel ? regel + ' ' + w : w;
      if (!regel || breedte(proef, sleutel, px) <= maxBreedte) { regel = proef; } else { regels.push(regel); regel = w; }
    });
    if (regel) { regels.push(regel); }
    return regels;
  }

  // Beste breekpunt in twee regels (op een spatie of na een koppelteken): kortste langste regel.
  function besteTweeRegels(tekst, sleutel, px) {
    var beste = null;
    var besteB = Infinity;
    for (var i = 1; i < tekst.length; i++) {
      var k = null;
      if (tekst.charAt(i) === ' ') { k = [tekst.slice(0, i).trim(), tekst.slice(i + 1).trim()]; }
      else if (tekst.charAt(i - 1) === '-') { k = [tekst.slice(0, i), tekst.slice(i)]; }
      if (!k || !k[0] || !k[1]) { continue; }
      var m = Math.max(breedte(k[0], sleutel, px), breedte(k[1], sleutel, px));
      if (m < besteB) { besteB = m; beste = k; }
    }
    return beste;
  }

  /* ---------- afgeleide prestatietekst ---------- */

  // "heeft geoefend met de gespen" -> "Geoefend met de gespen": leest als regel onder de spelnaam,
  // met dezelfde woorden als de goedgekeurde zin.
  function prestatieTekst(zin) {
    var t = String(zin || '').trim().replace(/^heeft\s+/i, '');
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : '';
  }

  /* ---------- plek van de decoratielaag ---------- */

  // Schaalt de decoratielaag als geheel om het midden van de pagina, precies genoeg om minstens VEILIG_MM
  // van elke papierrand te blijven (bloemen en lint lopen dicht tegen de rand). Niets wordt afgesneden en de
  // omlijsting blijft symmetrisch.
  function decoratiePlaats() {
    var sx = B / DECOR.b;
    var sy = H / DECOR.h;
    var veilig = VEILIG_MM * 5;
    var x0 = DECOR.inkt.x0 * sx;
    var x1 = (DECOR.inkt.x1 + 1) * sx;
    var y0 = DECOR.inkt.y0 * sy;
    var y1 = (DECOR.inkt.y1 + 1) * sy;
    var s = Math.min(
      1,
      (B / 2 - veilig) / (B / 2 - x0),
      (B / 2 - veilig) / (x1 - B / 2),
      (H / 2 - veilig) / (H / 2 - y0),
      (H / 2 - veilig) / (y1 - H / 2)
    );
    return { s: s, x: B / 2 * (1 - s), y: H / 2 * (1 - s), b: B * s, h: H * s };
  }

  /* ---------- vormen ---------- */

  function tekstOp(t, cx, y, font, px, kleur, veld) {
    return { k: 't', t: t, cx: cx, y: y, font: font, px: px, kleur: kleur, b: breedte(t, font, px), veld: veld || '' };
  }

  // Gevulde (en/of omlijnde) vorm uit absolute opdrachten: ['M',x,y] ['L',x,y] ['C',x1,y1,x2,y2,x,y] ['Z']
  function vorm(cmds, vul, lijn, dikte) {
    return { k: 'v', cmds: cmds, vul: vul || null, lijn: lijn || null, dikte: dikte || 0 };
  }

  function veelhoek(punten) {
    var c = punten.map(function (p, i) { return [i === 0 ? 'M' : 'L', p[0], p[1]]; });
    c.push(['Z']);
    return c;
  }

  function ronderechthoek(x, y, w, h, r) {
    var k = 0.5523 * r;
    return [
      ['M', x + r, y], ['L', x + w - r, y],
      ['C', x + w - r + k, y, x + w, y + r - k, x + w, y + r], ['L', x + w, y + h - r],
      ['C', x + w, y + h - r + k, x + w - r + k, y + h, x + w - r, y + h], ['L', x + r, y + h],
      ['C', x + r - k, y + h, x, y + h - r + k, x, y + h - r], ['L', x, y + r],
      ['C', x, y + r - k, x + r - k, y, x + r, y], ['Z']
    ];
  }

  // Sterretje met vier punten rond (cx, cy); s = halve grootte
  function ster(cx, cy, s) {
    var a = s * 0.27;
    return veelhoek([[cx, cy - s], [cx + a, cy - a], [cx + s, cy], [cx + a, cy + a], [cx, cy + s], [cx - a, cy + a], [cx - s, cy], [cx - a, cy - a]]);
  }

  // Kroontje: 64 x 45 eenheden, 5 graden gedraaid, linksboven op (493, 215)
  function kroonPunt(x, y) {
    var h = -5 * Math.PI / 180;
    var dx = x - 32;
    var dy = y - 20;
    return [493 + 32 + dx * Math.cos(h) - dy * Math.sin(h), 215 + 20 + dx * Math.sin(h) + dy * Math.cos(h)];
  }

  function kroonOps() {
    var p = [[3, 11], [18, 23], [32, 2], [46, 23], [61, 11], [54, 43], [10, 43]].map(function (q) { return kroonPunt(q[0], q[1]); });
    var steen = kroonPunt(32, 29);
    var a = kroonPunt(14, 36);
    var b = kroonPunt(51, 36);
    return [
      { k: 'v', cmds: veelhoek(p), vul: KLEUR.kroonVul, lijn: KLEUR.kroonRand, dikte: 2.5 },
      { k: 'stip', x: steen[0], y: steen[1], r: 4, kleur: KLEUR.kroonSteen },
      { k: 'l', x1: a[0], y1: a[1], x2: b[0], y2: b[1], kleur: KLEUR.kroonGlans, dikte: 3, rond: true }
    ];
  }

  // Zacht lila naamvlak: de ontwerpvorm, in breedte en hoogte meegerekt met de naam
  var VLAK = [
    ['M', 234, 505], ['C', 283, 474, 398, 491, 514, 484], ['C', 648, 478, 783, 481, 818, 522],
    ['C', 852, 561, 821, 635, 760, 650], ['C', 682, 672, 609, 653, 522, 661], ['C', 405, 672, 285, 662, 244, 635],
    ['C', 205, 610, 201, 537, 234, 505], ['Z']
  ];

  function naamvlakOps(sx, hoogte) {
    var sy = hoogte / NAAMVLAK_HOOGTE;
    var yc = NAAMVLAK_BOVEN + hoogte / 2;
    function m(x, y) { return [CX + (x - CX) * sx, yc + (y - 568) * sy]; }
    var cmds = VLAK.map(function (c) {
      if (c[0] === 'Z') { return ['Z']; }
      var uit = [c[0]];
      for (var i = 1; i < c.length; i += 2) { var q = m(c[i], c[i + 1]); uit.push(q[0], q[1]); }
      return uit;
    });
    var l1 = m(255, 535); var l2 = m(267, 514); var l3 = m(297, 516);
    var r1 = m(753, 624); var r2 = m(777, 624); var r3 = m(787, 605);
    var sterL = m(205, 547);
    var sterR = m(843, 625);
    return [
      vorm(cmds, KLEUR.naamVlak),
      { k: 'q', x1: l1[0], y1: l1[1], cx: l2[0], cy: l2[1], x2: l3[0], y2: l3[1], kleur: KLEUR.wit, dikte: 4, rond: true },
      { k: 'q', x1: r1[0], y1: r1[1], cx: r2[0], cy: r2[1], x2: r3[0], y2: r3[1], kleur: KLEUR.wit, dikte: 4, rond: true },
      vorm(ster(sterL[0], sterL[1], 19), KLEUR.ster),
      vorm(ster(sterR[0], sterR[1], 15), KLEUR.ster)
    ];
  }

  // Roze lint met "Goed gedaan!": rechthoek 406 x 85 met twee staarten, bovenkant op `top`
  function lintOps(top) {
    var links = [[299, -9], [337, 4], [337, 80], [299, 93], [312, 43]].map(function (p) { return [p[0], top + p[1]]; });
    var rechts = [[751, -9], [713, 4], [713, 80], [751, 93], [738, 43]].map(function (p) { return [p[0], top + p[1]]; });
    return [
      vorm(veelhoek(links), KLEUR.lintStaart),
      vorm(veelhoek(rechts), KLEUR.lintStaart),
      vorm(ronderechthoek(322, top, 406, 85, 19), KLEUR.lintVlak)
    ];
  }

  /* ---------- de indeling ---------- */

  function maakLayout(g) {
    g = g || {};
    var ops = [];
    var meldingen = [];
    var naam = String(g.childName || '').trim();
    var spel = String(g.gameName || '').trim();
    var prestatie = String(g.achievement || '').trim();
    var datum = String(g.date || '').trim();
    var afzender = String(g.presentedBy || '').trim();
    var capKop = tabel('kop').cap / 1000;

    // kroontje, titel en begeleidende regel
    kroonOps().forEach(function (o) { ops.push(o); });
    ops.push(tekstOp('Prinsessendiploma', CX, 339, 'kop', 60, KLEUR.titel));
    ops.push({ k: 'q', x1: 422, y1: 370, cx: 525, cy: 387, x2: 628, y2: 370, kleur: KLEUR.goud, dikte: 3, rond: true });
    ops.push(tekstOp('Dit diploma is voor', CX, 445, 'tekst', 24, KLEUR.tekst));

    // naam op het lila vlak: een regel op 85 eenheden (kleiner tot 50); past dat niet, twee regels (tot 38);
    // anders meetbaar kleiner (tot 24). Het vlak groeit mee in breedte (tot NAAMVLAK_MAX) en hoogte.
    var naamRegels = [];
    var naamPx = 85;
    if (naam) {
      var enkel = pasEnkel(naam, 'kop', 85, 50, NAAM_ZONE);
      if (enkel.past) { naamRegels = [naam]; naamPx = enkel.px; }
      else {
        var twee = besteTweeRegels(naam, 'kop', 56);
        if (twee) {
          naamPx = Math.min(pasEnkel(twee[0], 'kop', 70, 38, NAAM_ZONE).px, pasEnkel(twee[1], 'kop', 70, 38, NAAM_ZONE).px);
          naamRegels = twee;
          twee.forEach(function (r) { if (breedte(r, 'kop', naamPx) > NAAM_ZONE + 0.5) { meldingen.push({ veld: 'childName', tekst: 'De naam is te breed voor het diploma.' }); } });
        } else {
          var klein = pasEnkel(naam, 'kop', 85, 24, NAAM_ZONE);
          naamRegels = [naam]; naamPx = klein.px;
          if (!klein.past) { meldingen.push({ veld: 'childName', tekst: 'De naam is te breed voor het diploma.' }); }
        }
      }
    }
    var naamB = 0;
    naamRegels.forEach(function (r) { naamB = Math.max(naamB, breedte(r, 'kop', naamPx)); });
    var naamLh = naamPx * 1.12;
    var blok = naamRegels.length ? capKop * naamPx + (naamRegels.length - 1) * naamLh : 0;
    var vlakH = Math.max(NAAMVLAK_HOOGTE, blok + 90);
    var vlakSx = Math.min(NAAMVLAK_MAX / NAAMVLAK_BREEDTE, Math.max(1, (naamB + 140) / NAAMVLAK_BREEDTE));
    naamvlakOps(vlakSx, vlakH).forEach(function (o) { ops.push(o); });
    var vlakMidden = NAAMVLAK_BOVEN + vlakH / 2;
    naamRegels.forEach(function (r, i) {
      ops.push(tekstOp(r, CX, vlakMidden - blok / 2 + capKop * naamPx + i * naamLh - 4, 'kop', naamPx, KLEUR.tekst, 'childName'));
    });
    var vlakOnder = NAAMVLAK_BOVEN + vlakH;

    // spelnaam (lila kop) en prestatie; ruime tussenruimtes, bij veel tekst iets krapper zodat het lint
    // niet tegen de prinses komt. Past het dan nog niet: kleiner lettertype tot 22 eenheden.
    var spelRegels = [];
    var spelPx = 28;
    if (spel) {
      var sp = pasEnkel(spel, 'kop', 28, 20, MIDDEN_ZONE);
      if (sp.past) { spelRegels = [spel]; spelPx = sp.px; }
      else {
        spelPx = 22;
        spelRegels = breekRegels(spel, 'kop', spelPx, MIDDEN_ZONE);
        if (spelRegels.length > 2) { meldingen.push({ veld: 'gameName', tekst: 'De naam van het spel is te lang voor het diploma.' }); }
        spelRegels.forEach(function (r) { if (breedte(r, 'kop', spelPx) > MIDDEN_ZONE + 0.5) { meldingen.push({ veld: 'gameName', tekst: 'De naam van het spel is te breed voor het diploma.' }); } });
      }
    }
    var spelLh = spelPx * 1.25;
    var prestRegels = [];
    var prestPx = 28;
    var prestLh = 0;
    var spelY = 0;
    var prestY = 0;
    var lintTop = 0;
    var gaps = [[80, 63, 46], [62, 52, 34]];
    var klaar = false;
    if (prestatie) {
      for (prestPx = 28; !klaar; prestPx -= 0.5) {
        prestRegels = breekRegels(prestatie, 'tekst', prestPx, MIDDEN_ZONE);
        prestLh = prestPx * 1.35;
        for (var gi = 0; gi < gaps.length && !klaar; gi++) {
          spelY = vlakOnder + gaps[gi][0];
          prestY = spelY + Math.max(0, spelRegels.length - 1) * spelLh + gaps[gi][1];
          lintTop = prestY + (prestRegels.length - 1) * prestLh + gaps[gi][2];
          if (prestRegels.length <= 4 && lintTop <= LINT_MAX_BOVEN) { klaar = true; }
        }
        if (klaar || prestPx <= 22) { break; }
      }
      if (!klaar) { meldingen.push({ veld: 'achievement', tekst: 'De tekst bij het spel is te lang voor het diploma.' }); }
      prestRegels.forEach(function (r) { if (breedte(r, 'tekst', prestPx) > MIDDEN_ZONE + 0.5) { meldingen.push({ veld: 'achievement', tekst: 'De tekst bij het spel is te breed voor het diploma.' }); } });
    } else {
      // geen prestatie: dezelfde plekken als bij één regel, het lint blijft op zijn plek
      for (var gj = 0; gj < gaps.length && !klaar; gj++) {
        spelY = vlakOnder + gaps[gj][0];
        prestY = spelY + Math.max(0, spelRegels.length - 1) * spelLh + gaps[gj][1];
        lintTop = prestY + gaps[gj][2];
        if (lintTop <= LINT_MAX_BOVEN) { klaar = true; }
      }
    }
    spelRegels.forEach(function (r, i) { ops.push(tekstOp(r, CX, spelY + i * spelLh, 'kop', spelPx, KLEUR.spel, 'gameName')); });
    prestRegels.forEach(function (r, i) { ops.push(tekstOp(r, CX, prestY + i * prestLh, 'tekst', prestPx, KLEUR.tekst, 'achievement')); });

    // roze felicitatielint
    lintOps(lintTop).forEach(function (o) { ops.push(o); });
    ops.push(tekstOp('Goed gedaan!', CX, lintTop + 57, 'kop', 44, KLEUR.goed));

    // datum, links van de prinses, boven een lijn
    var datumHalf = 115;
    if (datum) {
      var dp = pasEnkel(datum, 'tekst', 22, 16, ONDER_ZONE);
      ops.push(tekstOp(datum, CX_ONDER, 1125, 'tekst', dp.px, KLEUR.tekst, 'date'));
      datumHalf = Math.max(115, dp.breedte / 2 + 14);
      if (!dp.past) { meldingen.push({ veld: 'date', tekst: 'De datum is te lang voor het diploma.' }); }
    }
    ops.push({ k: 'l', x1: CX_ONDER - datumHalf, y1: 1145, x2: CX_ONDER + datumHalf, y2: 1145, kleur: KLEUR.onderLijn, dikte: 1.4, rond: false });

    // afzender
    ops.push(tekstOp('Uitgereikt door', CX_ONDER, 1212, 'tekst', 21, KLEUR.label));
    var afzHalf = 115;
    if (afzender) {
      var ap = pasEnkel(afzender, 'tekst', 23, 17, ONDER_ZONE);
      if (ap.past) {
        ops.push(tekstOp(afzender, CX_ONDER, 1250, 'tekst', ap.px, KLEUR.tekst, 'presentedBy'));
        afzHalf = Math.max(115, ap.breedte / 2 + 14);
      } else {
        var apx = 20;
        var ar = breekRegels(afzender, 'tekst', apx, ONDER_ZONE);
        var arB = 0;
        ar.forEach(function (r) { arB = Math.max(arB, breedte(r, 'tekst', apx)); });
        if (ar.length > 2 || arB > ONDER_ZONE + 0.5) { meldingen.push({ veld: 'presentedBy', tekst: 'De naam van de afzender is te lang voor het diploma.' }); }
        ar.forEach(function (r, i) { ops.push(tekstOp(r, CX_ONDER, 1250 - (ar.length - 1 - i) * 24, 'tekst', apx, KLEUR.tekst, 'presentedBy')); });
        afzHalf = Math.max(115, Math.min(arB, ONDER_ZONE) / 2 + 14);
      }
    }
    ops.push({ k: 'l', x1: CX_ONDER - afzHalf, y1: 1270, x2: CX_ONDER + afzHalf, y2: 1270, kleur: KLEUR.onderLijn, dikte: 1.4, rond: false });

    return { ops: ops, meldingen: meldingen, decor: decoratiePlaats(), logo: { x: LOGO.x, y: LOGO.y, b: LOGO.b, h: LOGO.h } };
  }

  /* ---------- inline SVG met echte tekstlagen (voorbeeld en direct printen) ---------- */

  var NS = 'http://www.w3.org/2000/svg';
  var XLINK = 'http://www.w3.org/1999/xlink';

  function el(naam, attrs) {
    var e = document.createElementNS(NS, naam);
    Object.keys(attrs || {}).forEach(function (k) { e.setAttribute(k, String(attrs[k])); });
    return e;
  }

  function f1(v) { return (Math.round(v * 100) / 100).toString(); }

  function padTekst(cmds) {
    return cmds.map(function (c) {
      if (c[0] === 'Z') { return 'Z'; }
      var n = c.slice(1).map(f1).join(' ');
      return c[0] + n;
    }).join('');
  }

  function maakSvg(g) {
    var L = maakLayout(g);
    var svg = el('svg', { viewBox: '0 0 ' + B + ' ' + H, role: 'img', focusable: 'false', preserveAspectRatio: 'xMidYMid meet' });
    svg.setAttribute('xmlns', NS);
    svg.appendChild(el('rect', { x: 0, y: 0, width: B, height: H, fill: KLEUR.papier }));
    var dec = el('image', { x: f1(L.decor.x), y: f1(L.decor.y), width: f1(L.decor.b), height: f1(L.decor.h), preserveAspectRatio: 'none' });
    dec.setAttribute('href', window.IKDMU(BEELD.decoratie));
    dec.setAttributeNS(XLINK, 'xlink:href', window.IKDMU(BEELD.decoratie));
    svg.appendChild(dec);
    var logo = el('image', { x: L.logo.x, y: L.logo.y, width: L.logo.b, height: L.logo.h, preserveAspectRatio: 'xMidYMid meet' });
    logo.setAttribute('href', window.IKDMU(BEELD.logo));
    logo.setAttributeNS(XLINK, 'xlink:href', window.IKDMU(BEELD.logo));
    svg.appendChild(logo);
    L.ops.forEach(function (op) {
      if (op.k === 't') {
        var t = el('text', { x: f1(op.cx), y: f1(op.y), 'text-anchor': 'middle', 'font-size': f1(op.px), fill: op.kleur });
        t.style.fontFamily = FONT[op.font].canvas;
        t.style.fontWeight = FONT[op.font].gewicht;
        t.style.fontKerning = 'none';
        t.style.fontFeatureSettings = '"kern" 0';
        if (op.veld) { t.setAttribute('data-field', op.veld); }
        t.textContent = op.t;
        svg.appendChild(t);
      } else if (op.k === 'l') {
        svg.appendChild(el('path', { d: 'M' + f1(op.x1) + ' ' + f1(op.y1) + 'L' + f1(op.x2) + ' ' + f1(op.y2), stroke: op.kleur, 'stroke-width': op.dikte, fill: 'none', 'stroke-linecap': op.rond ? 'round' : 'butt' }));
      } else if (op.k === 'q') {
        svg.appendChild(el('path', { d: 'M' + f1(op.x1) + ' ' + f1(op.y1) + 'Q' + f1(op.cx) + ' ' + f1(op.cy) + ' ' + f1(op.x2) + ' ' + f1(op.y2), stroke: op.kleur, 'stroke-width': op.dikte, fill: 'none', 'stroke-linecap': op.rond ? 'round' : 'butt' }));
      } else if (op.k === 'stip') {
        svg.appendChild(el('circle', { cx: f1(op.x), cy: f1(op.y), r: op.r, fill: op.kleur }));
      } else if (op.k === 'v') {
        var a = { d: padTekst(op.cmds), fill: op.vul || 'none' };
        if (op.lijn) { a.stroke = op.lijn; a['stroke-width'] = op.dikte; a['stroke-linejoin'] = 'round'; }
        svg.appendChild(el('path', a));
      }
    });
    return svg;
  }

  /* ---------- canvas (alleen voor de png-download en het kleine themastaal) ---------- */

  function fontTekst(f, px) { return FONT[f].gewicht + ' ' + px + 'px ' + FONT[f].canvas; }

  function tekenCanvas(canvas, g, breedtePx, beeld) {
    var L = maakLayout(g);
    var schaal = breedtePx / B;
    canvas.width = Math.round(B * schaal);
    canvas.height = Math.round(H * schaal);
    var ctx = canvas.getContext('2d');
    ctx.setTransform(canvas.width / B, 0, 0, canvas.height / H, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.fillStyle = KLEUR.papier;
    ctx.fillRect(0, 0, B, H);
    if (beeld && beeld.decoratie) { ctx.drawImage(beeld.decoratie, L.decor.x, L.decor.y, L.decor.b, L.decor.h); }
    if (beeld && beeld.logo) { ctx.drawImage(beeld.logo, L.logo.x, L.logo.y, L.logo.b, L.logo.h); }
    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';
    if ('fontKerning' in ctx) { ctx.fontKerning = 'none'; }
    L.ops.forEach(function (op) {
      ctx.save();
      if (op.k === 't') {
        ctx.fillStyle = op.kleur;
        ctx.font = fontTekst(op.font, op.px);
        ctx.fillText(op.t, op.cx - op.b / 2, op.y);
      } else if (op.k === 'l') {
        ctx.beginPath(); ctx.moveTo(op.x1, op.y1); ctx.lineTo(op.x2, op.y2);
        ctx.strokeStyle = op.kleur; ctx.lineWidth = op.dikte; ctx.lineCap = op.rond ? 'round' : 'butt'; ctx.stroke();
      } else if (op.k === 'q') {
        ctx.beginPath(); ctx.moveTo(op.x1, op.y1); ctx.quadraticCurveTo(op.cx, op.cy, op.x2, op.y2);
        ctx.strokeStyle = op.kleur; ctx.lineWidth = op.dikte; ctx.lineCap = op.rond ? 'round' : 'butt'; ctx.stroke();
      } else if (op.k === 'stip') {
        ctx.beginPath(); ctx.arc(op.x, op.y, op.r, 0, Math.PI * 2); ctx.fillStyle = op.kleur; ctx.fill();
      } else if (op.k === 'v') {
        ctx.beginPath();
        op.cmds.forEach(function (c) {
          if (c[0] === 'M') { ctx.moveTo(c[1], c[2]); }
          else if (c[0] === 'L') { ctx.lineTo(c[1], c[2]); }
          else if (c[0] === 'C') { ctx.bezierCurveTo(c[1], c[2], c[3], c[4], c[5], c[6]); }
          else { ctx.closePath(); }
        });
        if (op.vul) { ctx.fillStyle = op.vul; ctx.fill(); }
        if (op.lijn) { ctx.strokeStyle = op.lijn; ctx.lineWidth = op.dikte; ctx.lineJoin = 'round'; ctx.stroke(); }
      }
      ctx.restore();
    });
    return L;
  }

  /* ---------- pdf-inhoud (echte tekst) ---------- */

  function f3(v) { return (Math.round(v * 1000) / 1000).toString(); }
  function rgb(hex) {
    var n = parseInt(hex.slice(1), 16);
    return f3(((n >> 16) & 255) / 255) + ' ' + f3(((n >> 8) & 255) / 255) + ' ' + f3((n & 255) / 255);
  }
  function hex4(v) { return ('0000' + v.toString(16)).slice(-4); }
  var HPT = H * PT;
  function X(x) { return f3(x * PT); }
  function Y(y) { return f3(HPT - y * PT); }

  // Geeft de inhoud van de pagina, de gebruikte glyphs per lettertype en de indeling terug.
  function pdfOpdrachten(g) {
    var L = maakLayout(g);
    var gebruikt = { kop: {}, tekst: {} };
    var s = [];
    s.push(rgb(KLEUR.papier) + ' rg 0 0 ' + f3(B * PT) + ' ' + f3(HPT) + ' re f');
    s.push('q ' + f3(L.decor.b * PT) + ' 0 0 ' + f3(L.decor.h * PT) + ' ' + X(L.decor.x) + ' ' + f3(HPT - (L.decor.y + L.decor.h) * PT) + ' cm /ImDecor Do Q');
    s.push('q ' + f3(L.logo.b * PT) + ' 0 0 ' + f3(L.logo.h * PT) + ' ' + X(L.logo.x) + ' ' + f3(HPT - (L.logo.y + L.logo.h) * PT) + ' cm /ImLogo Do Q');
    L.ops.forEach(function (op) {
      if (op.k === 'l') {
        s.push('q ' + rgb(op.kleur) + ' RG ' + f3(op.dikte * PT) + ' w ' + (op.rond ? '1' : '0') + ' J ' + X(op.x1) + ' ' + Y(op.y1) + ' m ' + X(op.x2) + ' ' + Y(op.y2) + ' l S Q');
      } else if (op.k === 'q') {
        // kwadratische kromme naar een kubische omzetten
        var c1x = op.x1 + 2 / 3 * (op.cx - op.x1);
        var c1y = op.y1 + 2 / 3 * (op.cy - op.y1);
        var c2x = op.x2 + 2 / 3 * (op.cx - op.x2);
        var c2y = op.y2 + 2 / 3 * (op.cy - op.y2);
        s.push('q ' + rgb(op.kleur) + ' RG ' + f3(op.dikte * PT) + ' w ' + (op.rond ? '1' : '0') + ' J ' + X(op.x1) + ' ' + Y(op.y1) + ' m ' +
          X(c1x) + ' ' + Y(c1y) + ' ' + X(c2x) + ' ' + Y(c2y) + ' ' + X(op.x2) + ' ' + Y(op.y2) + ' c S Q');
      } else if (op.k === 'stip') {
        var k = 0.5523 * op.r;
        s.push('q ' + rgb(op.kleur) + ' rg ' + X(op.x + op.r) + ' ' + Y(op.y) + ' m ' +
          X(op.x + op.r) + ' ' + Y(op.y + k) + ' ' + X(op.x + k) + ' ' + Y(op.y + op.r) + ' ' + X(op.x) + ' ' + Y(op.y + op.r) + ' c ' +
          X(op.x - k) + ' ' + Y(op.y + op.r) + ' ' + X(op.x - op.r) + ' ' + Y(op.y + k) + ' ' + X(op.x - op.r) + ' ' + Y(op.y) + ' c ' +
          X(op.x - op.r) + ' ' + Y(op.y - k) + ' ' + X(op.x - k) + ' ' + Y(op.y - op.r) + ' ' + X(op.x) + ' ' + Y(op.y - op.r) + ' c ' +
          X(op.x + k) + ' ' + Y(op.y - op.r) + ' ' + X(op.x + op.r) + ' ' + Y(op.y - k) + ' ' + X(op.x + op.r) + ' ' + Y(op.y) + ' c h f Q');
      } else if (op.k === 'v') {
        var d = ['q'];
        if (op.vul) { d.push(rgb(op.vul) + ' rg'); }
        if (op.lijn) { d.push(rgb(op.lijn) + ' RG ' + f3(op.dikte * PT) + ' w 1 j 1 J'); }
        op.cmds.forEach(function (c) {
          if (c[0] === 'M') { d.push(X(c[1]) + ' ' + Y(c[2]) + ' m'); }
          else if (c[0] === 'L') { d.push(X(c[1]) + ' ' + Y(c[2]) + ' l'); }
          else if (c[0] === 'C') { d.push(X(c[1]) + ' ' + Y(c[2]) + ' ' + X(c[3]) + ' ' + Y(c[4]) + ' ' + X(c[5]) + ' ' + Y(c[6]) + ' c'); }
          else { d.push('h'); }
        });
        d.push(op.vul && op.lijn ? 'B' : (op.vul ? 'f' : 'S'));
        d.push('Q');
        s.push(d.join(' '));
      } else if (op.k === 't') {
        var t = tabel(op.font);
        var hex = '';
        Array.from(op.t).forEach(function (ch) {
          var cp = ch.codePointAt(0);
          var gl = t.cmap[cp];
          if (gl === undefined) { cp = 32; gl = t.cmap[32]; }
          gebruikt[op.font][gl] = cp;
          hex += hex4(gl);
        });
        var sleutel = op.font === 'kop' ? 'FKop' : 'FTekst';
        s.push('BT ' + rgb(op.kleur) + ' rg /' + sleutel + ' ' + f3(op.px * PT) + ' Tf 0 Tc ' + X(op.cx - op.b / 2) + ' ' + Y(op.y) + ' Td <' + hex + '> Tj ET');
      }
    });
    return { inhoud: s.join('\n'), gebruikt: gebruikt, layout: L };
  }

  window.IKPrinses = Object.freeze({
    breedte: B,
    hoogte: H,
    naamMax: NAAM_MAX,
    afzenderMax: AFZENDER_MAX,
    kleur: KLEUR,
    beeld: BEELD,
    maakLayout: maakLayout,
    maakSvg: maakSvg,
    tekenCanvas: tekenCanvas,
    pdfOpdrachten: pdfOpdrachten,
    prestatieTekst: prestatieTekst,
    onbekendeTekens: onbekendeTekens,
    decoratiePlaats: decoratiePlaats,
    meet: breedte
  });
}());


/* ---- zeemeermin.js ---- */
/*
 * Intellikids diploma-maker (besloten testversie, R131): het Zeemeermindiploma v2 (handgetekend).
 *
 * Eén indeling (maakLayout) voor scherm, afbeelding, print en pdf. De indeling is een lijst eenvoudige
 * tekenopdrachten in een raster van 1050 x 1485 eenheden (A4 staand, 1 eenheid = 0,2 mm). Daaruit komen:
 *  - maakSvg(): inline SVG met echte <text>-lagen voor de voorbeelden en het directe printen;
 *  - tekenCanvas(): canvas voor de png-download en de kleine themakaart (raster is daar toegestaan);
 *  - pdfOpdrachten(): de pagina-inhoud van de download-pdf, met echte tekst en ingesloten lettertypes.
 * Letterbreedtes komen uit dezelfde tabellen als de pdf (js/pdf-fonts.js), zonder kerning, zodat alle uitvoer op
 * dezelfde plek afbreekt en centreert.
 *
 * Beeldmateriaal: alleen de decoratielaag (assets/zeemeermin-decoratie.png: turquoise golfrand, schelpen, zeesterren,
 * koraal, bubbels en de handgetekende zeemeermin) en het originele logo (assets/logo-officieel.png). Schelpaccent,
 * naamvlak, sterretjes en felicitatieband zijn losse vormen (type 'v'); alle teksten zijn echte tekst.
 * Afgeleid van js/prinses.js (dat ongewijzigd blijft): zelfde indeling, andere kleuren, zones en vormen.
 *
 * Velden: childName, gameName, achievement, date, presentedBy. Geen voorbeeldgegevens; een leeg veld geeft
 * witruimte (en de neutrale lijn onder datum en afzender). Niets wordt stilzwijgend afgekapt: past iets niet,
 * dan staat het in "meldingen" en toont de maker een duidelijke melding.
 */
(function () {
  'use strict';

  var B = 1050;
  var H = 1485;
  var PT = 595.2756 / B; // eenheid -> pdf-punt
  var CX = 525; // midden van de pagina: de tekstzone staat gecentreerd
  var CX_ONDER = 425; // midden van de datum- en afzenderzone, links van de zeemeermin (en haar bubbels)

  var BEELD = { decoratie: 'assets/zeemeermin-decoratie.png', logo: 'assets/logo-officieel.png' };

  var KLEUR = {
    tekst: '#243e53',
    titel: '#347d89',
    spel: '#6877ac',
    goed: '#347d89',
    label: '#617080',
    onderLijn: '#a5afb7',
    goud: '#e7bc64',
    naamVlak: '#eee5f8',
    wit: '#ffffff',
    ster: '#e5ba61',
    lintStaart: '#9cd9d5',
    lintVlak: '#e0f4f1',
    schelpVul: '#d8c7ef',
    schelpRand: '#9c86bc',
    schelpRib: '#b39acb',
    schelpParel: '#f3d27e',
    papier: '#FEFEFB'
  };

  var FONT = {
    kop: { canvas: '"IK Nunito", "Nunito", ui-rounded, "Segoe UI", system-ui, sans-serif', gewicht: '800' },
    tekst: { canvas: '"IK Nunito Sans", "Nunito Sans", "Segoe UI", system-ui, sans-serif', gewicht: '400' }
  };

  // Decoratielaag: afmetingen en de plek van de "inkt" (alles wat geen papierkleur is), gemeten in R131.
  var DECOR = { b: 1054, h: 1492, inkt: { x0: 21, x1: 1031, y0: 19, y1: 1473 } };
  var VEILIG_MM = 5.4;
  var LOGO = { x: 407, y: 91, b: 236, h: 53 };

  // Zones en grenzen (eenheden)
  var NAAM_ZONE = 560; // tekstbreedte binnen het naamvlak
  var NAAMVLAK_BREEDTE = 650; // standaardbreedte van het naamvlak; groeit mee tot NAAMVLAK_MAX
  var NAAMVLAK_MAX = 700; // daarbuiten raakt het vlak de bloemen links
  var NAAMVLAK_BOVEN = 474;
  var NAAMVLAK_HOOGTE = 188;
  var MIDDEN_ZONE = 620;
  var NAAM_MAX = 20;
  var AFZENDER_MAX = 30;
  var ONDER_ZONE = 250; // de lijnen staan bewust naar rechts, weg van koraal en bubbels links en de rots rechts
  var LINT_MAX_BOVEN = 880; // de band schuift hooguit tot hier mee; lager raakt de rechterstaart de krullen

  function tabel(sleutel) {
    var t = window.IKPdfFonts && window.IKPdfFonts[sleutel];
    if (!t) { throw new Error('lettertypegegevens ontbreken: ' + sleutel); }
    return t;
  }

  /* ---------- meten (uit dezelfde tabellen als de pdf) ---------- */

  function breedte(tekst, sleutel, px) {
    var t = tabel(sleutel);
    var som = 0;
    Array.from(tekst).forEach(function (ch) {
      var g = t.cmap[ch.codePointAt(0)];
      if (g === undefined) { g = t.cmap[32]; }
      som += (t.breedte[g] || 0) / 1000 * px;
    });
    return som;
  }

  // Tekens die niet in de ingesloten lettertypen zitten (de pdf kan ze dan niet tonen).
  function onbekendeTekens(tekst) {
    var uit = [];
    var kop = tabel('kop');
    var tekstT = tabel('tekst');
    Array.from(String(tekst || '')).forEach(function (ch) {
      var c = ch.codePointAt(0);
      if (kop.cmap[c] === undefined || tekstT.cmap[c] === undefined) { if (uit.indexOf(ch) === -1) { uit.push(ch); } }
    });
    return uit;
  }

  /* ---------- tekst passen ---------- */

  function pasEnkel(tekst, sleutel, start, minimum, maxBreedte) {
    var px = start;
    while (px > minimum && breedte(tekst, sleutel, px) > maxBreedte) { px -= 0.5; }
    var w = breedte(tekst, sleutel, px);
    return { px: px, breedte: w, past: w <= maxBreedte + 0.01 };
  }

  function breekRegels(tekst, sleutel, px, maxBreedte) {
    var woorden = tekst.split(' ');
    var regels = [];
    var regel = '';
    woorden.forEach(function (w) {
      var proef = regel ? regel + ' ' + w : w;
      if (!regel || breedte(proef, sleutel, px) <= maxBreedte) { regel = proef; } else { regels.push(regel); regel = w; }
    });
    if (regel) { regels.push(regel); }
    return regels;
  }

  // Beste breekpunt in twee regels (op een spatie of na een koppelteken): kortste langste regel.
  function besteTweeRegels(tekst, sleutel, px) {
    var beste = null;
    var besteB = Infinity;
    for (var i = 1; i < tekst.length; i++) {
      var k = null;
      if (tekst.charAt(i) === ' ') { k = [tekst.slice(0, i).trim(), tekst.slice(i + 1).trim()]; }
      else if (tekst.charAt(i - 1) === '-') { k = [tekst.slice(0, i), tekst.slice(i)]; }
      if (!k || !k[0] || !k[1]) { continue; }
      var m = Math.max(breedte(k[0], sleutel, px), breedte(k[1], sleutel, px));
      if (m < besteB) { besteB = m; beste = k; }
    }
    return beste;
  }

  /* ---------- afgeleide prestatietekst ---------- */

  // "heeft geoefend met de gespen" -> "Geoefend met de gespen": leest als regel onder de spelnaam,
  // met dezelfde woorden als de goedgekeurde zin.
  function prestatieTekst(zin) {
    var t = String(zin || '').trim().replace(/^heeft\s+/i, '');
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : '';
  }

  /* ---------- plek van de decoratielaag ---------- */

  // Schaalt de decoratielaag als geheel om het midden van de pagina, precies genoeg om minstens VEILIG_MM
  // van elke papierrand te blijven (bloemen en lint lopen dicht tegen de rand). Niets wordt afgesneden en de
  // omlijsting blijft symmetrisch.
  function decoratiePlaats() {
    var sx = B / DECOR.b;
    var sy = H / DECOR.h;
    var veilig = VEILIG_MM * 5;
    var x0 = DECOR.inkt.x0 * sx;
    var x1 = (DECOR.inkt.x1 + 1) * sx;
    var y0 = DECOR.inkt.y0 * sy;
    var y1 = (DECOR.inkt.y1 + 1) * sy;
    var s = Math.min(
      1,
      (B / 2 - veilig) / (B / 2 - x0),
      (B / 2 - veilig) / (x1 - B / 2),
      (H / 2 - veilig) / (H / 2 - y0),
      (H / 2 - veilig) / (y1 - H / 2)
    );
    return { s: s, x: B / 2 * (1 - s), y: H / 2 * (1 - s), b: B * s, h: H * s };
  }

  /* ---------- vormen ---------- */

  function tekstOp(t, cx, y, font, px, kleur, veld) {
    return { k: 't', t: t, cx: cx, y: y, font: font, px: px, kleur: kleur, b: breedte(t, font, px), veld: veld || '' };
  }

  // Gevulde (en/of omlijnde) vorm uit absolute opdrachten: ['M',x,y] ['L',x,y] ['C',x1,y1,x2,y2,x,y] ['Z']
  function vorm(cmds, vul, lijn, dikte) {
    return { k: 'v', cmds: cmds, vul: vul || null, lijn: lijn || null, dikte: dikte || 0 };
  }

  function veelhoek(punten) {
    var c = punten.map(function (p, i) { return [i === 0 ? 'M' : 'L', p[0], p[1]]; });
    c.push(['Z']);
    return c;
  }

  function ronderechthoek(x, y, w, h, r) {
    var k = 0.5523 * r;
    return [
      ['M', x + r, y], ['L', x + w - r, y],
      ['C', x + w - r + k, y, x + w, y + r - k, x + w, y + r], ['L', x + w, y + h - r],
      ['C', x + w, y + h - r + k, x + w - r + k, y + h, x + w - r, y + h], ['L', x + r, y + h],
      ['C', x + r - k, y + h, x, y + h - r + k, x, y + h - r], ['L', x, y + r],
      ['C', x, y + r - k, x + r - k, y, x + r, y], ['Z']
    ];
  }

  // Sterretje met vier punten rond (cx, cy); s = halve grootte
  function ster(cx, cy, s) {
    var a = s * 0.27;
    return veelhoek([[cx, cy - s], [cx + a, cy - a], [cx + s, cy], [cx + a, cy + a], [cx, cy + s], [cx - a, cy + a], [cx - s, cy], [cx - a, cy - a]]);
  }

  // Schelpaccent boven de titel: linksboven op (493, 215), met drie ribben en een parel
  function schelpOps() {
    function p(x, y) { return [493 + x, 215 + y]; }
    function c(a, b, c2, d, e, f) { var u = p(a, b); var v = p(c2, d); var w = p(e, f); return ['C', u[0], u[1], v[0], v[1], w[0], w[1]]; }
    var m = p(8, 37);
    var l1 = p(40, 49);
    var l2 = p(26, 49);
    var cmds = [
      ['M', m[0], m[1]], c(-6, 20, 2, 9, 13, 13), c(13, -3, 30, -3, 32, 8), c(40, -5, 54, 1, 53, 15), c(68, 12, 73, 26, 58, 38),
      ['L', l1[0], l1[1]], ['L', l2[0], l2[1]], ['Z']
    ];
    var parel = p(33, 45);
    function rib(x1, y1, x2, y2) { var a = p(x1, y1); var b = p(x2, y2); return { k: 'l', x1: a[0], y1: a[1], x2: b[0], y2: b[1], kleur: KLEUR.schelpRib, dikte: 2.2, rond: true }; }
    return [
      { k: 'v', cmds: cmds, vul: KLEUR.schelpVul, lijn: KLEUR.schelpRand, dikte: 2.4 },
      rib(13, 15, 29, 42), rib(32, 10, 32, 43), rib(52, 16, 37, 42),
      { k: 'stip', x: parel[0], y: parel[1], r: 4, kleur: KLEUR.schelpParel }
    ];
  }

  // Zacht lila naamvlak: de ontwerpvorm, in breedte en hoogte meegerekt met de naam
  var VLAK = [
    ['M', 234, 505], ['C', 283, 474, 398, 491, 514, 484], ['C', 648, 478, 783, 481, 818, 522],
    ['C', 852, 561, 821, 635, 760, 650], ['C', 682, 672, 609, 653, 522, 661], ['C', 405, 672, 285, 662, 244, 635],
    ['C', 205, 610, 201, 537, 234, 505], ['Z']
  ];

  function naamvlakOps(sx, hoogte) {
    var sy = hoogte / NAAMVLAK_HOOGTE;
    var yc = NAAMVLAK_BOVEN + hoogte / 2;
    function m(x, y) { return [CX + (x - CX) * sx, yc + (y - 568) * sy]; }
    var cmds = VLAK.map(function (c) {
      if (c[0] === 'Z') { return ['Z']; }
      var uit = [c[0]];
      for (var i = 1; i < c.length; i += 2) { var q = m(c[i], c[i + 1]); uit.push(q[0], q[1]); }
      return uit;
    });
    var l1 = m(255, 535); var l2 = m(267, 514); var l3 = m(297, 516);
    var r1 = m(753, 624); var r2 = m(777, 624); var r3 = m(787, 605);
    var sterL = m(205, 547);
    var sterR = m(843, 625);
    return [
      vorm(cmds, KLEUR.naamVlak),
      { k: 'q', x1: l1[0], y1: l1[1], cx: l2[0], cy: l2[1], x2: l3[0], y2: l3[1], kleur: KLEUR.wit, dikte: 4, rond: true },
      { k: 'q', x1: r1[0], y1: r1[1], cx: r2[0], cy: r2[1], x2: r3[0], y2: r3[1], kleur: KLEUR.wit, dikte: 4, rond: true },
      vorm(ster(sterL[0], sterL[1], 19), KLEUR.ster),
      vorm(ster(sterR[0], sterR[1], 15), KLEUR.ster)
    ];
  }

  // Mintkleurige felicitatieband: de prinsessenband op 90%, 25 eenheden naar links zodat hij vrij blijft van de krullen.
  var LINT_CX = 447.5;
  var LINT_TEKST = 39.6;
  function lintOps(top) {
    function m(x, y) { return [0.9 * x - 25, top + 0.9 * y]; }
    var links = [[299, -9], [337, 4], [337, 80], [299, 93], [312, 43]].map(function (q) { return m(q[0], q[1]); });
    var rechts = [[751, -9], [713, 4], [713, 80], [751, 93], [738, 43]].map(function (q) { return m(q[0], q[1]); });
    return [
      vorm(veelhoek(links), KLEUR.lintStaart),
      vorm(veelhoek(rechts), KLEUR.lintStaart),
      vorm(ronderechthoek(0.9 * 322 - 25, top, 0.9 * 406, 0.9 * 85, 0.9 * 19), KLEUR.lintVlak)
    ];
  }

  /* ---------- de indeling ---------- */

  function maakLayout(g) {
    g = g || {};
    var ops = [];
    var meldingen = [];
    var naam = String(g.childName || '').trim();
    var spel = String(g.gameName || '').trim();
    var prestatie = String(g.achievement || '').trim();
    var datum = String(g.date || '').trim();
    var afzender = String(g.presentedBy || '').trim();
    var capKop = tabel('kop').cap / 1000;

    // schelpaccent, titel en begeleidende regel
    schelpOps().forEach(function (o) { ops.push(o); });
    ops.push(tekstOp('Zeemeermindiploma', CX, 339, 'kop', 60, KLEUR.titel));
    ops.push({ k: 'q', x1: 422, y1: 370, cx: 525, cy: 387, x2: 628, y2: 370, kleur: KLEUR.goud, dikte: 3, rond: true });
    ops.push(tekstOp('Dit diploma is voor', CX, 445, 'tekst', 24, KLEUR.tekst));

    // naam op het lila vlak: een regel op 85 eenheden (kleiner tot 50); past dat niet, twee regels (tot 38);
    // anders meetbaar kleiner (tot 24). Het vlak groeit mee in breedte (tot NAAMVLAK_MAX) en hoogte.
    var naamRegels = [];
    var naamPx = 85;
    if (naam) {
      var enkel = pasEnkel(naam, 'kop', 85, 50, NAAM_ZONE);
      if (enkel.past) { naamRegels = [naam]; naamPx = enkel.px; }
      else {
        var twee = besteTweeRegels(naam, 'kop', 56);
        if (twee) {
          naamPx = Math.min(pasEnkel(twee[0], 'kop', 70, 38, NAAM_ZONE).px, pasEnkel(twee[1], 'kop', 70, 38, NAAM_ZONE).px);
          naamRegels = twee;
          twee.forEach(function (r) { if (breedte(r, 'kop', naamPx) > NAAM_ZONE + 0.5) { meldingen.push({ veld: 'childName', tekst: 'De naam is te breed voor het diploma.' }); } });
        } else {
          var klein = pasEnkel(naam, 'kop', 85, 24, NAAM_ZONE);
          naamRegels = [naam]; naamPx = klein.px;
          if (!klein.past) { meldingen.push({ veld: 'childName', tekst: 'De naam is te breed voor het diploma.' }); }
        }
      }
    }
    var naamB = 0;
    naamRegels.forEach(function (r) { naamB = Math.max(naamB, breedte(r, 'kop', naamPx)); });
    var naamLh = naamPx * 1.12;
    var blok = naamRegels.length ? capKop * naamPx + (naamRegels.length - 1) * naamLh : 0;
    var vlakH = Math.max(NAAMVLAK_HOOGTE, blok + 90);
    var vlakSx = Math.min(NAAMVLAK_MAX / NAAMVLAK_BREEDTE, Math.max(1, (naamB + 140) / NAAMVLAK_BREEDTE));
    naamvlakOps(vlakSx, vlakH).forEach(function (o) { ops.push(o); });
    var vlakMidden = NAAMVLAK_BOVEN + vlakH / 2;
    naamRegels.forEach(function (r, i) {
      ops.push(tekstOp(r, CX, vlakMidden - blok / 2 + capKop * naamPx + i * naamLh - 4, 'kop', naamPx, KLEUR.tekst, 'childName'));
    });
    var vlakOnder = NAAMVLAK_BOVEN + vlakH;

    // spelnaam (lila kop) en prestatie; ruime tussenruimtes, bij veel tekst iets krapper zodat het lint
    // niet tegen de krullen komt. Past het dan nog niet: kleiner lettertype tot 22 eenheden.
    var spelRegels = [];
    var spelPx = 28;
    if (spel) {
      var sp = pasEnkel(spel, 'kop', 28, 20, MIDDEN_ZONE);
      if (sp.past) { spelRegels = [spel]; spelPx = sp.px; }
      else {
        spelPx = 22;
        spelRegels = breekRegels(spel, 'kop', spelPx, MIDDEN_ZONE);
        if (spelRegels.length > 2) { meldingen.push({ veld: 'gameName', tekst: 'De naam van het spel is te lang voor het diploma.' }); }
        spelRegels.forEach(function (r) { if (breedte(r, 'kop', spelPx) > MIDDEN_ZONE + 0.5) { meldingen.push({ veld: 'gameName', tekst: 'De naam van het spel is te breed voor het diploma.' }); } });
      }
    }
    var spelLh = spelPx * 1.25;
    var prestRegels = [];
    var prestPx = 28;
    var prestLh = 0;
    var spelY = 0;
    var prestY = 0;
    var lintTop = 0;
    var gaps = [[80, 63, 46], [62, 52, 34]];
    var klaar = false;
    if (prestatie) {
      for (prestPx = 28; !klaar; prestPx -= 0.5) {
        prestRegels = breekRegels(prestatie, 'tekst', prestPx, MIDDEN_ZONE);
        prestLh = prestPx * 1.35;
        for (var gi = 0; gi < gaps.length && !klaar; gi++) {
          spelY = vlakOnder + gaps[gi][0];
          prestY = spelY + Math.max(0, spelRegels.length - 1) * spelLh + gaps[gi][1];
          lintTop = prestY + (prestRegels.length - 1) * prestLh + gaps[gi][2];
          if (prestRegels.length <= 4 && lintTop <= LINT_MAX_BOVEN) { klaar = true; }
        }
        if (klaar || prestPx <= 22) { break; }
      }
      if (!klaar) { meldingen.push({ veld: 'achievement', tekst: 'De tekst bij het spel is te lang voor het diploma.' }); }
      prestRegels.forEach(function (r) { if (breedte(r, 'tekst', prestPx) > MIDDEN_ZONE + 0.5) { meldingen.push({ veld: 'achievement', tekst: 'De tekst bij het spel is te breed voor het diploma.' }); } });
    } else {
      // geen prestatie: dezelfde plekken als bij één regel, het lint blijft op zijn plek
      for (var gj = 0; gj < gaps.length && !klaar; gj++) {
        spelY = vlakOnder + gaps[gj][0];
        prestY = spelY + Math.max(0, spelRegels.length - 1) * spelLh + gaps[gj][1];
        lintTop = prestY + gaps[gj][2];
        if (lintTop <= LINT_MAX_BOVEN) { klaar = true; }
      }
    }
    spelRegels.forEach(function (r, i) { ops.push(tekstOp(r, CX, spelY + i * spelLh, 'kop', spelPx, KLEUR.spel, 'gameName')); });
    prestRegels.forEach(function (r, i) { ops.push(tekstOp(r, CX, prestY + i * prestLh, 'tekst', prestPx, KLEUR.tekst, 'achievement')); });

    // mintkleurige felicitatieband
    lintOps(lintTop).forEach(function (o) { ops.push(o); });
    ops.push(tekstOp('Goed gedaan!', LINT_CX, lintTop + 51.3, 'kop', LINT_TEKST, KLEUR.goed));

    // datum, links van de zeemeermin, boven een lijn
    var datumHalf = 115;
    if (datum) {
      var dp = pasEnkel(datum, 'tekst', 22, 16, ONDER_ZONE);
      ops.push(tekstOp(datum, CX_ONDER, 1125, 'tekst', dp.px, KLEUR.tekst, 'date'));
      datumHalf = Math.min(125, Math.max(115, dp.breedte / 2 + 14));
      if (!dp.past) { meldingen.push({ veld: 'date', tekst: 'De datum is te lang voor het diploma.' }); }
    }
    ops.push({ k: 'l', x1: CX_ONDER - datumHalf, y1: 1145, x2: CX_ONDER + datumHalf, y2: 1145, kleur: KLEUR.onderLijn, dikte: 1.4, rond: false });

    // afzender
    ops.push(tekstOp('Uitgereikt door', CX_ONDER, 1212, 'tekst', 21, KLEUR.label));
    var afzHalf = 115;
    if (afzender) {
      var ap = pasEnkel(afzender, 'tekst', 23, 17, ONDER_ZONE);
      if (ap.past) {
        ops.push(tekstOp(afzender, CX_ONDER, 1250, 'tekst', ap.px, KLEUR.tekst, 'presentedBy'));
        afzHalf = Math.min(125, Math.max(115, ap.breedte / 2 + 14));
      } else {
        var apx = 20;
        var ar = breekRegels(afzender, 'tekst', apx, ONDER_ZONE);
        var arB = 0;
        ar.forEach(function (r) { arB = Math.max(arB, breedte(r, 'tekst', apx)); });
        if (ar.length > 2 || arB > ONDER_ZONE + 0.5) { meldingen.push({ veld: 'presentedBy', tekst: 'De naam van de afzender is te lang voor het diploma.' }); }
        ar.forEach(function (r, i) { ops.push(tekstOp(r, CX_ONDER, 1250 - (ar.length - 1 - i) * 24, 'tekst', apx, KLEUR.tekst, 'presentedBy')); });
        afzHalf = Math.min(125, Math.max(115, Math.min(arB, ONDER_ZONE) / 2 + 14));
      }
    }
    ops.push({ k: 'l', x1: CX_ONDER - afzHalf, y1: 1270, x2: CX_ONDER + afzHalf, y2: 1270, kleur: KLEUR.onderLijn, dikte: 1.4, rond: false });

    return { ops: ops, meldingen: meldingen, decor: decoratiePlaats(), logo: { x: LOGO.x, y: LOGO.y, b: LOGO.b, h: LOGO.h } };
  }

  /* ---------- inline SVG met echte tekstlagen (voorbeeld en direct printen) ---------- */

  var NS = 'http://www.w3.org/2000/svg';
  var XLINK = 'http://www.w3.org/1999/xlink';

  function el(naam, attrs) {
    var e = document.createElementNS(NS, naam);
    Object.keys(attrs || {}).forEach(function (k) { e.setAttribute(k, String(attrs[k])); });
    return e;
  }

  function f1(v) { return (Math.round(v * 100) / 100).toString(); }

  function padTekst(cmds) {
    return cmds.map(function (c) {
      if (c[0] === 'Z') { return 'Z'; }
      var n = c.slice(1).map(f1).join(' ');
      return c[0] + n;
    }).join('');
  }

  function maakSvg(g) {
    var L = maakLayout(g);
    var svg = el('svg', { viewBox: '0 0 ' + B + ' ' + H, role: 'img', focusable: 'false', preserveAspectRatio: 'xMidYMid meet' });
    svg.setAttribute('xmlns', NS);
    svg.appendChild(el('rect', { x: 0, y: 0, width: B, height: H, fill: KLEUR.papier }));
    var dec = el('image', { x: f1(L.decor.x), y: f1(L.decor.y), width: f1(L.decor.b), height: f1(L.decor.h), preserveAspectRatio: 'none' });
    dec.setAttribute('href', window.IKDMU(BEELD.decoratie));
    dec.setAttributeNS(XLINK, 'xlink:href', window.IKDMU(BEELD.decoratie));
    svg.appendChild(dec);
    var logo = el('image', { x: L.logo.x, y: L.logo.y, width: L.logo.b, height: L.logo.h, preserveAspectRatio: 'xMidYMid meet' });
    logo.setAttribute('href', window.IKDMU(BEELD.logo));
    logo.setAttributeNS(XLINK, 'xlink:href', window.IKDMU(BEELD.logo));
    svg.appendChild(logo);
    L.ops.forEach(function (op) {
      if (op.k === 't') {
        var t = el('text', { x: f1(op.cx), y: f1(op.y), 'text-anchor': 'middle', 'font-size': f1(op.px), fill: op.kleur });
        t.style.fontFamily = FONT[op.font].canvas;
        t.style.fontWeight = FONT[op.font].gewicht;
        t.style.fontKerning = 'none';
        t.style.fontFeatureSettings = '"kern" 0';
        if (op.veld) { t.setAttribute('data-field', op.veld); }
        t.textContent = op.t;
        svg.appendChild(t);
      } else if (op.k === 'l') {
        svg.appendChild(el('path', { d: 'M' + f1(op.x1) + ' ' + f1(op.y1) + 'L' + f1(op.x2) + ' ' + f1(op.y2), stroke: op.kleur, 'stroke-width': op.dikte, fill: 'none', 'stroke-linecap': op.rond ? 'round' : 'butt' }));
      } else if (op.k === 'q') {
        svg.appendChild(el('path', { d: 'M' + f1(op.x1) + ' ' + f1(op.y1) + 'Q' + f1(op.cx) + ' ' + f1(op.cy) + ' ' + f1(op.x2) + ' ' + f1(op.y2), stroke: op.kleur, 'stroke-width': op.dikte, fill: 'none', 'stroke-linecap': op.rond ? 'round' : 'butt' }));
      } else if (op.k === 'stip') {
        svg.appendChild(el('circle', { cx: f1(op.x), cy: f1(op.y), r: op.r, fill: op.kleur }));
      } else if (op.k === 'v') {
        var a = { d: padTekst(op.cmds), fill: op.vul || 'none' };
        if (op.lijn) { a.stroke = op.lijn; a['stroke-width'] = op.dikte; a['stroke-linejoin'] = 'round'; }
        svg.appendChild(el('path', a));
      }
    });
    return svg;
  }

  /* ---------- canvas (alleen voor de png-download en het kleine themastaal) ---------- */

  function fontTekst(f, px) { return FONT[f].gewicht + ' ' + px + 'px ' + FONT[f].canvas; }

  function tekenCanvas(canvas, g, breedtePx, beeld) {
    var L = maakLayout(g);
    var schaal = breedtePx / B;
    canvas.width = Math.round(B * schaal);
    canvas.height = Math.round(H * schaal);
    var ctx = canvas.getContext('2d');
    ctx.setTransform(canvas.width / B, 0, 0, canvas.height / H, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.fillStyle = KLEUR.papier;
    ctx.fillRect(0, 0, B, H);
    if (beeld && beeld.decoratie) { ctx.drawImage(beeld.decoratie, L.decor.x, L.decor.y, L.decor.b, L.decor.h); }
    if (beeld && beeld.logo) { ctx.drawImage(beeld.logo, L.logo.x, L.logo.y, L.logo.b, L.logo.h); }
    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';
    if ('fontKerning' in ctx) { ctx.fontKerning = 'none'; }
    L.ops.forEach(function (op) {
      ctx.save();
      if (op.k === 't') {
        ctx.fillStyle = op.kleur;
        ctx.font = fontTekst(op.font, op.px);
        ctx.fillText(op.t, op.cx - op.b / 2, op.y);
      } else if (op.k === 'l') {
        ctx.beginPath(); ctx.moveTo(op.x1, op.y1); ctx.lineTo(op.x2, op.y2);
        ctx.strokeStyle = op.kleur; ctx.lineWidth = op.dikte; ctx.lineCap = op.rond ? 'round' : 'butt'; ctx.stroke();
      } else if (op.k === 'q') {
        ctx.beginPath(); ctx.moveTo(op.x1, op.y1); ctx.quadraticCurveTo(op.cx, op.cy, op.x2, op.y2);
        ctx.strokeStyle = op.kleur; ctx.lineWidth = op.dikte; ctx.lineCap = op.rond ? 'round' : 'butt'; ctx.stroke();
      } else if (op.k === 'stip') {
        ctx.beginPath(); ctx.arc(op.x, op.y, op.r, 0, Math.PI * 2); ctx.fillStyle = op.kleur; ctx.fill();
      } else if (op.k === 'v') {
        ctx.beginPath();
        op.cmds.forEach(function (c) {
          if (c[0] === 'M') { ctx.moveTo(c[1], c[2]); }
          else if (c[0] === 'L') { ctx.lineTo(c[1], c[2]); }
          else if (c[0] === 'C') { ctx.bezierCurveTo(c[1], c[2], c[3], c[4], c[5], c[6]); }
          else { ctx.closePath(); }
        });
        if (op.vul) { ctx.fillStyle = op.vul; ctx.fill(); }
        if (op.lijn) { ctx.strokeStyle = op.lijn; ctx.lineWidth = op.dikte; ctx.lineJoin = 'round'; ctx.stroke(); }
      }
      ctx.restore();
    });
    return L;
  }

  /* ---------- pdf-inhoud (echte tekst) ---------- */

  function f3(v) { return (Math.round(v * 1000) / 1000).toString(); }
  function rgb(hex) {
    var n = parseInt(hex.slice(1), 16);
    return f3(((n >> 16) & 255) / 255) + ' ' + f3(((n >> 8) & 255) / 255) + ' ' + f3((n & 255) / 255);
  }
  function hex4(v) { return ('0000' + v.toString(16)).slice(-4); }
  var HPT = H * PT;
  function X(x) { return f3(x * PT); }
  function Y(y) { return f3(HPT - y * PT); }

  // Geeft de inhoud van de pagina, de gebruikte glyphs per lettertype en de indeling terug.
  function pdfOpdrachten(g) {
    var L = maakLayout(g);
    var gebruikt = { kop: {}, tekst: {} };
    var s = [];
    s.push(rgb(KLEUR.papier) + ' rg 0 0 ' + f3(B * PT) + ' ' + f3(HPT) + ' re f');
    s.push('q ' + f3(L.decor.b * PT) + ' 0 0 ' + f3(L.decor.h * PT) + ' ' + X(L.decor.x) + ' ' + f3(HPT - (L.decor.y + L.decor.h) * PT) + ' cm /ImDecor Do Q');
    s.push('q ' + f3(L.logo.b * PT) + ' 0 0 ' + f3(L.logo.h * PT) + ' ' + X(L.logo.x) + ' ' + f3(HPT - (L.logo.y + L.logo.h) * PT) + ' cm /ImLogo Do Q');
    L.ops.forEach(function (op) {
      if (op.k === 'l') {
        s.push('q ' + rgb(op.kleur) + ' RG ' + f3(op.dikte * PT) + ' w ' + (op.rond ? '1' : '0') + ' J ' + X(op.x1) + ' ' + Y(op.y1) + ' m ' + X(op.x2) + ' ' + Y(op.y2) + ' l S Q');
      } else if (op.k === 'q') {
        // kwadratische kromme naar een kubische omzetten
        var c1x = op.x1 + 2 / 3 * (op.cx - op.x1);
        var c1y = op.y1 + 2 / 3 * (op.cy - op.y1);
        var c2x = op.x2 + 2 / 3 * (op.cx - op.x2);
        var c2y = op.y2 + 2 / 3 * (op.cy - op.y2);
        s.push('q ' + rgb(op.kleur) + ' RG ' + f3(op.dikte * PT) + ' w ' + (op.rond ? '1' : '0') + ' J ' + X(op.x1) + ' ' + Y(op.y1) + ' m ' +
          X(c1x) + ' ' + Y(c1y) + ' ' + X(c2x) + ' ' + Y(c2y) + ' ' + X(op.x2) + ' ' + Y(op.y2) + ' c S Q');
      } else if (op.k === 'stip') {
        var k = 0.5523 * op.r;
        s.push('q ' + rgb(op.kleur) + ' rg ' + X(op.x + op.r) + ' ' + Y(op.y) + ' m ' +
          X(op.x + op.r) + ' ' + Y(op.y + k) + ' ' + X(op.x + k) + ' ' + Y(op.y + op.r) + ' ' + X(op.x) + ' ' + Y(op.y + op.r) + ' c ' +
          X(op.x - k) + ' ' + Y(op.y + op.r) + ' ' + X(op.x - op.r) + ' ' + Y(op.y + k) + ' ' + X(op.x - op.r) + ' ' + Y(op.y) + ' c ' +
          X(op.x - op.r) + ' ' + Y(op.y - k) + ' ' + X(op.x - k) + ' ' + Y(op.y - op.r) + ' ' + X(op.x) + ' ' + Y(op.y - op.r) + ' c ' +
          X(op.x + k) + ' ' + Y(op.y - op.r) + ' ' + X(op.x + op.r) + ' ' + Y(op.y - k) + ' ' + X(op.x + op.r) + ' ' + Y(op.y) + ' c h f Q');
      } else if (op.k === 'v') {
        var d = ['q'];
        if (op.vul) { d.push(rgb(op.vul) + ' rg'); }
        if (op.lijn) { d.push(rgb(op.lijn) + ' RG ' + f3(op.dikte * PT) + ' w 1 j 1 J'); }
        op.cmds.forEach(function (c) {
          if (c[0] === 'M') { d.push(X(c[1]) + ' ' + Y(c[2]) + ' m'); }
          else if (c[0] === 'L') { d.push(X(c[1]) + ' ' + Y(c[2]) + ' l'); }
          else if (c[0] === 'C') { d.push(X(c[1]) + ' ' + Y(c[2]) + ' ' + X(c[3]) + ' ' + Y(c[4]) + ' ' + X(c[5]) + ' ' + Y(c[6]) + ' c'); }
          else { d.push('h'); }
        });
        d.push(op.vul && op.lijn ? 'B' : (op.vul ? 'f' : 'S'));
        d.push('Q');
        s.push(d.join(' '));
      } else if (op.k === 't') {
        var t = tabel(op.font);
        var hex = '';
        Array.from(op.t).forEach(function (ch) {
          var cp = ch.codePointAt(0);
          var gl = t.cmap[cp];
          if (gl === undefined) { cp = 32; gl = t.cmap[32]; }
          gebruikt[op.font][gl] = cp;
          hex += hex4(gl);
        });
        var sleutel = op.font === 'kop' ? 'FKop' : 'FTekst';
        s.push('BT ' + rgb(op.kleur) + ' rg /' + sleutel + ' ' + f3(op.px * PT) + ' Tf 0 Tc ' + X(op.cx - op.b / 2) + ' ' + Y(op.y) + ' Td <' + hex + '> Tj ET');
      }
    });
    return { inhoud: s.join('\n'), gebruikt: gebruikt, layout: L };
  }

  window.IKZeemeermin = Object.freeze({
    breedte: B,
    hoogte: H,
    naamMax: NAAM_MAX,
    afzenderMax: AFZENDER_MAX,
    kleur: KLEUR,
    beeld: BEELD,
    maakLayout: maakLayout,
    maakSvg: maakSvg,
    tekenCanvas: tekenCanvas,
    pdfOpdrachten: pdfOpdrachten,
    prestatieTekst: prestatieTekst,
    onbekendeTekens: onbekendeTekens,
    decoratiePlaats: decoratiePlaats,
    meet: breedte
  });
}());


/* ---- tekstthemas.js ---- */
/*
 * Intellikids diploma-maker (besloten testversie, R132): Dinosaurus v1, Dieren & natuur v1, Voertuigen v5 en Ruimte v2.
 *
 * Eén gedeelde indelingsmotor, per thema ingesteld met een eigen configuratie (zones, kleuren, vormen). De motor is
 * dezelfde als die van het Prinsessendiploma (js/prinses.js) en het Zeemeermindiploma (js/zeemeermin.js), die ongewijzigd
 * blijven. Eén indeling (maakLayout) voor scherm, afbeelding, print en pdf, als lijst eenvoudige tekenopdrachten in een
 * raster van 1050 x 1485 eenheden (A4 staand, 1 eenheid = 0,2 mm). Daaruit komen:
 *  - maakSvg(): inline SVG met echte <text>-lagen voor de voorbeelden en het directe printen;
 *  - tekenCanvas(): canvas voor de png-download en de kleine themakaart (raster is daar toegestaan);
 *  - pdfOpdrachten(): de pagina-inhoud van de download-pdf, met echte tekst en ingesloten lettertypes.
 * Letterbreedtes komen uit dezelfde tabellen als de pdf (js/pdf-fonts.js), zonder kerning, zodat alle uitvoer op
 * dezelfde plek afbreekt en centreert.
 *
 * Beeldmateriaal per thema: alleen de aangeleverde decoratielaag (assets/<thema>-decoratie.png) en het originele logo
 * (assets/logo-officieel.png). Accent, naamvlak, sterretjes en felicitatieband zijn losse vormen; alle teksten zijn echte tekst.
 *
 * Velden: childName, gameName, achievement, date, presentedBy. Geen voorbeeldgegevens; een leeg veld geeft
 * witruimte (en de neutrale lijn onder datum en afzender). Niets wordt stilzwijgend afgekapt: past iets niet,
 * dan staat het in "meldingen" en toont de maker een duidelijke melding.
 */
(function () {
  'use strict';

  var B = 1050;
  var H = 1485;
  var PT = 595.2756 / B; // eenheid -> pdf-punt
  var CX = 525; // midden van de pagina: de tekstzone staat gecentreerd
  var NAAM_MAX = 20;
  var AFZENDER_MAX = 30;
  var VEILIG_MM = 5.4;
  var LOGO_X = 407;
  var LOGO_B = 236;
  var LOGO_H = 53;

  var FONT = {
    kop: { canvas: '"IK Nunito", "Nunito", ui-rounded, "Segoe UI", system-ui, sans-serif', gewicht: '800' },
    tekst: { canvas: '"IK Nunito Sans", "Nunito Sans", "Segoe UI", system-ui, sans-serif', gewicht: '400' }
  };

  function tabel(sleutel) {
    var t = window.IKPdfFonts && window.IKPdfFonts[sleutel];
    if (!t) { throw new Error('lettertypegegevens ontbreken: ' + sleutel); }
    return t;
  }

  /* ---------- meten (uit dezelfde tabellen als de pdf) ---------- */

  function breedte(tekst, sleutel, px) {
    var t = tabel(sleutel);
    var som = 0;
    Array.from(tekst).forEach(function (ch) {
      var g = t.cmap[ch.codePointAt(0)];
      if (g === undefined) { g = t.cmap[32]; }
      som += (t.breedte[g] || 0) / 1000 * px;
    });
    return som;
  }

  // Tekens die niet in de ingesloten lettertypen zitten (de pdf kan ze dan niet tonen).
  function onbekendeTekens(tekst) {
    var uit = [];
    var kop = tabel('kop');
    var tekstT = tabel('tekst');
    Array.from(String(tekst || '')).forEach(function (ch) {
      var c = ch.codePointAt(0);
      if (kop.cmap[c] === undefined || tekstT.cmap[c] === undefined) { if (uit.indexOf(ch) === -1) { uit.push(ch); } }
    });
    return uit;
  }

  /* ---------- tekst passen ---------- */

  function pasEnkel(tekst, sleutel, start, minimum, maxBreedte) {
    var px = start;
    while (px > minimum && breedte(tekst, sleutel, px) > maxBreedte) { px -= 0.5; }
    var w = breedte(tekst, sleutel, px);
    return { px: px, breedte: w, past: w <= maxBreedte + 0.01 };
  }

  function breekRegels(tekst, sleutel, px, maxBreedte) {
    var woorden = tekst.split(' ');
    var regels = [];
    var regel = '';
    woorden.forEach(function (w) {
      var proef = regel ? regel + ' ' + w : w;
      if (!regel || breedte(proef, sleutel, px) <= maxBreedte) { regel = proef; } else { regels.push(regel); regel = w; }
    });
    if (regel) { regels.push(regel); }
    return regels;
  }

  // Beste breekpunt in twee regels (op een spatie of na een koppelteken): kortste langste regel.
  function besteTweeRegels(tekst, sleutel, px) {
    var beste = null;
    var besteB = Infinity;
    for (var i = 1; i < tekst.length; i++) {
      var k = null;
      if (tekst.charAt(i) === ' ') { k = [tekst.slice(0, i).trim(), tekst.slice(i + 1).trim()]; }
      else if (tekst.charAt(i - 1) === '-') { k = [tekst.slice(0, i), tekst.slice(i)]; }
      if (!k || !k[0] || !k[1]) { continue; }
      var m = Math.max(breedte(k[0], sleutel, px), breedte(k[1], sleutel, px));
      if (m < besteB) { besteB = m; beste = k; }
    }
    return beste;
  }

  // "heeft geoefend met de gespen" -> "Geoefend met de gespen"
  function prestatieTekst(zin) {
    var t = String(zin || '').trim().replace(/^heeft\s+/i, '');
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : '';
  }

  /* ---------- vormen ---------- */

  function tekstOp(t, cx, y, font, px, kleur, veld) {
    return { k: 't', t: t, cx: cx, y: y, font: font, px: px, kleur: kleur, b: breedte(t, font, px), veld: veld || '' };
  }

  // Gevulde (en/of omlijnde) vorm uit absolute opdrachten: ['M',x,y] ['L',x,y] ['C',x1,y1,x2,y2,x,y] ['Z']
  function vorm(cmds, vul, lijn, dikte) {
    return { k: 'v', cmds: cmds, vul: vul || null, lijn: lijn || null, dikte: dikte || 0 };
  }

  function veelhoek(punten) {
    var c = punten.map(function (p, i) { return [i === 0 ? 'M' : 'L', p[0], p[1]]; });
    c.push(['Z']);
    return c;
  }

  function ronderechthoek(x, y, w, h, r) {
    var k = 0.5523 * r;
    return [
      ['M', x + r, y], ['L', x + w - r, y],
      ['C', x + w - r + k, y, x + w, y + r - k, x + w, y + r], ['L', x + w, y + h - r],
      ['C', x + w, y + h - r + k, x + w - r + k, y + h, x + w - r, y + h], ['L', x + r, y + h],
      ['C', x + r - k, y + h, x, y + h - r + k, x, y + h - r], ['L', x, y + r],
      ['C', x, y + r - k, x + r - k, y, x + r, y], ['Z']
    ];
  }

  // Sterretje met vier punten rond (cx, cy); s = halve grootte
  function ster(cx, cy, s) {
    var a = s * 0.27;
    return veelhoek([[cx, cy - s], [cx + a, cy - a], [cx + s, cy], [cx + a, cy + a], [cx, cy + s], [cx - a, cy + a], [cx - s, cy], [cx - a, cy - a]]);
  }

  // Kwadratische krommen als kubische opdrachten schrijven: [['M',x,y], ['Q',cx,cy,x,y] ...] -> M/L/C/Z
  function qNaarC(cmds) {
    var uit = [];
    var px = 0;
    var py = 0;
    cmds.forEach(function (c) {
      if (c[0] === 'M') { uit.push(c); px = c[1]; py = c[2]; }
      else if (c[0] === 'L') { uit.push(c); px = c[1]; py = c[2]; }
      else if (c[0] === 'Q') {
        uit.push(['C', px + 2 / 3 * (c[1] - px), py + 2 / 3 * (c[2] - py), c[3] + 2 / 3 * (c[1] - c[3]), c[4] + 2 / 3 * (c[2] - c[4]), c[3], c[4]]);
        px = c[3]; py = c[4];
      } else { uit.push(c); }
    });
    return uit;
  }

  // Past een puntentransformatie toe op M/L/C-opdrachten
  function mapCmds(cmds, f) {
    return cmds.map(function (c) {
      if (c[0] === 'Z') { return ['Z']; }
      var uit = [c[0]];
      for (var i = 1; i < c.length; i += 2) { var q = f(c[i], c[i + 1]); uit.push(q[0], q[1]); }
      return uit;
    });
  }

  function lijn(x1, y1, x2, y2, kleur, dikte, rond, dash) {
    var o = { k: 'l', x1: x1, y1: y1, x2: x2, y2: y2, kleur: kleur, dikte: dikte, rond: !!rond };
    if (dash) { o.dash = dash; }
    return o;
  }

  // Zacht naamvlak (de ontwerpvorm van de reeks), in breedte en hoogte meegerekt met de naam
  var VLAK = [
    ['M', 234, 505], ['C', 283, 474, 398, 491, 514, 484], ['C', 648, 478, 783, 481, 818, 522],
    ['C', 852, 561, 821, 635, 760, 650], ['C', 682, 672, 609, 653, 522, 661], ['C', 405, 672, 285, 662, 244, 635],
    ['C', 205, 610, 201, 537, 234, 505], ['Z']
  ];

  function blobOps(C, sx, hoogte) {
    var sy = hoogte / C.vlak.hoogte;
    var yc = C.vlak.top + hoogte / 2;
    function m(x, y) { return [CX + (x - CX) * sx, yc + (y - 568) * sy]; }
    var cmds = mapCmds(VLAK, m);
    var l1 = m(255, 535); var l2 = m(267, 514); var l3 = m(297, 516);
    var r1 = m(753, 624); var r2 = m(777, 624); var r3 = m(787, 605);
    var sterL = m(205, 547);
    var sterR = m(843, 625);
    var K = C.kleur;
    return [
      vorm(cmds, K.naamVlak),
      { k: 'q', x1: l1[0], y1: l1[1], cx: l2[0], cy: l2[1], x2: l3[0], y2: l3[1], kleur: K.wit, dikte: 4, rond: true },
      { k: 'q', x1: r1[0], y1: r1[1], cx: r2[0], cy: r2[1], x2: r3[0], y2: r3[1], kleur: K.wit, dikte: 4, rond: true },
      vorm(ster(sterL[0], sterL[1], 19), K.ster),
      vorm(ster(sterR[0], sterR[1], 15), K.ster)
    ];
  }

  // Voertuigen: gele kaart met inkepingen en twee stippellijnen (ontwerpvorm 193-857 x 450-612)
  function kaartOps(C, sx, hoogte) {
    var dh = hoogte - C.vlak.hoogte;
    function mx(x) { return CX + (x - CX) * sx; }
    function my(y) { return y <= 512 ? y - dh / 2 : (y >= 534 ? y + dh / 2 : y); }
    function m(x, y) { return [mx(x), my(y)]; }
    var pad = [
      ['M', 218, 450], ['L', 832, 450], ['Q', 857, 450, 857, 475], ['L', 857, 512], ['Q', 835, 522, 857, 534], ['L', 857, 582],
      ['Q', 857, 612, 829, 612], ['L', 221, 612], ['Q', 193, 612, 193, 582], ['L', 193, 534], ['Q', 215, 522, 193, 512],
      ['L', 193, 475], ['Q', 193, 450, 218, 450], ['Z']
    ];
    var mapped = pad.map(function (c) {
      if (c[0] === 'Z') { return ['Z']; }
      var uit = [c[0]];
      for (var i = 1; i < c.length; i += 2) { var q = m(c[i], c[i + 1]); uit.push(q[0], q[1]); }
      return uit;
    });
    var K = C.kleur;
    var a = m(223, 477); var b = m(827, 477); var c2 = m(223, 586); var d = m(827, 586);
    return [
      vorm(qNaarC(mapped), K.naamVlak),
      lijn(a[0], a[1], b[0], b[1], K.stippel, 2, true, [4, 9]),
      lijn(c2[0], c2[1], d[0], d[1], K.stippel, 2, true, [4, 9])
    ];
  }

  // Band van Dinosaurus, Dieren & natuur en Ruimte: 0,85 x de ontwerpband, 45 eenheden naar links
  function bandOps85(top, K) {
    function m(x, y) { return [0.85 * x - 45, top + 0.85 * (y - 896)]; }
    var links = [[299, 887], [337, 900], [337, 976], [299, 989], [312, 939]].map(function (q) { return m(q[0], q[1]); });
    var rechts = [[751, 887], [713, 900], [713, 976], [751, 989], [738, 939]].map(function (q) { return m(q[0], q[1]); });
    return [
      vorm(veelhoek(links), K.lintStaart),
      vorm(veelhoek(rechts), K.lintStaart),
      vorm(ronderechthoek(0.85 * 322 - 45, top, 0.85 * 406, 0.85 * 85, 0.85 * 19), K.lintVlak)
    ];
  }

  // Band van Voertuigen: afgeronde pil met twee sterretjes
  function bandOpsPil(top, K) {
    return [
      vorm(ronderechthoek(310, top, 430, 86, 43), K.lintVlak),
      vorm(ster(276, top + 37, 18), K.lintSter),
      vorm(ster(774, top + 37, 18), K.lintSter)
    ];
  }

  /* ---------- de motor ---------- */

  function maakThema(C) {
    var K = C.kleur;
    var BEELD = { decoratie: C.decorBestand, logo: 'assets/logo-officieel.png' };
    var DECOR = C.decor;
    var V = C.vlak;
    var M = C.midden;
    var F = C.voet;

    // Schaalt de decoratielaag als geheel om het midden van de pagina, precies genoeg om minstens VEILIG_MM
    // van elke papierrand te blijven. Niets wordt afgesneden en de omlijsting blijft symmetrisch.
    function decoratiePlaats() {
      var sx = B / DECOR.b;
      var sy = H / DECOR.h;
      var veilig = VEILIG_MM * 5;
      var x0 = DECOR.inkt.x0 * sx;
      var x1 = (DECOR.inkt.x1 + 1) * sx;
      var y0 = DECOR.inkt.y0 * sy;
      var y1 = (DECOR.inkt.y1 + 1) * sy;
      var s = Math.min(
        1,
        (B / 2 - veilig) / (B / 2 - x0),
        (B / 2 - veilig) / (x1 - B / 2),
        (H / 2 - veilig) / (H / 2 - y0),
        (H / 2 - veilig) / (y1 - H / 2)
      );
      return { s: s, x: B / 2 * (1 - s), y: H / 2 * (1 - s), b: B * s, h: H * s };
    }

    function maakLayout(g) {
      g = g || {};
      var ops = [];
      var meldingen = [];
      var naam = String(g.childName || '').trim();
      var spel = String(g.gameName || '').trim();
      var prestatie = String(g.achievement || '').trim();
      var datum = String(g.date || '').trim();
      var afzender = String(g.presentedBy || '').trim();
      var capKop = tabel('kop').cap / 1000;

      // accent, titel en begeleidende regel
      C.accent(K).forEach(function (o) { ops.push(o); });
      ops.push(tekstOp(C.titel, CX, C.titelY, 'kop', C.titelPx, K.titel));
      C.titelLijn(K).forEach(function (o) { ops.push(o); });
      ops.push(tekstOp('Dit diploma is voor', CX, C.ditY, 'tekst', C.ditPx, K.tekst));

      // naam op het vlak: een regel op 85 eenheden (kleiner tot 50); past dat niet, twee regels (tot 38);
      // anders meetbaar kleiner (tot 24). Het vlak groeit mee in breedte (tot V.max) en hoogte.
      var naamRegels = [];
      var naamPx = 85;
      if (naam) {
        var enkel = pasEnkel(naam, 'kop', 85, 50, V.zone);
        if (enkel.past) { naamRegels = [naam]; naamPx = enkel.px; }
        else {
          var twee = besteTweeRegels(naam, 'kop', 56);
          if (twee) {
            naamPx = Math.min(pasEnkel(twee[0], 'kop', 70, 38, V.zone).px, pasEnkel(twee[1], 'kop', 70, 38, V.zone).px);
            naamRegels = twee;
            twee.forEach(function (r) { if (breedte(r, 'kop', naamPx) > V.zone + 0.5) { meldingen.push({ veld: 'childName', tekst: 'De naam is te breed voor het diploma.' }); } });
          } else {
            var klein = pasEnkel(naam, 'kop', 85, 24, V.zone);
            naamRegels = [naam]; naamPx = klein.px;
            if (!klein.past) { meldingen.push({ veld: 'childName', tekst: 'De naam is te breed voor het diploma.' }); }
          }
        }
      }
      var naamB = 0;
      naamRegels.forEach(function (r) { naamB = Math.max(naamB, breedte(r, 'kop', naamPx)); });
      var naamLh = naamPx * 1.12;
      var blok = naamRegels.length ? capKop * naamPx + (naamRegels.length - 1) * naamLh : 0;
      var vlakH = Math.max(V.hoogte, blok + 90);
      var vlakSx = Math.min(V.max / V.breedte, Math.max(1, (naamB + 140) / V.breedte));
      (V.soort === 'kaart' ? kaartOps(C, vlakSx, vlakH) : blobOps(C, vlakSx, vlakH)).forEach(function (o) { ops.push(o); });
      var vlakMidden = V.top + vlakH / 2;
      naamRegels.forEach(function (r, i) {
        ops.push(tekstOp(r, CX, vlakMidden - blok / 2 + capKop * naamPx + i * naamLh + V.naamOffset, 'kop', naamPx, K.tekst, 'childName'));
      });
      var vlakOnder = V.top + vlakH;

      // spelnaam en prestatie; ruime tussenruimtes, bij veel tekst iets krapper zodat de band niet te laag komt.
      // Past het dan nog niet: kleiner lettertype tot 22 eenheden.
      var spelRegels = [];
      var spelPx = M.spelPx;
      if (spel) {
        var sp = pasEnkel(spel, 'kop', M.spelPx, 20, M.zone);
        if (sp.past) { spelRegels = [spel]; spelPx = sp.px; }
        else {
          spelPx = 22;
          spelRegels = breekRegels(spel, 'kop', spelPx, M.zone);
          if (spelRegels.length > 2) { meldingen.push({ veld: 'gameName', tekst: 'De naam van het spel is te lang voor het diploma.' }); }
          spelRegels.forEach(function (r) { if (breedte(r, 'kop', spelPx) > M.zone + 0.5) { meldingen.push({ veld: 'gameName', tekst: 'De naam van het spel is te breed voor het diploma.' }); } });
        }
      }
      var spelLh = spelPx * 1.25;
      var prestRegels = [];
      var prestPx = M.prestPx;
      var prestLh = 0;
      var spelY = 0;
      var prestY = 0;
      var lintTop = 0;
      var gaps = M.gaps;
      var klaar = false;
      if (prestatie) {
        for (prestPx = M.prestPx; !klaar; prestPx -= 0.5) {
          prestRegels = breekRegels(prestatie, 'tekst', prestPx, M.zone);
          prestLh = prestPx * 1.35;
          for (var gi = 0; gi < gaps.length && !klaar; gi++) {
            spelY = vlakOnder + gaps[gi][0];
            prestY = spelY + Math.max(0, spelRegels.length - 1) * spelLh + gaps[gi][1];
            lintTop = prestY + (prestRegels.length - 1) * prestLh + gaps[gi][2];
            if (prestRegels.length <= 4 && lintTop <= M.lintMax) { klaar = true; }
          }
          if (klaar || prestPx <= 22) { break; }
        }
        if (!klaar) { meldingen.push({ veld: 'achievement', tekst: 'De tekst bij het spel is te lang voor het diploma.' }); }
        prestRegels.forEach(function (r) { if (breedte(r, 'tekst', prestPx) > M.zone + 0.5) { meldingen.push({ veld: 'achievement', tekst: 'De tekst bij het spel is te breed voor het diploma.' }); } });
      } else {
        // geen prestatie: dezelfde plekken als bij één regel, de band blijft op zijn plek
        for (var gj = 0; gj < gaps.length && !klaar; gj++) {
          spelY = vlakOnder + gaps[gj][0];
          prestY = spelY + Math.max(0, spelRegels.length - 1) * spelLh + gaps[gj][1];
          lintTop = prestY + gaps[gj][2];
          if (lintTop <= M.lintMax) { klaar = true; }
        }
      }
      spelRegels.forEach(function (r, i) { ops.push(tekstOp(r, CX, spelY + i * spelLh, 'kop', spelPx, K.spel, 'gameName')); });
      prestRegels.forEach(function (r, i) { ops.push(tekstOp(r, CX, prestY + i * prestLh, 'tekst', prestPx, K.tekst, 'achievement')); });

      // felicitatieband
      C.band(lintTop, K).forEach(function (o) { ops.push(o); });
      ops.push(tekstOp('Goed gedaan!', C.bandTekst.cx, lintTop + C.bandTekst.dy, 'kop', C.bandTekst.px, K.goed));

      // datum, boven een lijn
      var D = F.datum;
      var datumHalf = D.half;
      if (datum) {
        var dp = pasEnkel(datum, 'tekst', 22, 16, D.zone);
        ops.push(tekstOp(datum, D.cx, D.y, 'tekst', dp.px, K.tekst, 'date'));
        datumHalf = Math.min(D.maxHalf, Math.max(D.half, dp.breedte / 2 + 14));
        if (!dp.past) { meldingen.push({ veld: 'date', tekst: 'De datum is te lang voor het diploma.' }); }
      }
      ops.push(lijn(D.cx - datumHalf, D.lijnY, D.cx + datumHalf, D.lijnY, K.onderLijn, 1.4, false));

      // afzender
      var A = F.afz;
      ops.push(tekstOp('Uitgereikt door', F.label.cx, F.label.y, 'tekst', 21, K.label));
      var afzHalf = A.half;
      if (afzender) {
        var ap = pasEnkel(afzender, 'tekst', 23, 17, A.zone);
        if (ap.past) {
          ops.push(tekstOp(afzender, A.cx, A.y, 'tekst', ap.px, K.tekst, 'presentedBy'));
          afzHalf = Math.min(A.maxHalf, Math.max(A.half, ap.breedte / 2 + 14));
        } else {
          var apx = 20;
          var ar = breekRegels(afzender, 'tekst', apx, A.zone);
          var arB = 0;
          ar.forEach(function (r) { arB = Math.max(arB, breedte(r, 'tekst', apx)); });
          if (ar.length > 2 || arB > A.zone + 0.5) { meldingen.push({ veld: 'presentedBy', tekst: 'De naam van de afzender is te lang voor het diploma.' }); }
          ar.forEach(function (r, i) { ops.push(tekstOp(r, A.cx, A.y - (ar.length - 1 - i) * 24, 'tekst', apx, K.tekst, 'presentedBy')); });
          afzHalf = Math.min(A.maxHalf, Math.max(A.half, Math.min(arB, A.zone) / 2 + 14));
        }
      }
      ops.push(lijn(A.cx - afzHalf, A.lijnY, A.cx + afzHalf, A.lijnY, K.onderLijn, 1.4, false));

      return { ops: ops, meldingen: meldingen, decor: decoratiePlaats(), logo: { x: LOGO_X, y: C.logoY, b: LOGO_B, h: LOGO_H } };
    }

    /* ---------- inline SVG met echte tekstlagen (voorbeeld en direct printen) ---------- */

    var NS = 'http://www.w3.org/2000/svg';
    var XLINK = 'http://www.w3.org/1999/xlink';

    function el(naam, attrs) {
      var e = document.createElementNS(NS, naam);
      Object.keys(attrs || {}).forEach(function (k) { e.setAttribute(k, String(attrs[k])); });
      return e;
    }

    function f1(v) { return (Math.round(v * 100) / 100).toString(); }

    function padTekst(cmds) {
      return cmds.map(function (c) {
        if (c[0] === 'Z') { return 'Z'; }
        var n = c.slice(1).map(f1).join(' ');
        return c[0] + n;
      }).join('');
    }

    function maakSvg(g) {
      var L = maakLayout(g);
      var svg = el('svg', { viewBox: '0 0 ' + B + ' ' + H, role: 'img', focusable: 'false', preserveAspectRatio: 'xMidYMid meet' });
      svg.setAttribute('xmlns', NS);
      svg.appendChild(el('rect', { x: 0, y: 0, width: B, height: H, fill: K.papier }));
      var dec = el('image', { x: f1(L.decor.x), y: f1(L.decor.y), width: f1(L.decor.b), height: f1(L.decor.h), preserveAspectRatio: 'none' });
      dec.setAttribute('href', window.IKDMU(BEELD.decoratie));
      dec.setAttributeNS(XLINK, 'xlink:href', window.IKDMU(BEELD.decoratie));
      svg.appendChild(dec);
      var logo = el('image', { x: L.logo.x, y: L.logo.y, width: L.logo.b, height: L.logo.h, preserveAspectRatio: 'xMidYMid meet' });
      logo.setAttribute('href', window.IKDMU(BEELD.logo));
      logo.setAttributeNS(XLINK, 'xlink:href', window.IKDMU(BEELD.logo));
      svg.appendChild(logo);
      L.ops.forEach(function (op) {
        if (op.k === 't') {
          var t = el('text', { x: f1(op.cx), y: f1(op.y), 'text-anchor': 'middle', 'font-size': f1(op.px), fill: op.kleur });
          t.style.fontFamily = FONT[op.font].canvas;
          t.style.fontWeight = FONT[op.font].gewicht;
          t.style.fontKerning = 'none';
          t.style.fontFeatureSettings = '"kern" 0';
          if (op.veld) { t.setAttribute('data-field', op.veld); }
          t.textContent = op.t;
          svg.appendChild(t);
        } else if (op.k === 'l') {
          var la = { d: 'M' + f1(op.x1) + ' ' + f1(op.y1) + 'L' + f1(op.x2) + ' ' + f1(op.y2), stroke: op.kleur, 'stroke-width': op.dikte, fill: 'none', 'stroke-linecap': op.rond ? 'round' : 'butt' };
          if (op.dash) { la['stroke-dasharray'] = op.dash.join(' '); }
          svg.appendChild(el('path', la));
        } else if (op.k === 'q') {
          svg.appendChild(el('path', { d: 'M' + f1(op.x1) + ' ' + f1(op.y1) + 'Q' + f1(op.cx) + ' ' + f1(op.cy) + ' ' + f1(op.x2) + ' ' + f1(op.y2), stroke: op.kleur, 'stroke-width': op.dikte, fill: 'none', 'stroke-linecap': op.rond ? 'round' : 'butt' }));
        } else if (op.k === 'stip') {
          svg.appendChild(el('circle', { cx: f1(op.x), cy: f1(op.y), r: op.r, fill: op.kleur }));
        } else if (op.k === 'v') {
          var a = { d: padTekst(op.cmds), fill: op.vul || 'none' };
          if (op.lijn) { a.stroke = op.lijn; a['stroke-width'] = op.dikte; a['stroke-linejoin'] = 'round'; }
          if (op.lijnCap) { a['stroke-linecap'] = op.lijnCap; }
          svg.appendChild(el('path', a));
        }
      });
      return svg;
    }

    /* ---------- canvas (alleen voor de png-download en het kleine themastaal) ---------- */

    function fontTekst(f, px) { return FONT[f].gewicht + ' ' + px + 'px ' + FONT[f].canvas; }

    function tekenCanvas(canvas, g, breedtePx, beeld) {
      var L = maakLayout(g);
      var schaal = breedtePx / B;
      canvas.width = Math.round(B * schaal);
      canvas.height = Math.round(H * schaal);
      var ctx = canvas.getContext('2d');
      ctx.setTransform(canvas.width / B, 0, 0, canvas.height / H, 0, 0);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.fillStyle = K.papier;
      ctx.fillRect(0, 0, B, H);
      if (beeld && beeld.decoratie) { ctx.drawImage(beeld.decoratie, L.decor.x, L.decor.y, L.decor.b, L.decor.h); }
      if (beeld && beeld.logo) { ctx.drawImage(beeld.logo, L.logo.x, L.logo.y, L.logo.b, L.logo.h); }
      ctx.textAlign = 'left';
      ctx.textBaseline = 'alphabetic';
      if ('fontKerning' in ctx) { ctx.fontKerning = 'none'; }
      L.ops.forEach(function (op) {
        ctx.save();
        if (op.k === 't') {
          ctx.fillStyle = op.kleur;
          ctx.font = fontTekst(op.font, op.px);
          ctx.fillText(op.t, op.cx - op.b / 2, op.y);
        } else if (op.k === 'l') {
          ctx.beginPath(); ctx.moveTo(op.x1, op.y1); ctx.lineTo(op.x2, op.y2);
          if (op.dash) { ctx.setLineDash(op.dash); }
          ctx.strokeStyle = op.kleur; ctx.lineWidth = op.dikte; ctx.lineCap = op.rond ? 'round' : 'butt'; ctx.stroke();
        } else if (op.k === 'q') {
          ctx.beginPath(); ctx.moveTo(op.x1, op.y1); ctx.quadraticCurveTo(op.cx, op.cy, op.x2, op.y2);
          ctx.strokeStyle = op.kleur; ctx.lineWidth = op.dikte; ctx.lineCap = op.rond ? 'round' : 'butt'; ctx.stroke();
        } else if (op.k === 'stip') {
          ctx.beginPath(); ctx.arc(op.x, op.y, op.r, 0, Math.PI * 2); ctx.fillStyle = op.kleur; ctx.fill();
        } else if (op.k === 'v') {
          ctx.beginPath();
          op.cmds.forEach(function (c) {
            if (c[0] === 'M') { ctx.moveTo(c[1], c[2]); }
            else if (c[0] === 'L') { ctx.lineTo(c[1], c[2]); }
            else if (c[0] === 'C') { ctx.bezierCurveTo(c[1], c[2], c[3], c[4], c[5], c[6]); }
            else { ctx.closePath(); }
          });
          if (op.vul) { ctx.fillStyle = op.vul; ctx.fill(); }
          if (op.lijn) { ctx.strokeStyle = op.lijn; ctx.lineWidth = op.dikte; ctx.lineJoin = 'round'; if (op.lijnCap) { ctx.lineCap = op.lijnCap; } ctx.stroke(); }
        }
        ctx.restore();
      });
      return L;
    }

    /* ---------- pdf-inhoud (echte tekst) ---------- */

    function f3(v) { return (Math.round(v * 1000) / 1000).toString(); }
    function rgb(hex) {
      var n = parseInt(hex.slice(1), 16);
      return f3(((n >> 16) & 255) / 255) + ' ' + f3(((n >> 8) & 255) / 255) + ' ' + f3((n & 255) / 255);
    }
    function hex4(v) { return ('0000' + v.toString(16)).slice(-4); }
    var HPT = H * PT;
    function X(x) { return f3(x * PT); }
    function Y(y) { return f3(HPT - y * PT); }

    // Geeft de inhoud van de pagina, de gebruikte glyphs per lettertype en de indeling terug.
    function pdfOpdrachten(g) {
      var L = maakLayout(g);
      var gebruikt = { kop: {}, tekst: {} };
      var s = [];
      s.push(rgb(K.papier) + ' rg 0 0 ' + f3(B * PT) + ' ' + f3(HPT) + ' re f');
      s.push('q ' + f3(L.decor.b * PT) + ' 0 0 ' + f3(L.decor.h * PT) + ' ' + X(L.decor.x) + ' ' + f3(HPT - (L.decor.y + L.decor.h) * PT) + ' cm /ImDecor Do Q');
      s.push('q ' + f3(L.logo.b * PT) + ' 0 0 ' + f3(L.logo.h * PT) + ' ' + X(L.logo.x) + ' ' + f3(HPT - (L.logo.y + L.logo.h) * PT) + ' cm /ImLogo Do Q');
      L.ops.forEach(function (op) {
        if (op.k === 'l') {
          var dash = op.dash ? '[' + op.dash.map(function (v) { return f3(v * PT); }).join(' ') + '] 0 d ' : '';
          s.push('q ' + rgb(op.kleur) + ' RG ' + f3(op.dikte * PT) + ' w ' + (op.rond ? '1' : '0') + ' J ' + dash + X(op.x1) + ' ' + Y(op.y1) + ' m ' + X(op.x2) + ' ' + Y(op.y2) + ' l S Q');
        } else if (op.k === 'q') {
          var c1x = op.x1 + 2 / 3 * (op.cx - op.x1);
          var c1y = op.y1 + 2 / 3 * (op.cy - op.y1);
          var c2x = op.x2 + 2 / 3 * (op.cx - op.x2);
          var c2y = op.y2 + 2 / 3 * (op.cy - op.y2);
          s.push('q ' + rgb(op.kleur) + ' RG ' + f3(op.dikte * PT) + ' w ' + (op.rond ? '1' : '0') + ' J ' + X(op.x1) + ' ' + Y(op.y1) + ' m ' +
            X(c1x) + ' ' + Y(c1y) + ' ' + X(c2x) + ' ' + Y(c2y) + ' ' + X(op.x2) + ' ' + Y(op.y2) + ' c S Q');
        } else if (op.k === 'stip') {
          var k = 0.5523 * op.r;
          s.push('q ' + rgb(op.kleur) + ' rg ' + X(op.x + op.r) + ' ' + Y(op.y) + ' m ' +
            X(op.x + op.r) + ' ' + Y(op.y + k) + ' ' + X(op.x + k) + ' ' + Y(op.y + op.r) + ' ' + X(op.x) + ' ' + Y(op.y + op.r) + ' c ' +
            X(op.x - k) + ' ' + Y(op.y + op.r) + ' ' + X(op.x - op.r) + ' ' + Y(op.y + k) + ' ' + X(op.x - op.r) + ' ' + Y(op.y) + ' c ' +
            X(op.x - op.r) + ' ' + Y(op.y - k) + ' ' + X(op.x - k) + ' ' + Y(op.y - op.r) + ' ' + X(op.x) + ' ' + Y(op.y - op.r) + ' c ' +
            X(op.x + k) + ' ' + Y(op.y - op.r) + ' ' + X(op.x + op.r) + ' ' + Y(op.y - k) + ' ' + X(op.x + op.r) + ' ' + Y(op.y) + ' c h f Q');
        } else if (op.k === 'v') {
          var d = ['q'];
          if (op.vul) { d.push(rgb(op.vul) + ' rg'); }
          if (op.lijn) { d.push(rgb(op.lijn) + ' RG ' + f3(op.dikte * PT) + ' w 1 j 1 J'); }
          op.cmds.forEach(function (c) {
            if (c[0] === 'M') { d.push(X(c[1]) + ' ' + Y(c[2]) + ' m'); }
            else if (c[0] === 'L') { d.push(X(c[1]) + ' ' + Y(c[2]) + ' l'); }
            else if (c[0] === 'C') { d.push(X(c[1]) + ' ' + Y(c[2]) + ' ' + X(c[3]) + ' ' + Y(c[4]) + ' ' + X(c[5]) + ' ' + Y(c[6]) + ' c'); }
            else { d.push('h'); }
          });
          d.push(op.vul && op.lijn ? 'B' : (op.vul ? 'f' : 'S'));
          d.push('Q');
          s.push(d.join(' '));
        } else if (op.k === 't') {
          var t = tabel(op.font);
          var hex = '';
          Array.from(op.t).forEach(function (ch) {
            var cp = ch.codePointAt(0);
            var gl = t.cmap[cp];
            if (gl === undefined) { cp = 32; gl = t.cmap[32]; }
            gebruikt[op.font][gl] = cp;
            hex += hex4(gl);
          });
          var sleutel = op.font === 'kop' ? 'FKop' : 'FTekst';
          s.push('BT ' + rgb(op.kleur) + ' rg /' + sleutel + ' ' + f3(op.px * PT) + ' Tf 0 Tc ' + X(op.cx - op.b / 2) + ' ' + Y(op.y) + ' Td <' + hex + '> Tj ET');
        }
      });
      return { inhoud: s.join('\n'), gebruikt: gebruikt, layout: L };
    }

    return Object.freeze({
      breedte: B,
      hoogte: H,
      naamMax: NAAM_MAX,
      afzenderMax: AFZENDER_MAX,
      kleur: K,
      beeld: BEELD,
      maakLayout: maakLayout,
      maakSvg: maakSvg,
      tekenCanvas: tekenCanvas,
      pdfOpdrachten: pdfOpdrachten,
      prestatieTekst: prestatieTekst,
      onbekendeTekens: onbekendeTekens,
      decoratiePlaats: decoratiePlaats,
      meet: breedte
    });
  }

  /* ---------- gedeelde onderdelen van de configuraties ---------- */

  var GOUD_KROMME = function (K) { return [{ k: 'q', x1: 422, y1: 370, cx: 525, cy: 387, x2: 628, y2: 370, kleur: K.goud, dikte: 3, rond: true }]; };

  function basisKleur(extra) {
    var k = {
      tekst: '#243e53', label: '#617080', onderLijn: '#a5afb7', goud: '#e7bc64', wit: '#ffffff', ster: '#e5ba61',
      lintStaart: '#edca82', lintVlak: '#fff0ce'
    };
    Object.keys(extra).forEach(function (n) { k[n] = extra[n]; });
    return k;
  }

  // Kleine hulpfuncties voor de accenten (links boven het midden, op (493, 215))
  function accentPad(cmds, vul, f) {
    return { k: 'v', cmds: mapCmds(cmds, f), vul: vul, lijn: null, dikte: 0 };
  }

  // Standaardvoet voor Dinosaurus, Dieren & natuur en Ruimte: datum en afzender links van de illustratie
  // cx = midden van de voetzone (ontwerp: 365); alleen Dinosaurus staat verder naar rechts, zie daar
  function voetLinks(zone, maxHalf, cx) {
    cx = cx || 365;
    return {
      datum: { cx: cx, y: 1125, lijnY: 1145, half: 115, maxHalf: maxHalf, zone: zone },
      label: { cx: cx, y: 1212 },
      afz: { cx: cx, y: 1250, lijnY: 1270, half: 115, maxHalf: maxHalf, zone: zone }
    };
  }

  var BLOB = { soort: 'blob', top: 474, hoogte: 188, breedte: 650, zone: 560, naamOffset: -4 };
  var MIDDEN_BLOB = { zone: 620, spelPx: 28, prestPx: 28, gaps: [[80, 63, 46.6], [62, 52, 34]] };

  /* ---------- Dinosaurus v1 ---------- */

  var dinoKleur = basisKleur({ titel: '#407451', spel: '#8e6b3d', goed: '#46734d', naamVlak: '#e3efcf', papier: '#FDF9E8' });
  window.IKDinosaurus = maakThema({
    decorBestand: 'assets/dinosaurus-decoratie.png',
    decor: { b: 1055, h: 1491, inkt: { x0: 13, x1: 1036, y0: 10, y1: 1467 } },
    logoY: 91,
    kleur: dinoKleur,
    titel: 'Dinosaurusdiploma', titelPx: 60, titelY: 339, ditY: 445, ditPx: 24,
    // pootafdruk, 12 graden gekanteld om (32, 25), op (493, 215)
    accent: function (K) {
      var c = Math.cos(-12 * Math.PI / 180);
      var s = Math.sin(-12 * Math.PI / 180);
      var cmds = [['M', 20, 43], ['C', 13, 35, 5, 23, 6, 17], ['C', 7, 12, 15, 17, 23, 23], ['C', 24, 10, 27, 1, 32, 2], ['C', 37, 3, 37, 16, 38, 24],
        ['C', 48, 14, 55, 12, 57, 17], ['C', 59, 22, 47, 39, 40, 45], ['C', 33, 51, 25, 49, 20, 43], ['Z']];
      return [accentPad(cmds, '#dcb775', function (x, y) { return [493 + 32 + (x - 32) * c - (y - 25) * s, 215 + 25 + (x - 32) * s + (y - 25) * c]; })];
    },
    titelLijn: GOUD_KROMME,
    vlak: Object.assign({ max: 700 }, BLOB),
    midden: Object.assign({ lintMax: 940 }, MIDDEN_BLOB),
    band: bandOps85,
    bandTekst: { cx: 401.25, dy: 48.45, px: 37.4 },
    voet: voetLinks(240, 118, 405) // 40 eenheden naar rechts: de bladeren linksonder in de illustratie raken anders de afzenderlijn
  });

  /* ---------- Dieren & natuur v1 ---------- */

  var dierKleur = basisKleur({ titel: '#407451', spel: '#5b8b7a', goed: '#46734d', naamVlak: '#e1f0f6', papier: '#FDFCF7' });
  window.IKDieren = maakThema({
    decorBestand: 'assets/dieren-decoratie.png',
    decor: { b: 1055, h: 1491, inkt: { x0: 16, x1: 1035, y0: 17, y1: 1455 } },
    logoY: 91,
    kleur: dierKleur,
    titel: 'Dieren- & natuurdiploma', titelPx: 50, titelY: 339, ditY: 445, ditPx: 24,
    // kiemplantje met twee blaadjes op (493, 215)
    accent: function () {
      function m(x, y) { return [493 + x, 215 + y]; }
      var blad1 = [['M', 31, 34], ['C', 10, 39, 2, 20, 4, 12], ['C', 23, 9, 34, 20, 31, 34], ['Z']];
      var blad2 = [['M', 32, 25], ['C', 31, 7, 45, 1, 60, 6], ['C', 59, 20, 48, 31, 32, 25], ['Z']];
      return [
        lijn(493 + 31, 215 + 48, 493 + 31, 215 + 17, '#7c9c62', 4, true),
        accentPad(blad1, '#abd096', m),
        accentPad(blad2, '#86b17c', m)
      ];
    },
    titelLijn: GOUD_KROMME,
    vlak: Object.assign({ max: 700 }, BLOB),
    midden: Object.assign({ lintMax: 940 }, MIDDEN_BLOB),
    band: bandOps85,
    bandTekst: { cx: 401.25, dy: 48.45, px: 37.4 },
    voet: voetLinks(250, 125)
  });

  /* ---------- Ruimte v2 ---------- */

  var ruimteKleur = basisKleur({ titel: '#6f68a7', spel: '#ad6b69', goed: '#6f68a7', naamVlak: '#ece7f8', papier: '#FEFEFE' });
  window.IKRuimte = maakThema({
    decorBestand: 'assets/ruimte-decoratie.png',
    decor: { b: 1054, h: 1492, inkt: { x0: 19, x1: 1033, y0: 22, y1: 1467 } },
    logoY: 91,
    kleur: ruimteKleur,
    titel: 'Ruimtediploma', titelPx: 60, titelY: 339, ditY: 445, ditPx: 24,
    // gouden ster met twee lila stipjes op (493, 215)
    accent: function () {
      var punten = [[32, 1], [40, 18], [59, 21], [45, 34], [49, 53], [32, 44], [15, 53], [19, 34], [5, 21], [24, 18]].map(function (p) { return [493 + p[0], 215 + p[1]]; });
      return [
        vorm(veelhoek(punten), '#e7be66'),
        { k: 'stip', x: 493 + 1, y: 215 + 10, r: 3, kleur: '#b9b4da' },
        { k: 'stip', x: 493 + 65, y: 215 + 40, r: 3, kleur: '#b9b4da' }
      ];
    },
    titelLijn: GOUD_KROMME,
    vlak: Object.assign({}, BLOB, { max: 650 }),
    midden: Object.assign({ lintMax: 940 }, MIDDEN_BLOB),
    band: bandOps85,
    bandTekst: { cx: 401.25, dy: 48.45, px: 37.4 },
    voet: voetLinks(250, 125)
  });

  /* ---------- Voertuigen v5 ---------- */

  var voertKleur = basisKleur({
    titel: '#356c97', spel: '#b25e50', goed: '#356c97', naamVlak: '#fff0bd', stippel: '#e9c66e',
    lintVlak: '#e1f0f8', lintSter: '#edc468', papier: '#FEFEFE'
  });
  window.IKVoertuigen = maakThema({
    // R133: aparte versie met afgeronde weguiteinden (het origineel assets/voertuigen-decoratie.png blijft ongewijzigd bewaard)
    decorBestand: 'assets/voertuigen-decoratie-afgerond.png',
    decor: { b: 1054, h: 1492, inkt: { x0: 8, x1: 1044, y0: 69, y1: 1462 } },
    logoY: 100,
    kleur: voertKleur,
    titel: 'Voertuigendiploma', titelPx: 60, titelY: 301, ditY: 405, ditPx: 25,
    accent: function () { return []; },
    titelLijn: function () {
      return [
        lijn(469, 337, 507, 337, '#e58570', 5, true),
        lijn(520, 337, 558, 337, '#edc468', 5, true),
        lijn(571, 337, 609, 337, '#85b7aa', 5, true)
      ];
    },
    vlak: { soort: 'kaart', top: 450, hoogte: 162, breedte: 664, zone: 560, max: 700, naamOffset: -5 },
    midden: { zone: 620, spelPx: 29, prestPx: 29, gaps: [[88, 62, 85], [66, 52, 60]], lintMax: 925 },
    band: bandOpsPil,
    bandTekst: { cx: 525, dy: 60, px: 43 },
    voet: {
      datum: { cx: 345, y: 1110, lijnY: 1130, half: 120, maxHalf: 130, zone: 250 },
      label: { cx: 705, y: 1058 },
      afz: { cx: 705, y: 1110, lijnY: 1130, half: 120, maxHalf: 130, zone: 250 }
    }
  });
}());


/* ---- diploma.js ---- */
/*
 * Intellikids diploma-maker (besloten testversie, R127b; vijf kinderthema's in R127d)
 * Tekent het diploma op een canvas. Voorbeeld, afbeelding, pdf en print gebruiken allemaal
 * deze ene tekenfunctie, zodat ze er precies hetzelfde uitzien.
 *
 * Ontwerpruimte: 2100 x 2970 eenheden (A4 staand, 0,1 mm per eenheid).
 * Merkonderdelen uit de webshop (lokale themabestanden):
 *  - heuvelrand: pastelellipsen onder een golvende rand met zachte schaduw (ik-foundation.css);
 *  - onderlijntje: gele golflijn met witte stippellijn (ik-pages.css);
 *  - kleuren: merkpastels (bronpakket Huisstijl) en de navigatieaccenten van de webshop;
 *  - het echte Intellikids-logo.
 * Themavormen (golfjes, schelpen, dino, pootjes, wielen, vlaggetjes) zijn zelf getekend.
 * De panda is de vaste mascotte van de app en staat niet op het diploma.
 * Er worden geen gegevens bewaard: de functie tekent alleen wat hij meekrijgt.
 */
(function () {
  'use strict';

  var W = 2100;
  var H = 2970;

  var K = {
    inkt: '#12304A',
    inktZacht: '#4A5E66',
    geel: '#F6C567',
    geelDiep: '#EABA54',
    geelPastel: '#FEE99D',
    geelLicht: '#FCEBC4',
    koraal: '#E2685F',
    koraalDiep: '#B9463F',
    koraalPastel: '#FFB0A3',
    koraalLicht: '#FFD9D1',
    blauw: '#7FA3CC',
    blauwPastel: '#B8D8E2',
    blauwLicht: '#D9EAF0',
    groen: '#7BA872',
    groenDiep: '#2E6055',
    groenPastel: '#C7F5D9',
    groenLicht: '#DCEEDD',
    salie: '#A9C2A6',
    lila: '#A58AC7',
    lilaPastel: '#E7DAF3',
    perzik: '#F2D3B8',
    wit: '#FFFFFF'
  };

  var KOP = '"IK Nunito", "Nunito", ui-rounded, "Segoe UI", system-ui, sans-serif';
  var TEKST = '"IK Nunito Sans", "Nunito Sans", "Segoe UI", system-ui, sans-serif';
  var SIER = 'Georgia, "Iowan Old Style", "Palatino Linotype", "Book Antiqua", Palatino, "Times New Roman", serif';

  // Vormen uit de webshop (paden letterlijk overgenomen uit de themabestanden)
  var GOLF = 'M0,0 L1440,0 L1440,48 C1400,52 1330,64 1250,63 C1180,62 1130,44 1050,40 C980,37 930,60 860,70 ' +
    'C820,75 780,74 740,68 C690,61 640,36 570,30 C500,24 450,34 400,42 C360,48 330,47 300,44 C250,39 200,18 130,16 ' +
    'C80,15 40,20 0,24 Z';
  var HEUVELS = [[190, 6, 130, 34], [470, 14, 120, 34], [880, 30, 150, 68], [810, 30, 130, 56], [1170, 22, 130, 50], [1400, 18, 90, 42]];
  var ONDERLIJN = 'M5 9C45 3 70 12 118 7S196 2 235 8';

  var beeld = { logo: null, prinsesDecoratie: null, prinsesLogo: null, zeemeerminDecoratie: null, dinosaurusDecoratie: null, dierenDecoratie: null, voertuigenDecoratie: null, ruimteDecoratie: null };
  var laadBelofte = null;

  function laadBeeld(src) {
    return new Promise(function (klaar) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { klaar(img); };
      img.onerror = function () { klaar(null); };
      img.src = window.IKDMU(src);
    });
  }

  function laadAfbeeldingen() {
    if (laadBelofte) { return laadBelofte; }
    var fonts = [];
    if (document.fonts && document.fonts.load) {
      fonts = ['800 100px "IK Nunito"', '400 100px "IK Nunito Sans"', '700 100px "IK Nunito Sans"'].map(function (f) {
        return document.fonts.load(f).catch(function () { return null; });
      });
    }
    laadBelofte = Promise.all([laadBeeld('assets/logo-diploma.png'), laadBeeld('assets/prinses-decoratie.png'), laadBeeld('assets/logo-officieel.png'), laadBeeld('assets/zeemeermin-decoratie.png'), laadBeeld('assets/dinosaurus-decoratie.png'), laadBeeld('assets/dieren-decoratie.png'), laadBeeld('assets/voertuigen-decoratie-afgerond.png'), laadBeeld('assets/ruimte-decoratie.png')].concat(fonts))
      .then(function (r) { beeld.logo = r[0]; beeld.prinsesDecoratie = r[1]; beeld.prinsesLogo = r[2]; beeld.zeemeerminDecoratie = r[3]; beeld.dinosaurusDecoratie = r[4]; beeld.dierenDecoratie = r[5]; beeld.voertuigenDecoratie = r[6]; beeld.ruimteDecoratie = r[7]; });
    return laadBelofte;
  }

  /* ---------- tekenhulpen ---------- */

  function rondeRechthoek(ctx, x, y, b, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + b - r, y);
    ctx.quadraticCurveTo(x + b, y, x + b, y + r);
    ctx.lineTo(x + b, y + h - r);
    ctx.quadraticCurveTo(x + b, y + h, x + b - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
  }

  function stip(ctx, x, y, r, kleur) {
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fillStyle = kleur;
    ctx.fill();
  }

  function blad(ctx, x, y, lengte, breedte, hoek, vul, nerf) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(hoek);
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.quadraticCurveTo(lengte * 0.5, -breedte, lengte, 0);
    ctx.quadraticCurveTo(lengte * 0.5, breedte, 0, 0);
    ctx.closePath();
    ctx.fillStyle = vul;
    ctx.fill();
    if (nerf) {
      ctx.beginPath();
      ctx.moveTo(lengte * 0.1, 0);
      ctx.lineTo(lengte * 0.84, 0);
      ctx.strokeStyle = nerf;
      ctx.lineWidth = Math.max(3, breedte * 0.09);
      ctx.lineCap = 'round';
      ctx.stroke();
    }
    ctx.restore();
  }

  // takje: steel als boog met blaadjes om en om
  function takje(ctx, x, y, lengte, hoek, buiging, bladLengte, kleurA, kleurB, nerf) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(hoek);
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.quadraticCurveTo(lengte * 0.5, buiging, lengte, 0);
    ctx.strokeStyle = nerf;
    ctx.lineWidth = 7;
    ctx.lineCap = 'round';
    ctx.stroke();
    var aantal = 5;
    for (var i = 1; i <= aantal; i++) {
      var t = i / (aantal + 0.4);
      var px = lengte * t;
      var py = 2 * (1 - t) * t * buiging;
      var kant = i % 2 === 0 ? 1 : -1;
      blad(ctx, px, py, bladLengte * (1 - t * 0.35), bladLengte * 0.34 * (1 - t * 0.3), kant * 0.85 - 0.15, i % 2 ? kleurA : kleurB, nerf);
    }
    blad(ctx, lengte, 0, bladLengte * 0.8, bladLengte * 0.28, -0.05, kleurA, nerf);
    ctx.restore();
  }

  function pasLettergrootte(ctx, tekst, stijl, familie, start, minimum, maxBreedte) {
    var grootte = start;
    ctx.font = stijl + ' ' + grootte + 'px ' + familie;
    while (grootte > minimum && ctx.measureText(tekst).width > maxBreedte) {
      grootte -= 4;
      ctx.font = stijl + ' ' + grootte + 'px ' + familie;
    }
    return grootte;
  }

  function breekRegels(ctx, tekst, maxBreedte) {
    var woorden = tekst.split(' ');
    var regels = [];
    var regel = '';
    for (var i = 0; i < woorden.length; i++) {
      var proef = regel ? regel + ' ' + woorden[i] : woorden[i];
      if (ctx.measureText(proef).width <= maxBreedte || !regel) { regel = proef; } else { regels.push(regel); regel = woorden[i]; }
    }
    if (regel) { regels.push(regel); }
    return regels;
  }

  // Past de zin niet op één regel, kies dan het breekpunt met de kortste langste regel.
  function evenwichtigeRegels(ctx, tekst, maxBreedte) {
    if (ctx.measureText(tekst).width <= maxBreedte) { return [tekst]; }
    var woorden = tekst.split(' ');
    var beste = null;
    var besteBreedte = Infinity;
    for (var i = 1; i < woorden.length; i++) {
      var a = woorden.slice(0, i).join(' ');
      var b = woorden.slice(i).join(' ');
      var breedste = Math.max(ctx.measureText(a).width, ctx.measureText(b).width);
      if (breedste <= maxBreedte && breedste < besteBreedte) { besteBreedte = breedste; beste = [a, b]; }
    }
    return beste || breekRegels(ctx, tekst, maxBreedte);
  }

  // heuvelband bovenaan: pastelheuvels die onder een golvende band uitkomen (webshopkop)
  function heuvelband(ctx, band, heuvelKleuren, yTop, schaalY) {
    var sx = W / 1440;
    var pixel = ctx.getTransform().a; // schaduw is in beeldpunten, dus meeschalen met de uitvoergrootte
    HEUVELS.forEach(function (h, i) {
      ctx.beginPath();
      ctx.ellipse(h[0] * sx, yTop + h[1] * schaalY, h[2] * sx, h[3] * schaalY, 0, 0, Math.PI * 2);
      ctx.fillStyle = heuvelKleuren[i % heuvelKleuren.length];
      ctx.fill();
    });
    // eerst de golfrand met schaduw, daarna het vlak erboven zonder schaduw (voorkomt een streep)
    var golf = new Path2D();
    golf.addPath(new Path2D(GOLF), new DOMMatrix([sx, 0, 0, schaalY, 0, yTop]));
    ctx.save();
    ctx.fillStyle = band;
    ctx.shadowColor = 'rgba(138, 106, 74, 0.28)';
    ctx.shadowBlur = 40 * pixel;
    ctx.shadowOffsetY = 14 * pixel;
    ctx.fill(golf);
    ctx.restore();
    ctx.fillStyle = band;
    ctx.fillRect(0, 0, W, yTop + 6);
  }

  function onderlijntje(ctx, midden, y, breedte, kleur) {
    var s = breedte / 240;
    ctx.save();
    ctx.translate(midden - 120 * s, y - 7 * s);
    ctx.scale(s, s);
    var pad = new Path2D(ONDERLIJN);
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = kleur;
    ctx.lineWidth = 5;
    ctx.stroke(pad);
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.4)';
    ctx.lineWidth = 1.6;
    ctx.setLineDash([9, 13]);
    ctx.stroke(pad);
    ctx.restore();
  }

  /* ---------- zelfgetekende vormen voor de kinderthema's (R127d) ---------- */
  // Eenvoudige, eigen vormen: geen personages, merken, logo's of bestaande figuren.

  // pootafdruk met drie tenen; de tenen wijzen naar -y
  function voetafdruk(ctx, x, y, s, hoek, kleur) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(hoek || 0);
    ctx.fillStyle = kleur;
    ctx.beginPath();
    ctx.ellipse(0, s * 0.2, s * 0.34, s * 0.3, 0, 0, Math.PI * 2);
    ctx.fill();
    [[-0.4, -0.3, -0.5], [0, -0.48, 0], [0.4, -0.3, 0.5]].forEach(function (t) {
      ctx.save();
      ctx.translate(t[0] * s, t[1] * s);
      ctx.rotate(t[2]);
      ctx.beginPath();
      ctx.ellipse(0, 0, s * 0.13, s * 0.29, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    });
    ctx.restore();
  }

  function ei(ctx, x, y, s, vul, lijn, vlek, hoek) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(hoek || 0);
    ctx.beginPath();
    ctx.moveTo(0, -s);
    ctx.bezierCurveTo(s * 0.6, -s, s * 0.78, s * 0.15, s * 0.72, s * 0.45);
    ctx.bezierCurveTo(s * 0.64, s * 0.95, -s * 0.64, s * 0.95, -s * 0.72, s * 0.45);
    ctx.bezierCurveTo(-s * 0.78, s * 0.15, -s * 0.6, -s, 0, -s);
    ctx.closePath();
    ctx.fillStyle = vul;
    ctx.fill();
    ctx.lineWidth = s * 0.06;
    ctx.strokeStyle = lijn;
    ctx.stroke();
    [[-0.22, -0.42, 0.11], [0.26, -0.12, 0.1], [-0.2, 0.25, 0.13], [0.3, 0.42, 0.08]].forEach(function (v) {
      stip(ctx, v[0] * s, v[1] * s, v[2] * s, vlek);
    });
    ctx.restore();
  }

  // rustige dino met lange nek, voeten op (x, y); kijkt naar links als richting -1
  function dino(ctx, x, y, s, richting, kleur, buik, vlek, oog) {
    var p = new Path2D();
    p.moveTo(-1.18, -0.5);
    p.bezierCurveTo(-0.95, -0.62, -0.72, -0.98, -0.3, -0.98);
    p.bezierCurveTo(0.02, -0.98, 0.26, -0.93, 0.42, -0.86);
    p.bezierCurveTo(0.56, -1.0, 0.56, -1.42, 0.74, -1.56);
    p.bezierCurveTo(0.86, -1.67, 1.08, -1.63, 1.11, -1.5);
    p.bezierCurveTo(1.13, -1.4, 1.0, -1.36, 0.9, -1.38);
    p.bezierCurveTo(0.8, -1.3, 0.74, -1.1, 0.72, -0.86);
    p.bezierCurveTo(0.72, -0.7, 0.7, -0.52, 0.66, -0.42);
    p.lineTo(0.66, -0.07);
    p.quadraticCurveTo(0.66, 0, 0.59, 0);
    p.lineTo(0.45, 0);
    p.quadraticCurveTo(0.38, 0, 0.38, -0.07);
    p.lineTo(0.38, -0.3);
    p.bezierCurveTo(0.2, -0.26, -0.12, -0.26, -0.3, -0.3);
    p.lineTo(-0.3, -0.07);
    p.quadraticCurveTo(-0.3, 0, -0.37, 0);
    p.lineTo(-0.53, 0);
    p.quadraticCurveTo(-0.6, 0, -0.6, -0.07);
    p.lineTo(-0.6, -0.37);
    p.bezierCurveTo(-0.8, -0.42, -1.0, -0.46, -1.18, -0.5);
    p.closePath();
    ctx.save();
    ctx.translate(x, y);
    ctx.scale(s * richting, s);
    ctx.fillStyle = kleur;
    ctx.fill(p);
    // lichte buik
    ctx.beginPath();
    ctx.ellipse(0.06, -0.4, 0.42, 0.12, 0, 0, Math.PI * 2);
    ctx.fillStyle = buik;
    ctx.fill();
    // vlekjes op de rug
    [[-0.52, -0.8, 0.075, 0.05], [-0.22, -0.9, 0.085, 0.055], [0.1, -0.88, 0.075, 0.05], [0.64, -1.08, 0.045, 0.032]].forEach(function (v) {
      ctx.beginPath();
      ctx.ellipse(v[0], v[1], v[2], v[3], 0, 0, Math.PI * 2);
      ctx.fillStyle = vlek;
      ctx.fill();
    });
    // vriendelijk oog en een kleine glimlach
    ctx.beginPath();
    ctx.arc(0.97, -1.5, 0.038, 0, Math.PI * 2);
    ctx.fillStyle = oog;
    ctx.fill();
    ctx.beginPath();
    ctx.moveTo(0.98, -1.42);
    ctx.quadraticCurveTo(1.03, -1.39, 1.07, -1.43);
    ctx.lineWidth = 0.02;
    ctx.lineCap = 'round';
    ctx.strokeStyle = oog;
    ctx.stroke();
    ctx.restore();
  }

  function pootje(ctx, x, y, s, hoek, kleur) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(hoek || 0);
    ctx.fillStyle = kleur;
    ctx.beginPath();
    ctx.moveTo(0, -s * 0.1);
    ctx.bezierCurveTo(s * 0.32, -s * 0.1, s * 0.47, s * 0.3, s * 0.3, s * 0.43);
    ctx.bezierCurveTo(s * 0.16, s * 0.53, -s * 0.16, s * 0.53, -s * 0.3, s * 0.43);
    ctx.bezierCurveTo(-s * 0.47, s * 0.3, -s * 0.32, -s * 0.1, 0, -s * 0.1);
    ctx.fill();
    [[-0.44, -0.2, -0.35], [-0.16, -0.46, -0.12], [0.16, -0.46, 0.12], [0.44, -0.2, 0.35]].forEach(function (t) {
      ctx.beginPath();
      ctx.ellipse(t[0] * s, t[1] * s, s * 0.13, s * 0.17, t[2], 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.restore();
  }

  function wiel(ctx, x, y, r, band, velg) {
    stip(ctx, x, y, r, band);
    stip(ctx, x, y, r * 0.58, velg);
    for (var i = 0; i < 5; i++) {
      var a = -Math.PI / 2 + i * Math.PI * 2 / 5;
      stip(ctx, x + Math.cos(a) * r * 0.36, y + Math.sin(a) * r * 0.36, r * 0.08, band);
    }
    stip(ctx, x, y, r * 0.16, band);
  }

  // wimpel aan een stokje; voet van de stok op (x, y); richting 1 = wimpel naar rechts, -1 = naar links
  function vlaggetje(ctx, x, y, s, kleur, stok, richting) {
    var d = richting || 1;
    ctx.save();
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x, y - s);
    ctx.strokeStyle = stok;
    ctx.lineWidth = Math.max(4, s * 0.05);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x + d * s * 0.02, y - s * 0.98);
    ctx.quadraticCurveTo(x + d * s * 0.34, y - s * 0.9, x + d * s * 0.6, y - s * 0.8);
    ctx.quadraticCurveTo(x + d * s * 0.34, y - s * 0.7, x + d * s * 0.02, y - s * 0.6);
    ctx.closePath();
    ctx.fillStyle = kleur;
    ctx.fill();
    stip(ctx, x, y - s, Math.max(5, s * 0.045), stok);
    ctx.restore();
  }

  // slinger met driehoekige vlaggetjes tussen x1 en x2
  function slinger(ctx, x1, x2, y, zak, kleuren, g) {
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(x1, y);
    ctx.quadraticCurveTo((x1 + x2) / 2, y + zak * 2, x2, y);
    ctx.strokeStyle = 'rgba(18, 48, 74, 0.35)';
    ctx.lineWidth = 4;
    ctx.stroke();
    var n = Math.max(2, Math.floor((x2 - x1) / (g * 1.45)));
    for (var i = 0; i < n; i++) {
      var t = (i + 0.5) / n;
      var px = x1 + (x2 - x1) * t;
      var py = y + 4 * zak * t * (1 - t);
      ctx.beginPath();
      ctx.moveTo(px - g / 2, py);
      ctx.lineTo(px + g / 2, py);
      ctx.lineTo(px, py + g * 1.1);
      ctx.closePath();
      ctx.lineJoin = 'round';
      ctx.fillStyle = kleuren[i % kleuren.length];
      ctx.fill();
    }
    ctx.restore();
  }

  // eenvoudig speelgoedautootje, zonder merk of kenteken; wielen staan op (x, y)
  function autootje(ctx, x, y, s, kleur, raam, band, velg, licht) {
    ctx.save();
    ctx.translate(x, y);
    // cabine
    ctx.beginPath();
    ctx.moveTo(-0.52 * s, -0.6 * s);
    ctx.lineTo(-0.36 * s, -0.98 * s);
    ctx.quadraticCurveTo(-0.32 * s, -1.04 * s, -0.24 * s, -1.04 * s);
    ctx.lineTo(0.22 * s, -1.04 * s);
    ctx.quadraticCurveTo(0.3 * s, -1.04 * s, 0.35 * s, -0.98 * s);
    ctx.lineTo(0.56 * s, -0.6 * s);
    ctx.closePath();
    ctx.fillStyle = kleur;
    ctx.fill();
    // ramen
    rondeRechthoek(ctx, -0.36 * s, -0.94 * s, 0.32 * s, 0.3 * s, 0.06 * s);
    ctx.fillStyle = raam;
    ctx.fill();
    rondeRechthoek(ctx, 0.02 * s, -0.94 * s, 0.34 * s, 0.3 * s, 0.06 * s);
    ctx.fill();
    // carrosserie
    rondeRechthoek(ctx, -1.0 * s, -0.66 * s, 2.0 * s, 0.46 * s, 0.18 * s);
    ctx.fillStyle = kleur;
    ctx.fill();
    // deur en koplamp
    ctx.beginPath();
    ctx.moveTo(0, -0.62 * s);
    ctx.lineTo(0, -0.28 * s);
    ctx.lineWidth = 0.035 * s;
    ctx.lineCap = 'round';
    ctx.strokeStyle = 'rgba(18, 48, 74, 0.22)';
    ctx.stroke();
    stip(ctx, 0.9 * s, -0.5 * s, 0.07 * s, licht);
    // wielen
    wiel(ctx, -0.56 * s, -0.2 * s, 0.24 * s, band, velg);
    wiel(ctx, 0.56 * s, -0.2 * s, 0.24 * s, band, velg);
    ctx.restore();
  }

  function wolkje(ctx, x, y, s, kleur) {
    ctx.save();
    ctx.fillStyle = kleur;
    ctx.beginPath();
    ctx.arc(x - s * 0.55, y, s * 0.42, 0, Math.PI * 2);
    ctx.arc(x, y - s * 0.22, s * 0.58, 0, Math.PI * 2);
    ctx.arc(x + s * 0.6, y, s * 0.4, 0, Math.PI * 2);
    ctx.fill();
    rondeRechthoek(ctx, x - s * 0.95, y - s * 0.05, s * 1.95, s * 0.44, s * 0.22);
    ctx.fill();
    ctx.restore();
  }

  // versiering langs de boven- en onderrand (midden van het randvlak)
  function langsRand(aantal, van, tot, doe) {
    for (var i = 0; i < aantal; i++) {
      var t = (i + 0.5) / aantal;
      var x = van + t * (tot - van);
      doe(x, 87, i, true);
      doe(x, 2883, i, false);
    }
  }

  /* ---------- vijf kinderthema's (R127d), allemaal op dezelfde diploma-indeling ---------- */

  var WERELDEN = {
    dinosaurus: {
      papier: '#FFFBF3',
      randVlak: '#D5E3C2',
      rand: '#4F6B3A',
      randLijn: '#E8964A',
      stipjes: '#E8964A',
      lint: '#FCEBB6',
      lintTekst: K.inkt,
      slot: '#A34A12',
      onderlijn: '#F2B35B',
      band: function (ctx) {
        heuvelband(ctx, '#FCF1CF', ['#C9DDB0', '#F7CFA3', '#E3EDC8', '#C9DDB0', '#F7CFA3', '#FBE3A6'], 440, 1.55);
        takje(ctx, 150, 330, 380, -0.55, -50, 118, '#8BA86A', '#B5C98F', '#4F6B3A');
        takje(ctx, 1950, 330, 380, Math.PI + 0.55, 50, 118, '#8BA86A', '#B5C98F', '#4F6B3A');
        [[390, 372, 1.3], [470, 306, 1.1], [552, 372, 1.3], [634, 306, 1.1]].forEach(function (v) {
          voetafdruk(ctx, v[0], v[1], 44, v[2], 'rgba(79, 107, 58, 0.5)');
        });
        ei(ctx, 1560, 360, 38, '#FFF4DC', '#E8964A', '#E8964A', -0.15);
        ei(ctx, 1640, 372, 30, '#FFF4DC', '#E8964A', '#8BA86A', 0.2);
        [[1480, 250, 9, '#E8964A'], [1720, 230, 7, '#8BA86A'], [600, 200, 8, '#E8964A']].forEach(function (d) { stip(ctx, d[0], d[1], d[2], d[3]); });
      },
      randVersier: function (ctx) {
        langsRand(28, 170, 1930, function (x, y, i, boven) {
          if (boven) { stip(ctx, x, y, 6, i % 2 ? '#E8964A' : '#FFFFFF'); }
          else if (i % 2 === 0) { voetafdruk(ctx, x, y + (i % 4 ? 6 : -6), 22, 1.57, '#4F6B3A'); }
        });
      },
      zij: function (ctx) {
        ei(ctx, 238, 1210, 26, '#FFF4DC', '#E8964A', '#E8964A', -0.2);
        blad(ctx, 214, 1560, 70, 24, 0.9, '#8BA86A', '#4F6B3A');
        blad(ctx, 1886, 1210, 70, 24, Math.PI - 0.9, '#8BA86A', '#4F6B3A');
        ei(ctx, 1860, 1560, 26, '#FFF4DC', '#E8964A', '#8BA86A', 0.2);
      },
      zegel: function (ctx) {
        ctx.beginPath();
        ctx.ellipse(1650, 2786, 300, 46, 0, 0, Math.PI * 2);
        ctx.fillStyle = '#FBE3A6';
        ctx.fill();
        blad(ctx, 1860, 2770, 120, 38, -1.9, '#B5C98F', '#4F6B3A');
        blad(ctx, 1872, 2772, 104, 34, -1.2, '#8BA86A', '#4F6B3A');
        dino(ctx, 1664, 2786, 232, -1, '#7E9A55', '#C9DDB0', '#E8964A', '#2B3A1F');
        ei(ctx, 1392, 2742, 46, '#FFF4DC', '#E8964A', '#E8964A', -0.12);
      }
    },

    dieren: {
      papier: '#F8FBF3',
      randVlak: '#CFE2CC',
      rand: K.groenDiep,
      randLijn: '#8FC0D6',
      stipjes: K.groen,
      lint: K.blauwLicht,
      lintTekst: K.inkt,
      slot: K.groenDiep,
      onderlijn: K.geel,
      band: function (ctx) {
        var g = ctx.createLinearGradient(0, 110, 0, 560);
        g.addColorStop(0, '#D3E9F3');
        g.addColorStop(1, '#EAF5F8');
        heuvelband(ctx, g, [K.groenPastel, '#B9D6B4', K.salie, K.groenPastel, '#B9D6B4', K.groenLicht], 440, 1.55);
        // zon met stralen rechtsboven in de lucht
        ctx.save();
        ctx.translate(1770, 250);
        for (var i = 0; i < 12; i++) {
          ctx.rotate(Math.PI / 6);
          rondeRechthoek(ctx, -9, -128, 18, 40, 9);
          ctx.fillStyle = K.geelDiep;
          ctx.fill();
        }
        ctx.restore();
        stip(ctx, 1770, 250, 76, K.geel);
        stip(ctx, 1770, 250, 50, K.geelPastel);
        wolkje(ctx, 470, 205, 70, 'rgba(255, 255, 255, 0.92)');
        wolkje(ctx, 1560, 330, 46, 'rgba(255, 255, 255, 0.88)');
        takje(ctx, 150, 330, 360, -0.55, -50, 110, K.groen, K.salie, K.groenDiep);
      },
      randVersier: function (ctx) {
        langsRand(16, 150, 1950, function (x, y, i, boven) {
          if (boven) { blad(ctx, x - 22, y, 44, 13, 0, i % 2 ? K.groen : K.groenDiep, null); }
          else { pootje(ctx, x, y + (i % 2 ? 5 : -5), 26, 1.57, K.groenDiep); }
        });
      },
      zij: function (ctx) {
        pootje(ctx, 238, 1190, 38, -0.35, 'rgba(46, 96, 85, 0.8)');
        blad(ctx, 214, 1560, 70, 24, 0.9, K.groen, K.groenDiep);
        blad(ctx, 1886, 1190, 70, 24, Math.PI - 0.9, K.groen, K.groenDiep);
        pootje(ctx, 1860, 1560, 38, 0.35, 'rgba(46, 96, 85, 0.8)');
      },
      zegel: function (ctx) {
        ctx.save();
        ctx.translate(1620, 2380);
        for (var i = 0; i < 14; i++) {
          ctx.rotate(Math.PI / 7);
          rondeRechthoek(ctx, -21, -318, 42, 104, 21);
          ctx.fillStyle = K.geelDiep;
          ctx.fill();
        }
        ctx.restore();
        stip(ctx, 1620, 2380, 196, K.geel);
        stip(ctx, 1620, 2380, 150, K.geelPastel);
        pootje(ctx, 1620, 2392, 190, 0, K.groenDiep);
        takje(ctx, 1608, 2700, 290, Math.PI + 0.22, 60, 92, K.groen, K.salie, K.groenDiep);
        takje(ctx, 1632, 2700, 290, -0.22, -60, 92, K.groen, K.salie, K.groenDiep);
      }
    },

    voertuigen: {
      papier: '#F9FBFD',
      randVlak: '#D2E3F1',
      rand: '#2C5B87',
      randLijn: '#F2C04F',
      stipjes: '#6D98C7',
      lint: K.geelLicht,
      lintTekst: K.inkt,
      slot: '#1F4E79',
      onderlijn: K.geel,
      band: function (ctx) {
        var g = ctx.createLinearGradient(0, 110, 0, 560);
        g.addColorStop(0, '#D3E5F3');
        g.addColorStop(1, '#E9F2FA');
        heuvelband(ctx, g, ['#CFE8D8', '#FBD2C9', '#FDEBB5', '#CFE8D8', '#FBD2C9', '#FDEBB5'], 440, 1.55);
        slinger(ctx, 150, 640, 150, 34, ['#F08B7F', '#F6C567', '#7BA872', '#7FA3CC'], 44);
        slinger(ctx, 1460, 1950, 150, 34, ['#7FA3CC', '#7BA872', '#F6C567', '#F08B7F'], 44);
        wolkje(ctx, 420, 350, 52, 'rgba(255, 255, 255, 0.9)');
        wolkje(ctx, 1690, 345, 60, 'rgba(255, 255, 255, 0.9)');
      },
      randVersier: function (ctx) {
        // wegmarkering: witte streepjes midden op de rand
        ctx.save();
        rondeRechthoek(ctx, 87, 87, W - 174, H - 174, 94);
        ctx.setLineDash([46, 34]);
        ctx.lineWidth = 9;
        ctx.lineCap = 'round';
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.95)';
        ctx.stroke();
        ctx.restore();
      },
      zij: function (ctx) {
        wiel(ctx, 236, 1200, 22, '#2C3E50', '#DDE6EE');
        vlaggetje(ctx, 222, 1610, 90, '#7BA872', '#2C5B87', 1);
        vlaggetje(ctx, 1878, 1250, 90, '#F08B7F', '#2C5B87', -1);
        wiel(ctx, 1864, 1580, 22, '#2C3E50', '#DDE6EE');
      },
      zegel: function (ctx) {
        // stukje weg met wegmarkering
        rondeRechthoek(ctx, 1330, 2700, 590, 96, 48);
        ctx.fillStyle = '#5E7488';
        ctx.fill();
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(1380, 2748);
        ctx.lineTo(1870, 2748);
        ctx.setLineDash([44, 30]);
        ctx.lineWidth = 9;
        ctx.lineCap = 'round';
        ctx.strokeStyle = '#F6C567';
        ctx.stroke();
        ctx.restore();
        autootje(ctx, 1580, 2736, 180, '#F08B7F', '#D9EAF0', '#2C3E50', '#DDE6EE', '#F6C567');
        vlaggetje(ctx, 1880, 2700, 300, '#7BA872', '#2C5B87', -1);
        stip(ctx, 1400, 2380, 12, '#F6C567');
        stip(ctx, 1720, 2330, 9, '#7FA3CC');
      }
    }
  };

  /* ---------- het diploma ---------- */

  // Thema's met een eigen indeling en echte tekstlagen: Prinses (js/prinses.js, R128 t/m R130) en Zeemeermin
  // (js/zeemeermin.js, R131). Alle andere thema's tekenen met de canvasfunctie hieronder.
  var TEKSTTHEMAS = {
    prinses: { mod: 'IKPrinses', decor: 'prinsesDecoratie' },
    zeemeermin: { mod: 'IKZeemeermin', decor: 'zeemeerminDecoratie' },
    // R132: gedeelde motor met een eigen configuratie per thema (js/tekstthemas.js)
    dinosaurus: { mod: 'IKDinosaurus', decor: 'dinosaurusDecoratie' },
    dieren: { mod: 'IKDieren', decor: 'dierenDecoratie' },
    voertuigen: { mod: 'IKVoertuigen', decor: 'voertuigenDecoratie' },
    ruimte: { mod: 'IKRuimte', decor: 'ruimteDecoratie' }
  };
  function tekstThema(t) { return Object.prototype.hasOwnProperty.call(TEKSTTHEMAS, t) ? TEKSTTHEMAS[t] : null; }

  function themaGegevens(g) {
    return {
      childName: g.voornaam || '',
      gameName: g.spelNaam || '',
      achievement: window[tekstThema(g.thema).mod].prestatieTekst(g.zin),
      date: g.datumTekst || '',
      presentedBy: g.afzender || '',
      naamIsPlaatshouder: !!g.naamIsPlaatshouder
    };
  }

  function teken(canvas, g, breedtePx) {
    var tt = tekstThema(g.thema);
    if (tt) {
      window[tt.mod].tekenCanvas(canvas, themaGegevens(g), breedtePx, { decoratie: beeld[tt.decor], logo: beeld.prinsesLogo });
      return canvas;
    }
    var w = WERELDEN[g.thema] || WERELDEN.dieren;
    var schaal = breedtePx / W;
    canvas.width = Math.round(W * schaal);
    canvas.height = Math.round(H * schaal);
    var ctx = canvas.getContext('2d');
    ctx.setTransform(schaal, 0, 0, schaal, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    // papier en rijke rand
    ctx.fillStyle = w.papier;
    ctx.fillRect(0, 0, W, H);
    rondeRechthoek(ctx, 64, 64, W - 128, H - 128, 110);
    ctx.fillStyle = w.randVlak;
    ctx.fill();
    rondeRechthoek(ctx, 110, 110, W - 220, H - 220, 78);
    ctx.fillStyle = w.papier;
    ctx.fill();

    // band bovenaan, binnen de rand
    ctx.save();
    rondeRechthoek(ctx, 110, 110, W - 220, H - 220, 78);
    ctx.clip();
    w.band(ctx);
    ctx.restore();

    w.randVersier(ctx);
    rondeRechthoek(ctx, 64, 64, W - 128, H - 128, 110);
    ctx.lineWidth = 10;
    ctx.strokeStyle = w.rand;
    ctx.stroke();
    rondeRechthoek(ctx, 110, 110, W - 220, H - 220, 78);
    ctx.lineWidth = 4;
    ctx.strokeStyle = w.randLijn;
    ctx.stroke();

    // stippellijn binnen het papier (onder de band)
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(150, 700);
    ctx.lineTo(150, H - 190);
    ctx.quadraticCurveTo(150, H - 150, 190, H - 150);
    ctx.lineTo(W - 190, H - 150);
    ctx.quadraticCurveTo(W - 150, H - 150, W - 150, H - 190);
    ctx.lineTo(W - 150, 700);
    ctx.setLineDash([0.1, 30]);
    ctx.lineCap = 'round';
    ctx.lineWidth = 10;
    ctx.strokeStyle = w.stipjes;
    ctx.globalAlpha = 0.55;
    ctx.stroke();
    ctx.restore();

    // zijaccenten in het thema
    w.zij(ctx);

    // logo in de band
    if (beeld.logo) {
      var lb = 680;
      var lh = lb * (beeld.logo.naturalHeight / beeld.logo.naturalWidth);
      ctx.drawImage(beeld.logo, W / 2 - lb / 2, 231, lb, lh);
    }

    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';

    // titel
    ctx.fillStyle = K.inkt;
    ctx.font = '800 250px ' + KOP;
    ctx.fillText('Diploma', W / 2, 860);

    // lint met de naam van het spel
    var lintTekst = (g.spelNaam || '').toUpperCase();
    ctx.font = '800 64px ' + KOP;
    var lintBreedte = Math.min(ctx.measureText(lintTekst).width + 180, 1500);
    rondeRechthoek(ctx, W / 2 - lintBreedte / 2, 905, lintBreedte, 118, 59);
    ctx.fillStyle = w.lint;
    ctx.fill();
    ctx.fillStyle = w.lintTekst;
    pasLettergrootte(ctx, lintTekst, '800', KOP, 64, 42, lintBreedte - 120);
    ctx.fillText(lintTekst, W / 2, 986);

    // voornaam (in het voorbeeld zonder naam: lichte plaatshouder)
    var naam = g.voornaam || '';
    ctx.fillStyle = K.inkt;
    if (g.naamIsPlaatshouder) { ctx.globalAlpha = 0.32; }
    var naamGrootte = pasLettergrootte(ctx, naam, 'italic 700', SIER, 240, 120, 1560);
    ctx.fillText(naam, W / 2, 1320 + (240 - naamGrootte) * 0.3);
    ctx.globalAlpha = 1;
    onderlijntje(ctx, W / 2, 1402, 980, w.onderlijn);

    // zin, verdeeld over evenwichtige regels
    var zin = g.zin || '';
    var zinGrootte = 90;
    var regels;
    while (true) {
      ctx.font = '700 ' + zinGrootte + 'px ' + TEKST;
      regels = evenwichtigeRegels(ctx, zin, 1480);
      if (regels.length <= 3 || zinGrootte <= 62) { break; }
      zinGrootte -= 6;
    }
    var regelHoogte = Math.round(zinGrootte * 1.3);
    var yZin = 1585;
    ctx.fillStyle = K.inkt;
    regels.forEach(function (r, i) { ctx.fillText(r, W / 2, yZin + i * regelHoogte); });

    // aanmoediging met twee stipjes
    var yAanmoediging = yZin + regels.length * regelHoogte + 185;
    ctx.font = '800 118px ' + KOP;
    ctx.fillStyle = w.slot;
    ctx.fillText('Goed gedaan!', W / 2, yAanmoediging);
    var bw = ctx.measureText('Goed gedaan!').width;
    stip(ctx, W / 2 - bw / 2 - 60, yAanmoediging - 38, 13, w.stipjes);
    stip(ctx, W / 2 + bw / 2 + 60, yAanmoediging - 38, 13, w.stipjes);

    // datum en ondertekening, linksonder
    ctx.textAlign = 'left';
    ctx.fillStyle = K.inktZacht;
    ctx.font = '700 52px ' + TEKST;
    ctx.fillText('Datum', 300, 2380);
    ctx.fillStyle = K.inkt;
    ctx.font = '700 76px ' + TEKST;
    ctx.fillText(g.datumTekst || '', 300, 2470);
    ctx.fillStyle = K.inktZacht;
    ctx.font = '700 52px ' + TEKST;
    ctx.fillText('Uitgereikt door', 300, 2612);
    ctx.beginPath();
    ctx.moveTo(300, 2742);
    ctx.lineTo(1090, 2742);
    ctx.lineWidth = 5;
    ctx.strokeStyle = K.inktZacht;
    ctx.stroke();

    // beloning rechtsonder
    ctx.textAlign = 'center';
    w.zegel(ctx);

    return canvas;
  }

  /* ---------- pdf van de thema's met echte tekst: ingesloten lettertypes, JPEG-decoratie, logo met doorzichtigheid ---------- */

  function beeldNaarCanvas(img) {
    var c = document.createElement('canvas');
    c.width = img.naturalWidth;
    c.height = img.naturalHeight;
    return c;
  }

  function jpegBytes(img, kwaliteit) {
    var c = beeldNaarCanvas(img);
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.drawImage(img, 0, 0);
    return new Promise(function (ok, fout) {
      c.toBlob(function (b) {
        wis(c);
        if (!b) { fout(new Error('leeg')); return; }
        b.arrayBuffer().then(function (buf) { ok(new Uint8Array(buf)); }, fout);
      }, 'image/jpeg', kwaliteit);
    });
  }

  function deflate(bytes) {
    if (typeof CompressionStream === 'undefined') { return Promise.resolve(null); }
    var cs = new CompressionStream('deflate');
    var schrijver = cs.writable.getWriter();
    schrijver.write(bytes);
    schrijver.close();
    return new Response(cs.readable).arrayBuffer().then(function (buf) { return new Uint8Array(buf); });
  }

  // Het logo blijft het originele bestand: rood-geel-groen-blauw in kleur, met zijn eigen doorzichtigheid.
  function logoVoorPdf(img) {
    var c = beeldNaarCanvas(img);
    var ctx = c.getContext('2d');
    ctx.drawImage(img, 0, 0);
    var data = ctx.getImageData(0, 0, c.width, c.height).data;
    var n = c.width * c.height;
    var rgb = new Uint8Array(n * 3);
    var alfa = new Uint8Array(n);
    for (var i = 0, p = 0; i < n; i++, p += 4) {
      rgb[i * 3] = data[p]; rgb[i * 3 + 1] = data[p + 1]; rgb[i * 3 + 2] = data[p + 2]; alfa[i] = data[p + 3];
    }
    var b = c.width;
    var h = c.height;
    wis(c);
    return Promise.all([deflate(rgb), deflate(alfa)]).then(function (r) {
      if (!r[0] || !r[1]) { return jpegBytes(img, 0.95).then(function (j) { return { soort: 'jpeg', bytes: j, b: b, h: h }; }); }
      return { soort: 'rgb', bytes: r[0], alfa: r[1], b: b, h: h };
    });
  }

  function maakTekstPdf(g) {
    var tt = tekstThema(g.thema);
    var P = window[tt.mod];
    var F = window.IKPdfFonts;
    var o = P.pdfOpdrachten(themaGegevens(g));
    var dec = beeld[tt.decor];
    return Promise.all([jpegBytes(dec, 0.9), logoVoorPdf(beeld.prinsesLogo)]).then(function (r) {
      var afbeeldingen = [
        { sleutel: 'ImDecor', soort: 'jpeg', bytes: r[0], b: dec.naturalWidth, h: dec.naturalHeight },
        { sleutel: 'ImLogo', soort: r[1].soort, bytes: r[1].bytes, alfa: r[1].alfa, b: r[1].b, h: r[1].h }
      ];
      var fonts = [
        { sleutel: 'FKop', def: F.kop, gebruikt: o.gebruikt.kop },
        { sleutel: 'FTekst', def: F.tekst, gebruikt: o.gebruikt.tekst }
      ];
      return window.IKPdf.maakPdfMetTekst({ titel: 'Diploma Intellikids', inhoud: o.inhoud, fonts: fonts, afbeeldingen: afbeeldingen });
    });
  }

  function wis(canvas) {
    if (!canvas) { return; }
    var ctx = canvas.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvas.width = 1;
    canvas.height = 1;
  }

  window.IKDiploma = Object.freeze({
    breedte: W,
    hoogte: H,
    laadAfbeeldingen: laadAfbeeldingen,
    teken: teken,
    maakTekstPdf: maakTekstPdf,
    themaGegevens: themaGegevens,
    heeftTekstlagen: function (thema) { return !!tekstThema(thema); },
    tekstMeldingen: function (g) { return window[tekstThema(g.thema).mod].maakLayout(themaGegevens(g)).meldingen; },
    wis: wis
  });
}());


/* ---- inschrijving.js ---- */
/*
 * Intellikids diploma-maker (besloten testversie, R134): vrijwillige e-mailinschrijving, lokale voorbereiding.
 *
 * Wat dit bestand wel en niet doet:
 * - Het blok is vrijwillig en staat los van de diploma-acties: downloaden en printen werken ook zonder, of met een defect, blok.
 * - Er gaat niets weg zolang niemand op "Houd mij op de hoogte" klikt met een geldig adres en het (standaard uitgezette) vinkje.
 *   Typen, downloaden, printen of het vinkje aanzetten versturen niets.
 * - Er is hier GEEN echte koppeling. Zonder adapter zegt het blok eerlijk dat het nog niet is aangesloten; het toont dan nooit een
 *   inschrijfbevestiging. Een (lokale) testvoorziening kan via zetAdapter() worden aangesloten; die meldt zich als test.
 * - Er zit geen geheime sleutel in de browsercode. Een echte koppeling hoort server-side te lopen (zie docs/R134-...).
 * - Het e-mailadres komt niet in de URL, de paginatitel, de console of opslag. Er gaat geen diploma-inhoud mee
 *   (geen naam, spel, activiteit, datum of afzender).
 *
 * Contract van een adapter: { echt: boolean, verstuur(inzending, opties) -> Promise<{ status: 'ontvangen' | 'fout' }> }
 *   inzending = { email, toestemming: true, toestemmingstekst, toestemmingsversie, bron }
 *   opties = { signal, voortgang }: voortgang('beveiliging') meldt dat de winkel een controle vraagt; een adapter mag ook { status: 'geblokkeerd' } teruggeven (venster geblokkeerd) en tijdlimietMs instellen;
 *   signal is een AbortSignal dat bij een reset of time-out wordt afgebroken (een adapter mag dat gebruiken om het verzoek te annuleren)
 *   Het tijdstip van toestemming zet de server bij ontvangst (betrouwbaarder dan de klok van het apparaat).
 *
 * Late antwoorden (R135): elke aanvraag krijgt een aanvraagnummer; een reset ("Maak nog een diploma", verlaten van de pagina) en elke
 * nieuwe aanvraag maken alle eerdere nummers ongeldig, samen met hun timers. Een succes, fout of time-out van een oude aanvraag wordt
 * genegeerd en verandert nooit de invoer, de toestemming, de knop of de melding van een nieuwere aanvraag. Annuleren via het signaal is
 * een extra, niet het enige vangnet. De adapter wordt per aanvraag vastgelegd, ook als er intussen een andere wordt ingesteld.
 */
(function () {
  'use strict';

  var PRIVACY_URL = 'https://www.intellikids.nl/pages/privacyverklaring'; // bestaande privacyverklaring van de webshop
  var BRON = 'diploma-maker';
  var TOESTEMMING_VERSIE = 'diploma-maker-toestemming-concept-1'; // concept: tekst en versie vragen om juridische goedkeuring
  var EMAIL_MAX = 254;
  var TIJDLIMIET_MS = 20000; // een voorziening die niet antwoordt, geeft na 20 seconden een nette foutmelding

  var adapter = null; // standaard: niet aangesloten
  var el = {};
  var teller = 0; // aanvraagnummer: elke nieuwe aanvraag en elke reset verhoogt hem
  var lopend = null; // { timer, controller } van de actuele aanvraag

  function heeftAdres(v) { return String(v || '').trim().length > 0; }

  // Bewust eenvoudig: één @, een punt in het domein, geen spaties of dubbele punten. De echte controle is de bevestigingsmail.
  function geldigAdres(v) {
    v = String(v || '').trim();
    if (!v || v.length > EMAIL_MAX || /\s/.test(v)) { return false; }
    var delen = v.split('@');
    if (delen.length !== 2 || !delen[0] || !delen[1] || delen[0].length > 64) { return false; }
    if (delen[1].indexOf('..') !== -1 || delen[0].indexOf('..') !== -1) { return false; }
    if (delen[0].charAt(0) === '.' || delen[0].charAt(delen[0].length - 1) === '.') { return false; }
    return /^[^\s@.][^\s@]*\.[^\s@.]{2,}$/.test(delen[1]) && delen[1].charAt(delen[1].length - 1) !== '.';
  }

  function zetFout(veld, tekst) {
    var fout = document.getElementById('inschrijf-fout-' + veld);
    var invoer = veld === 'email' ? el.email : el.toestemming;
    if (fout) { fout.textContent = tekst; fout.hidden = !tekst; }
    if (invoer) { if (tekst) { invoer.setAttribute('aria-invalid', 'true'); } else { invoer.removeAttribute('aria-invalid'); } }
  }

  function zetStatus(tekst, soort) {
    el.status.textContent = tekst;
    el.status.hidden = !tekst;
    el.status.setAttribute('data-soort', soort || '');
  }

  // Testmarkering: zonder koppeling (of met een testvoorziening) de standaardtekst uit de pagina; bij een echte koppeling alleen de tekst
  // die de koppeling zelf opgeeft (bijvoorbeeld "wordt nog getest"), en niets zodra de werking is aangetoond.
  var STANDAARD_MARKERING = null;
  function toonTestlabel() {
    if (STANDAARD_MARKERING === null) { STANDAARD_MARKERING = el.test.textContent; }
    var tekst = STANDAARD_MARKERING;
    if (adapter && adapter.echt === true) { tekst = typeof adapter.markering === 'string' ? adapter.markering : ''; }
    el.test.textContent = tekst;
    el.test.hidden = !tekst;
  }

  function stopLopend() {
    if (!lopend) { return; }
    clearTimeout(lopend.timer);
    try { lopend.controller.abort(); } catch (e) { /* annuleren is een extra, geen eis */ }
    lopend = null;
  }

  function reset() {
    teller++; // alle eerdere aanvragen en hun timers zijn hiermee ongeldig
    stopLopend();
    if (!el.email) { return; }
    el.email.value = '';
    el.toestemming.checked = false;
    zetFout('email', '');
    zetFout('toestemming', '');
    zetStatus('', '');
    el.knop.disabled = false;
    el.knop.removeAttribute('aria-busy');
  }

  function controleer() {
    var gelukt = true;
    var eerste = null;
    var adres = el.email.value.trim();
    if (!heeftAdres(adres)) { zetFout('email', 'Vul je e-mailadres in.'); gelukt = false; eerste = eerste || el.email; }
    else if (!geldigAdres(adres)) { zetFout('email', 'Controleer je e-mailadres. Het lijkt niet te kloppen.'); gelukt = false; eerste = eerste || el.email; }
    else { zetFout('email', ''); }
    if (!el.toestemming.checked) { zetFout('toestemming', 'Zet het vinkje aan als je e-mails wilt ontvangen.'); gelukt = false; eerste = eerste || el.toestemming; }
    else { zetFout('toestemming', ''); }
    if (eerste) { eerste.focus(); }
    return gelukt;
  }

  function verstuur() {
    if (lopend) { return; }
    zetStatus('', '');
    if (!controleer()) { return; }
    if (!adapter) {
      // Niets aangesloten: eerlijk melden, niets versturen en geen bevestiging tonen.
      zetStatus('Aanmelden is in deze testversie nog niet aangesloten. Er is niets verstuurd.', 'info');
      return;
    }
    var nr = ++teller;
    var gekozen = adapter; // per aanvraag vastgelegd
    var controller = typeof AbortController === 'function' ? new AbortController() : { abort: function () {}, signal: undefined };
    var mijn = { timer: null, controller: controller };
    lopend = mijn;
    el.knop.disabled = true;
    el.knop.setAttribute('aria-busy', 'true');
    var inzending = {
      email: el.email.value.trim(),
      toestemming: true,
      toestemmingstekst: el.toestemmingTekst.textContent.trim(),
      toestemmingsversie: TOESTEMMING_VERSIE,
      bron: BRON
    };
    var klaar = function (uitkomst) {
      if (nr !== teller || lopend !== mijn) { return; } // verouderd antwoord of verouderde timer: negeren
      clearTimeout(mijn.timer);
      lopend = null;
      el.knop.disabled = false;
      el.knop.removeAttribute('aria-busy');
      if (uitkomst && uitkomst.status === 'geenopslag') {
        zetStatus('Je browser kan je diploma niet tijdelijk bewaren tijdens het aanmelden. Download of print eerst je diploma en probeer het daarna opnieuw. Er is niets verstuurd.', 'fout');
        return;
      }
      if (uitkomst && uitkomst.status === 'onbekend') {
        zetStatus('We konden niet bevestigen dat je aanmelding is gelukt. Probeer het niet meteen opnieuw; controleer later je mailbox.', 'info');
        return;
      }
      if (uitkomst && (uitkomst.status === 'ontvangen' || uitkomst.status === 'bevestiging')) {
        // alleen wissen wat bij deze aanvraag hoort; is er intussen iets anders getypt, dan blijft dat staan
        if (el.email.value.trim() === inzending.email) { el.email.value = ''; el.toestemming.checked = false; }
        // alleen de werkelijke status melden: een echte koppeling zegt "ontvangen" of "bevestiging nodig", een testvoorziening meldt zich als test
        zetStatus(gekozen.echt !== true
          ? 'Testmelding: de testvoorziening heeft deze aanmelding ontvangen. Er is geen echte e-mail verstuurd.'
          : (uitkomst.status === 'bevestiging'
            ? 'Bijna klaar. Bevestig je aanmelding via de e-mail die we je sturen. Pas daarna ontvang je onze e-mails.'
            : 'We hebben je aanmelding ontvangen.'), 'ok');
      } else if (uitkomst && uitkomst.status === 'geblokkeerd') {
        zetStatus('Je browser blokkeerde het kleine venster voor de aanmelding. Sta pop-ups toe voor deze pagina en probeer het opnieuw. Er is niets verstuurd.', 'fout');
      } else {
        zetStatus('Aanmelden lukte nu niet. Je diploma blijft gewoon werken. Probeer het later nog eens.', 'fout');
      }
    };
    mijn.timer = setTimeout(function () {
      if (nr === teller && lopend === mijn) { try { controller.abort(); } catch (e) { /* extra */ } }
      klaar({ status: 'fout' });
    }, (gekozen && gekozen.tijdlimietMs) || TIJDLIMIET_MS);
    var geval;
    try { geval = Promise.resolve(gekozen.verstuur.call(gekozen, inzending, { signal: controller.signal, voortgang: function (soort) {
      if (nr !== teller || lopend !== mijn) { return; }
      if (soort === 'beveiliging') { zetStatus('Shopify vraagt een beveiligingscontrole. Rond die af in het geopende venster; het sluit daarna vanzelf. Je aanmelding is pas vastgelegd als die controle is geslaagd.', 'info'); }
    } })); } catch (e) { geval = Promise.reject(e); }
    geval.then(klaar, function () { klaar({ status: 'fout' }); });
  }

  function init() {
    el.blok = document.getElementById('inschrijving');
    if (!el.blok) { return; }
    el.test = document.getElementById('inschrijving-test');
    el.email = document.getElementById('inschrijf-email');
    el.toestemming = document.getElementById('inschrijf-toestemming');
    el.toestemmingTekst = el.blok.querySelector('.vink__tekst');
    el.knop = document.getElementById('inschrijf-knop');
    el.status = document.getElementById('inschrijf-status');
    toonTestlabel();
    el.knop.addEventListener('click', verstuur);
    el.email.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); verstuur(); } });
    el.email.addEventListener('input', function () { if (el.email.getAttribute('aria-invalid') === 'true') { zetFout('email', ''); } zetStatus('', ''); });
    el.toestemming.addEventListener('change', function () { if (el.toestemming.checked) { zetFout('toestemming', ''); } zetStatus('', ''); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  window.IKInschrijving = Object.freeze({
    reset: reset,
    meld: function (tekst, soort) { if (el.status) { zetStatus(tekst, soort || 'ok'); } },
    zetAdapter: function (a) { adapter = a || null; toonTestlabel(); },
    geldigAdres: geldigAdres,
    privacyUrl: PRIVACY_URL,
    toestemmingsversie: TOESTEMMING_VERSIE,
    bron: BRON
  });
}());


/* ---- koppeling met Shopify ---- */
/*
 * Koppeling van het vrijwillige inschrijfblok met Shopify (R137).
 * Gebruikt de standaardroute van Shopify voor nieuwsbriefaanmeldingen: het formulier {% form 'customer' %} (POST /contact), dezelfde route als
 * het nieuwsbriefformulier in de footer. Shopify maakt of werkt de klant bij en registreert de e-mailmarketingtoestemming.
 * Er is geen eigen backend, geen tweede database en geen sleutel in de browser. Er gaat uitsluitend mee: het e-mailadres, de tags
 * (newsletter, bronlabel, versie van de toestemmingstekst) en het door Shopify zelf aangemaakte beveiligingstoken. Nooit diplomagegevens.
 *
 * Beveiliging (Shopify CAPTCHA, hCaptcha): bij de klik van de ouder (na geldig adres en vinkje) wordt het formulier met de officiële methode
 * window.Shopify.captcha.protect() gekoppeld; daarna doet de pagina de gewone, native formulierverzending van Shopify (form.submit()) in
 * hetzelfde tabblad, naar de ongewijzigde formulieractie (/contact). Shopify voert zelf de beveiliging uit en toont zo nodig zelf een
 * interactieve controle. Geen venster, geen omleiding van de actie en geen overhevelen van het token.
 *
 * Omdat Shopify de pagina daarbij even verlaat, bewaart de maker vlak vóór het verzenden de invoer van de ouder (spel, activiteit, naam, datum,
 * afzender, thema) in sessionStorage van dit tabblad (tijdelijke lokale browseropslag). Dat blijft op het apparaat en wordt niet verzonden.
 * Gewist wordt het: bij elke start van de maker (herstellen alleen binnen 30 minuten na het verzenden en alleen na terugkeer of Terug), bij een
 * mislukte of afgebroken aanvraag, bij Maak nog een diploma, en uiterlijk als het tabblad wordt gesloten. Het wordt NIET na 30 minuten vanzelf
 * gewist: verlaat de ouder de maker zonder terug te komen, dan blijft het in dat tabblad staan tot de maker opnieuw start of het tabblad sluit. Keert Shopify terug (customer_posted=true) of gaat de ouder terug vanaf een foutpagina, dan zet de maker alles terug op stap 5
 * en toont bij de knop "We hebben je aanmelding ontvangen." Kan de browser niets bewaren, dan wordt er niet verzonden.
 *
 * Diagnose: mislukt de voorbereiding (beveiliging niet gereed, verzending niet gestart, geen opslag), dan staat een record in
 * window.IKDMDiagnose (alleen in het geheugen; geen adres, geen token, geen diplomagegevens).
 */
(function () {
  'use strict';
  var FORM_ID = 'ikdm-inschrijfformulier';
  var SLEUTEL = 'ikdm-herstel';
  var HOUDBAAR_MS = 30 * 60 * 1000;
  var diagnose = window.IKDMDiagnose = window.IKDMDiagnose || [];

  function transportformulier() {
    var f = document.getElementById(FORM_ID);
    return f && f.elements && f.elements['contact[email]'] ? f : null;
  }
  function heeftBeveiliging() {
    var c = window.Shopify && window.Shopify.captcha;
    return !!(c && typeof c.protect === 'function');
  }
  function wisToken(form) {
    var t = form.elements['h-captcha-response'];
    if (t) { t.value = ''; }
  }
  function leg(reden) {
    diagnose.push({ tijd: new Date().toISOString(), reden: reden });
    if (diagnose.length > 20) { diagnose.shift(); }
  }
  function maakSchoon() {
    var f = transportformulier();
    if (!f) { return; }
    f.elements['contact[email]'].value = '';
    wisToken(f);
    f.removeAttribute('target');
  }

  // ---- invoer tijdelijk bewaren en terugzetten (alleen sessionStorage van dit tabblad) ----
  function bewaarStaat() {
    try {
      var s = window.IKMaker && window.IKMaker.exporteer();
      if (!s) { return false; }
      window.sessionStorage.setItem(SLEUTEL, JSON.stringify({ t: Date.now(), s: s }));
      return window.sessionStorage.getItem(SLEUTEL) !== null;
    } catch (e) { return false; }
  }
  function haalStaat() {
    try {
      var r = window.sessionStorage.getItem(SLEUTEL);
      if (!r) { return null; }
      var o = JSON.parse(r);
      return o && o.s && Date.now() - o.t < HOUDBAAR_MS ? o.s : null;
    } catch (e) { return null; }
  }
  function wisBewaard() {
    try { window.sessionStorage.removeItem(SLEUTEL); } catch (e) { /* niets te wissen */ }
  }

  window.IKDMShopifyAdapter = {
    echt: true,
    tijdlimietMs: 60000,
    tokenMs: 25000, // zo lang mag de beveiliging van de winkel nodig hebben
    navigatieMs: 20000, // zo lang wachten we of de verzending de pagina daadwerkelijk verlaat
    get markering() {
      var c = window.IKDM || {};
      return c.getest ? '' : 'Voorlopige weergave: de aanmelding is aangesloten op Shopify en wordt nog getest.';
    },

    // Bij een gelukte start verlaat de pagina zich (native verzending); de belofte lost dan niet meer op. Alleen mislukkingen komen terug.
    verstuur: function (inzending, opties) {
      var self = this;
      var form = transportformulier();
      if (!form) { leg('geen-formulier'); return Promise.resolve({ status: 'fout' }); }
      var veld = form.elements['contact[email]'];
      var signaal = opties && opties.signal;
      return new Promise(function (klaarMelden) {
        var klaar = false;
        var verzonden = false; // vanaf de start van de native verzending verlaat de pagina zich; het wissen van de maker (pagehide) mag niets meer afbreken
        var timers = [];
        var einde = function (reden) {
          if (klaar) { return; }
          klaar = true;
          timers.forEach(clearTimeout);
          if (signaal && signaal.removeEventListener) { signaal.removeEventListener('abort', bijAfbreken); }
          maakSchoon();
          wisBewaard(); // we blijven op de pagina: niets meer bewaren
          if (reden) { leg(reden); }
          klaarMelden({ status: reden === 'geen-opslag' ? 'geenopslag' : 'fout', reden: reden || 'afgebroken' });
        };
        var bijAfbreken = function () { if (verzonden) { return; } einde(''); };
        if (signaal && signaal.addEventListener) { signaal.addEventListener('abort', bijAfbreken); }
        veld.value = inzending.email;
        form.removeAttribute('target');
        timers.push(setTimeout(function () { einde('beveiliging-niet-gereed'); }, self.tokenMs));
        var verzend = function () {
          if (klaar) { return; }
          timers.forEach(clearTimeout);
          if (!bewaarStaat()) { einde('geen-opslag'); return; } // zonder bewaren zou de ouder het diploma kwijtraken: dan niet verzenden
          // vanaf hier verlaat de pagina zich; gebeurt dat niet, dan een nette fout en een schoon formulier
          timers = [setTimeout(function () { einde('verzending-niet-gestart'); }, self.navigatieMs)];
          verzonden = true;
          try { form.submit(); } catch (e) { verzonden = false; einde('submit-fout'); }
        };
        if (heeftBeveiliging()) {
          try { window.Shopify.captcha.protect(form, verzend); } catch (e) { einde('protect-fout'); }
        } else {
          verzend(); // de winkel heeft de beveiliging uitgezet: gewone verzending zonder token
        }
      });
    }
  };

  // ---- terugkeer: invoer terugzetten en de uitkomst tonen ----
  function toonBovenaan(root, tekst) {
    var melding = document.createElement('p');
    melding.className = 'ikdm-melding';
    melding.setAttribute('role', 'status');
    melding.setAttribute('tabindex', '-1');
    melding.textContent = tekst;
    root.insertBefore(melding, root.firstChild);
    return melding;
  }

  function naTerugkeer(viaTerug) {
    var root = document.getElementById('ikdm');
    if (!root) { return; }
    var gepost = /[?&]customer_posted=true(&|$)/.test(location.search);
    var bewaard = haalStaat();
    var nav = (window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var terug = !!viaTerug || nav.type === 'back_forward';
    wisBewaard(); // nooit langer bewaard dan nodig
    var hersteld = false;
    if (bewaard && (gepost || terug) && window.IKMaker && typeof window.IKMaker.herstel === 'function') {
      try { hersteld = window.IKMaker.herstel(bewaard) === true; } catch (e) { hersteld = false; }
    }
    if (!gepost) { return; }
    // Het nieuwsbriefformulier in de footer van het thema meldt na elke geslaagde klantaanmelding zelf "Gelukt!" (met een andere belofte) en neemt
    // met autofocus de focus en de scrollpositie over. Op deze pagina geldt alleen de melding van de maker.
    var themaMeldingen = document.querySelectorAll('.newsletter-form__message--success');
    for (var i = 0; i < themaMeldingen.length; i++) { themaMeldingen[i].removeAttribute('autofocus'); themaMeldingen[i].hidden = true; themaMeldingen[i].style.display = 'none'; }
    try {
      var schoon = location.search.replace(/([?&])customer_posted=true(&|$)/, function (x, a, b) { return b ? a : ''; }).replace(/[?&]$/, '');
      history.replaceState(null, '', location.pathname + schoon); // ook het anker weg: dat zou de pagina naar het verborgen formulier scrollen
    } catch (e) { /* adresbalk laten staan */ }
    var doel = null;
    var tekst = 'We hebben je aanmelding ontvangen.';
    if (hersteld && window.IKInschrijving && typeof window.IKInschrijving.meld === 'function') {
      window.IKInschrijving.meld(tekst, 'ok');
      doel = document.getElementById('inschrijf-status');
    } else {
      doel = toonBovenaan(root, tekst);
    }
    var naarMelding = function () {
      try { doel.scrollIntoView({ block: 'center' }); if (doel.id !== 'inschrijf-status') { doel.focus({ preventScroll: true }); } } catch (e) { /* geen scroll */ }
    };
    naarMelding();
    // na het scrollen van de browser naar het anker of een autofocus
    if (document.readyState === 'complete') { setTimeout(naarMelding, 60); } else { window.addEventListener('load', function () { setTimeout(naarMelding, 60); }, { once: true }); }
  }

  // Opnieuw beginnen door de ouder: nooit bewaarde invoer laten staan.
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[data-actie="opnieuw"]')) { wisBewaard(); } }, true);

  if (document.readyState === 'complete') { setTimeout(function () { naTerugkeer(false); }, 0); } else { window.addEventListener('load', function () { setTimeout(function () { naTerugkeer(false); }, 0); }, { once: true }); }

  // Terug via de knop Vorige met een bewaarde pagina (bfcache): de maker is dan gewist; zet de invoer terug en maak het formulier schoon.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      maakSchoon();
      if (window.IKInschrijving && typeof window.IKInschrijving.reset === 'function') { window.IKInschrijving.reset(); }
      naTerugkeer(true);
    }
  });
}());


/* ---- app.js ---- */
/*
 * Intellikids diploma-maker (besloten testversie, R127b; vijf kinderthema's in R127d)
 * Schermlogica voor de vijf stappen. Gedrag gelijk aan R127; R127b en R127d wijzigen alleen het beeld en de themalijst.
 *
 * Privacy-afspraken in deze code:
 * - Alle keuzes en de voornaam staan alleen in het variabele "staat" (werkgeheugen).
 * - Geen cookies, localStorage, sessionStorage, IndexedDB, service worker of netwerkverzoeken
 *   (de CSP staat connect-src 'none' toe, dus fetch en beacons kunnen niet eens).
 * - De naam komt nooit in de URL, de paginatitel, een bestandsnaam of de console.
 * - "Maak nog een diploma" en het verlaten van de pagina wissen alles.
 * - R134: het vrijwillige inschrijfblok (js/inschrijving.js) staat los van de diplomagegevens; die gaan er nooit in mee.
 */
(function () {
  'use strict';

  var I = window.IKInhoud;
  var D = window.IKDiploma;
  var P = window.IKPdf;

  var NAAM_MAX = 20;
  var NAAM_PATROON = /^[\p{L}\p{M}]+(?:[ '’-][\p{L}\p{M}]+)*$/u;
  var AFZENDER_MAX = 30;
  var AFZENDER_PATROON = /^[\p{L}\p{M}\p{N}][\p{L}\p{M}\p{N} .,'’&+-]*$/u;
  // Thema's met een eigen indeling en echte tekstlagen (Prinses en Zeemeermin); de andere thema's tekenen op canvas
  var TEKSTMODULES = { prinses: window.IKPrinses, zeemeermin: window.IKZeemeermin, dinosaurus: window.IKDinosaurus, dieren: window.IKDieren, voertuigen: window.IKVoertuigen, ruimte: window.IKRuimte };
  var THEMA_TITEL = { prinses: 'Prinsessendiploma', zeemeermin: 'Zeemeermindiploma', dinosaurus: 'Dinosaurusdiploma', dieren: 'Dieren- en natuurdiploma', voertuigen: 'Voertuigendiploma', ruimte: 'Ruimtediploma' };
  function eigen(thema) { return Object.prototype.hasOwnProperty.call(TEKSTMODULES, thema) ? TEKSTMODULES[thema] : null; }
  var STAPNAMEN = ['Welkom', 'Spel', 'Gedaan', 'Persoonlijk', 'Diploma'];
  var STAPTITELS = ['Welkom', 'Met welk spel?', 'Wat heeft je kind gedaan?', 'Maak het persoonlijk', 'Je diploma is klaar'];


  var staat = null;
  var el = {};
  var bezig = false;
  var tekenTimer = null;
  var overzicht = { 2: [], 3: [], 4: [] };

  function beginstaat() {
    return { stap: 1, spel: '', prestatie: '', tafel: '', voornaam: '', afzender: '', datum: vandaagIso(), datumGekozen: false, thema: I.standaardThema };
  }

  /* ---------- datum ---------- */

  function isoVan(d) {
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var dag = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + dag;
  }
  function vandaagIso() { return isoVan(new Date()); }
  function leesIso(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
    if (!m) { return null; }
    var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    if (d.getFullYear() !== Number(m[1]) || d.getMonth() !== Number(m[2]) - 1 || d.getDate() !== Number(m[3])) { return null; }
    return d;
  }
  function datumGrenzen() {
    var nu = new Date();
    var min = new Date(nu.getFullYear() - 1, nu.getMonth(), nu.getDate());
    var max = new Date(nu.getFullYear(), nu.getMonth() + 1, nu.getDate());
    return { min: isoVan(min), max: isoVan(max) };
  }
  function datumTekst(iso) {
    var d = leesIso(iso);
    if (!d) { return ''; }
    return new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }).format(d);
  }

  /* ---------- naam ---------- */

  function normaliseerNaam(s) { return String(s || '').normalize('NFC').replace(/\s+/g, ' ').trim(); }
  // Het Prinsessendiploma zet de tekst in de pdf met ingesloten lettertypes; tekens die daarin ontbreken worden gemeld.
  function onbekendTeken(tekst, thema) {
    var mod = eigen(thema);
    if (!mod) { return ''; }
    var weg = mod.onbekendeTekens(tekst);
    return weg.length ? 'Dit teken past niet in het diploma: ' + weg.join(' ') + '. Kies een andere schrijfwijze of een ander thema.' : '';
  }
  function controleerNaam(n, thema) {
    if (!n) { return 'Vul de voornaam van je kind in.'; }
    if (Array.from(n).length > NAAM_MAX) { return 'Gebruik maximaal ' + NAAM_MAX + ' tekens, dan past de naam mooi op het diploma.'; }
    if (!NAAM_PATROON.test(n)) { return 'Gebruik alleen letters, een spatie, een koppelteken of een apostrof.'; }
    return onbekendTeken(n, thema);
  }
  function controleerAfzender(v) {
    if (!v) { return ''; }
    if (Array.from(v).length > AFZENDER_MAX) { return 'Gebruik maximaal ' + AFZENDER_MAX + ' tekens, dan past het ' + (staat.thema === 'zeemeermin' ? 'naast de zeemeermin' : (staat.thema === 'prinses' ? 'naast de prinses' : 'op het diploma')) + '.'; }
    if (!AFZENDER_PATROON.test(v)) { return 'Gebruik alleen letters, cijfers, een spatie of een van deze tekens: . , \' & + -'; }
    return onbekendTeken(v, staat.thema);
  }
  function controleerDatum(v) {
    if (!v) { return 'Kies een datum.'; }
    if (!leesIso(v)) { return 'Kies een geldige datum.'; }
    var g = datumGrenzen();
    if (v < g.min || v > g.max) { return 'Kies een datum in het afgelopen jaar of in de komende maand.'; }
    return '';
  }

  /* ---------- opbouw van de keuzes ---------- */

  function maak(tag, klasse, tekst) {
    var e = document.createElement(tag);
    if (klasse) { e.className = klasse; }
    if (tekst) { e.textContent = tekst; }
    return e;
  }

  // Keuzekaart: echte radioknop (onzichtbaar, over de hele kaart) met een eigen beeld of accent.
  // opties: { kleur, beeld (lokaal productbeeld), stip (accentstip), staal (element) }
  function radioKaart(groep, waarde, id, titel, uitleg, extraKlasse, opties) {
    opties = opties || {};
    var label = maak('label', 'kaart' + (extraKlasse ? ' ' + extraKlasse : ''));
    label.htmlFor = id;
    if (opties.kleur) { label.setAttribute('data-kleur', opties.kleur); }
    var invoer = document.createElement('input');
    invoer.type = 'radio';
    invoer.className = 'kaart__invoer';
    invoer.name = groep;
    invoer.id = id;
    invoer.value = waarde;
    label.appendChild(invoer);
    if (opties.beeld) {
      var beeld = maak('span', 'kaart__beeld');
      beeld.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.src = window.IKDMU(opties.beeld);
      img.alt = '';
      img.width = 288;
      img.height = 288;
      img.decoding = 'async';
      beeld.appendChild(img);
      label.appendChild(beeld);
    }
    if (opties.stip) {
      var stip = maak('span', 'kaart__stip');
      stip.setAttribute('aria-hidden', 'true');
      label.appendChild(stip);
    }
    if (opties.staal) { label.appendChild(opties.staal); }
    var tekst = maak('span', 'kaart__tekst');
    tekst.appendChild(maak('span', 'kaart__titel', titel));
    if (uitleg) { tekst.appendChild(maak('span', 'kaart__uitleg', uitleg)); }
    label.appendChild(tekst);
    var vink = maak('span', 'kaart__vink');
    vink.setAttribute('aria-hidden', 'true');
    label.appendChild(vink);
    return label;
  }

  function bouwSpelKeuzes() {
    I.spellen.forEach(function (s) {
      el.spelKeuzes.appendChild(radioKaart('spel', s.id, 'spel-' + s.id, s.kaartnaam || s.naam, s.uitleg, 'kaart--spel',
        { kleur: s.kleur, beeld: 'assets/spel-' + s.id + '-uitsnede.jpg' }));
    });
  }

  function bouwPrestatieKeuzes() {
    el.prestatieKeuzes.textContent = '';
    var spel = I.zoekSpel(staat.spel);
    if (!spel) { return; }
    el.prestatieSpel.textContent = spel.naam;
    el.prestatieKeuzes.setAttribute('data-kleur', spel.kleur);
    // de keuze toont exact de tekst die op het diploma komt; bij de tafeloptie komt het gekozen getal erin zodra het gekozen is
    spel.prestaties.forEach(function (p) {
      el.prestatieKeuzes.appendChild(radioKaart('prestatie', p.id, 'prestatie-' + p.id, prestatieLabel(p), '', 'kaart--zin', {}));
    });
    toonTafelVeld();
  }

  function prestatieLabel(p) {
    return p.metTafel ? p.zin.replace('{tafel}', staat.tafel || '…') : p.zin;
  }

  function verversTafelKaart() {
    var spel = I.zoekSpel(staat.spel);
    if (!spel) { return; }
    spel.prestaties.forEach(function (p) {
      if (!p.metTafel) { return; }
      var titel = document.querySelector('label[for="prestatie-' + p.id + '"] .kaart__titel');
      if (titel) { titel.textContent = prestatieLabel(p); }
    });
  }

  // De drie werelden krijgen een echt miniatuurtje uit dezelfde tekenfunctie, zonder naam van het kind.
  var wereldStalen = [];
  function bouwThemaKeuzes() {
    I.themas.forEach(function (t) {
      var staal = maak('span', 'kaart__staal');
      staal.setAttribute('aria-hidden', 'true');
      var cv = document.createElement('canvas');
      cv.width = 1;
      cv.height = 1;
      staal.appendChild(cv);
      wereldStalen.push({ thema: t.id, canvas: cv });
      el.themaKeuzes.appendChild(radioKaart('thema', t.id, 'thema-' + t.id, t.naam, '', 'kaart--thema', { kleur: t.kleur, staal: staal }));
    });
  }

  function tekenWereldStalen() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    wereldStalen.forEach(function (s) {
      var leeg = !!eigen(s.thema);
      D.teken(s.canvas, { voornaam: leeg ? '' : 'Voornaam', naamIsPlaatshouder: !leeg, spelNaam: leeg ? '' : 'Spel', zin: leeg ? '' : 'heeft iets nieuws geprobeerd', datumTekst: '', afzender: '', thema: s.thema }, Math.round(140 * dpr));
    });
  }

  function zetWereld(thema) {
    (document.getElementById('ikdm') || document.body).setAttribute('data-wereld', thema || I.standaardThema);
  }

  function bouwTafels() {
    for (var n = 1; n <= 10; n++) {
      var o = document.createElement('option');
      o.value = String(n);
      o.textContent = 'De tafel van ' + n;
      el.tafel.appendChild(o);
    }
  }

  function toonTafelVeld() {
    var p = I.zoekPrestatie(staat.spel, staat.prestatie);
    var nodig = !!(p && p.metTafel);
    el.tafelVeld.hidden = !nodig;
    if (!nodig) { staat.tafel = ''; el.tafel.value = ''; wisVeldFout('tafel'); }
  }

  // Thema-specifiek (Prinses): een afzender erbij en een datum die alleen wordt ingevuld als je die zelf kiest.
  function pasThemaVeldenAan() {
    var prinses = !!eigen(staat.thema);
    el.afzenderVeld.hidden = !prinses;
    el.datumHint.textContent = prinses
      ? 'Niet verplicht. Kies een datum of tik op Vandaag.'
      : 'Vandaag staat al ingevuld. Je kunt ook een andere dag kiezen.';
    if (!staat.datumGekozen) {
      staat.datum = prinses ? '' : vandaagIso();
      el.datum.value = staat.datum;
      if (prinses) { wisVeldFout('datum'); }
    }
  }

  /* ---------- fouten ---------- */

  function zetVeldFout(naam, tekst) {
    var fout = document.getElementById('fout-' + naam);
    if (fout) { fout.textContent = tekst; fout.hidden = !tekst; }
    var veld = veldVoor(naam);
    if (veld) {
      if (tekst) { veld.setAttribute('aria-invalid', 'true'); } else { veld.removeAttribute('aria-invalid'); }
    }
  }
  // Veld is in orde: foutmelding weg, en ook uit het foutoverzicht (zonder de focus te verplaatsen).
  function wisVeldFout(naam) {
    zetVeldFout(naam, '');
    [2, 3, 4].forEach(function (s) {
      var voor = overzicht[s].length;
      overzicht[s] = overzicht[s].filter(function (f) { return f.veld !== naam; });
      if (overzicht[s].length !== voor) { toonFoutoverzicht(s, overzicht[s], false); }
    });
  }

  function veldVoor(naam) {
    if (naam === 'spel') { return el.spelKeuzes; }
    if (naam === 'prestatie') { return el.prestatieKeuzes; }
    if (naam === 'thema') { return el.themaKeuzes; }
    return document.getElementById(naam);
  }

  function focusDoel(naam) {
    if (naam === 'spel' || naam === 'prestatie' || naam === 'thema') {
      var groep = veldVoor(naam);
      var gekozen = groep.querySelector('input:checked') || groep.querySelector('input');
      return gekozen;
    }
    return document.getElementById(naam);
  }

  function toonFoutoverzicht(stap, fouten, metFocus) {
    var vak = document.getElementById('fouten-' + stap);
    if (!vak) { return; }
    overzicht[stap] = fouten.slice();
    vak.textContent = '';
    if (!fouten.length) { vak.hidden = true; return; }
    vak.appendChild(maak('p', 'foutoverzicht__titel', fouten.length === 1 ? 'Nog één ding:' : 'Nog ' + fouten.length + ' dingen:'));
    var lijst = maak('ul', 'foutoverzicht__lijst');
    fouten.forEach(function (f) {
      var li = document.createElement('li');
      var knop = maak('button', 'foutoverzicht__link', f.tekst);
      knop.type = 'button';
      knop.addEventListener('click', function () { var doel = focusDoel(f.veld); if (doel) { doel.focus(); } });
      li.appendChild(knop);
      lijst.appendChild(li);
    });
    vak.appendChild(lijst);
    vak.hidden = false;
    if (metFocus) { vak.focus(); }
  }

  function valideer(stap) {
    var fouten = [];
    if (stap === 2) {
      if (!staat.spel) { fouten.push({ veld: 'spel', tekst: 'Kies eerst een spel.' }); }
      zetVeldFout('spel', staat.spel ? '' : 'Kies eerst een spel.');
    }
    if (stap === 3) {
      var p = I.zoekPrestatie(staat.spel, staat.prestatie);
      zetVeldFout('prestatie', p ? '' : 'Kies wat je kind heeft gedaan.');
      if (!p) { fouten.push({ veld: 'prestatie', tekst: 'Kies wat je kind heeft gedaan.' }); }
      if (p && p.metTafel) {
        var tafelFout = staat.tafel ? '' : 'Kies welke tafel is geoefend.';
        zetVeldFout('tafel', tafelFout);
        if (tafelFout) { fouten.push({ veld: 'tafel', tekst: tafelFout }); }
      }
    }
    if (stap === 4) {
      staat.voornaam = normaliseerNaam(el.voornaam.value);
      var naamFout = controleerNaam(staat.voornaam, staat.thema);
      zetVeldFout('voornaam', naamFout);
      if (naamFout) { fouten.push({ veld: 'voornaam', tekst: naamFout }); }
      staat.datum = el.datum.value;
      // Prinses: een datum is niet verplicht; leeg geeft een lijn om zelf in te vullen
      var datumFout = eigen(staat.thema) && !staat.datum ? '' : controleerDatum(staat.datum);
      zetVeldFout('datum', datumFout);
      if (datumFout) { fouten.push({ veld: 'datum', tekst: datumFout }); }
      if (eigen(staat.thema)) {
        staat.afzender = normaliseerNaam(el.afzender.value);
        var afzFout = controleerAfzender(staat.afzender);
        zetVeldFout('afzender', afzFout);
        if (afzFout) { fouten.push({ veld: 'afzender', tekst: afzFout }); }
        // laatste vangnet: past alles gemeten op het diploma? Zo niet, dan melden en niet verder
        if (!naamFout && !afzFout) {
          D.tekstMeldingen(gegevens(false)).forEach(function (m) {
            var veld = m.veld === 'childName' ? 'voornaam' : (m.veld === 'presentedBy' ? 'afzender' : (m.veld === 'date' ? 'datum' : ''));
            fouten.push({ veld: veld || 'voornaam', tekst: m.tekst + ' Kort het in of kies een ander thema.' });
            if (veld) { zetVeldFout(veld, m.tekst + ' Kort het in.'); }
          });
        }
      } else {
        staat.afzender = '';
        zetVeldFout('afzender', '');
      }
      if (!staat.thema) { fouten.push({ veld: 'thema', tekst: 'Kies een thema.' }); zetVeldFout('thema', 'Kies een thema.'); } else { wisVeldFout('thema'); }
    }
    toonFoutoverzicht(stap, fouten, true);
    return fouten.length === 0;
  }

  /* ---------- diploma-gegevens ---------- */

  function gegevens(voorVoorbeeld) {
    var spel = I.zoekSpel(staat.spel);
    var p = I.zoekPrestatie(staat.spel, staat.prestatie);
    var zin = p ? p.zin : '';
    if (p && p.metTafel) { zin = zin.replace('{tafel}', staat.tafel || '…'); }
    var naam = staat.voornaam;
    var plaatshouder = false;
    if (voorVoorbeeld && (!naam || controleerNaam(naam, staat.thema))) {
      // Prinses: rustig leeg, geen plaatshouder; de andere thema's tonen hun lichte 'Voornaam'
      if (eigen(staat.thema)) { naam = ''; } else { naam = 'Voornaam'; plaatshouder = true; }
    }
    return {
      voornaam: naam,
      naamIsPlaatshouder: plaatshouder,
      spelNaam: spel ? spel.naam : '',
      zin: zin,
      datumTekst: datumTekst(staat.datum),
      afzender: eigen(staat.thema) && !(voorVoorbeeld && controleerAfzender(staat.afzender)) ? staat.afzender : '',
      thema: staat.thema || I.standaardThema
    };
  }

  function beschrijving() {
    var g = gegevens(false);
    return 'Diploma. ' + g.spelNaam + '. ' + g.voornaam + '. ' + g.zin + '. Goed gedaan!' + (g.datumTekst ? ' Datum: ' + g.datumTekst + '.' : '') + (g.afzender ? ' Uitgereikt door ' + g.afzender + '.' : '') + ' Thema: ' + (I.themas.filter(function (t) { return t.id === g.thema; })[0] || {}).naam + '.';
  }

  function tekenIn(canvas, voorVoorbeeld) {
    var vak = canvas.parentElement;
    var breedte = vak.getBoundingClientRect().width;
    if (!breedte) { return; }
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    D.teken(canvas, gegevens(voorVoorbeeld), Math.round(breedte * dpr));
  }

  // Prinses: inline SVG met echte <text>-lagen (selecteerbaar, scherp op elk formaat); andere thema's: canvas.
  function toonDiploma(canvas, svgVak, voorVoorbeeld) {
    if (eigen(staat.thema)) {
      var svg = eigen(staat.thema).maakSvg(D.themaGegevens(gegevens(voorVoorbeeld)));
      svg.setAttribute('aria-label', voorVoorbeeld ? 'Voorbeeld van het ' + THEMA_TITEL[staat.thema] : beschrijving());
      svgVak.textContent = '';
      svgVak.appendChild(svg);
      svgVak.hidden = false;
      D.wis(canvas);
      canvas.hidden = true;
    } else {
      svgVak.textContent = '';
      svgVak.hidden = true;
      canvas.hidden = false;
      tekenIn(canvas, voorVoorbeeld);
      if (!voorVoorbeeld) { canvas.setAttribute('aria-label', beschrijving()); }
    }
  }

  function tekenVoorbeelden() {
    if (staat.stap === 4 && el.voorbeeldKleinVak.offsetParent !== null) { toonDiploma(el.voorbeeldKlein, el.svgKlein, true); }
    if (staat.stap === 5) { toonDiploma(el.voorbeeldGroot, el.svgGroot, false); }
  }

  function planTekenen() {
    if (tekenTimer) { clearTimeout(tekenTimer); }
    tekenTimer = setTimeout(tekenVoorbeelden, 90);
  }

  /* ---------- stappen ---------- */

  function toon(stap, opties) {
    opties = opties || {};
    staat.stap = stap;
    el.stappen.forEach(function (s, i) { s.hidden = i + 1 !== stap; });
    el.voortgangItems.forEach(function (li, i) {
      li.classList.toggle('is-klaar', i + 1 < stap);
      li.classList.toggle('is-nu', i + 1 === stap);
      if (i + 1 === stap) { li.setAttribute('aria-current', 'step'); } else { li.removeAttribute('aria-current'); }
    });
    el.voortgangTekst.textContent = 'Stap ' + stap + ' van 5: ' + STAPNAMEN[stap - 1];
    if (stap === 3) { bouwPrestatieKeuzes(); herstelKeuze('prestatie', staat.prestatie); }
    if (stap === 4 || stap === 5) { planTekenen(); }
    if (opties.focus !== false) {
      el.melding.textContent = 'Stap ' + stap + ' van 5: ' + STAPTITELS[stap - 1];
      var titel = document.getElementById('titel-' + stap);
      window.IKDMScroll();
      if (titel) { titel.focus({ preventScroll: true }); }
    }
  }

  function herstelKeuze(groep, waarde) {
    var invoer = document.querySelectorAll('input[name="' + groep + '"]');
    Array.prototype.forEach.call(invoer, function (i) { i.checked = i.value === waarde; });
  }

  function verder() {
    if (!valideer(staat.stap)) { return; }
    toon(staat.stap + 1);
  }

  function terug() {
    if (staat.stap > 1) { toon(staat.stap - 1); }
  }

  /* ---------- downloaden en printen ---------- */

  function naarBlob(canvas, type, kwaliteit) {
    return new Promise(function (ok, fout) {
      canvas.toBlob(function (b) { if (b) { ok(b); } else { fout(new Error('leeg')); } }, type, kwaliteit);
    });
  }

  // Tijdelijke blob-adressen: na 60 seconden of bij "alles wissen" ingetrokken.
  // Eerder intrekken kan een download afbreken terwijl de browser het bestand nog controleert.
  var blobAdressen = [];
  function trekIn(url) {
    URL.revokeObjectURL(url);
    blobAdressen = blobAdressen.filter(function (u) { return u !== url; });
  }
  function trekAllesIn() { blobAdressen.slice().forEach(trekIn); }

  function bewaar(blob, bestandsnaam) {
    var url = URL.createObjectURL(blob);
    blobAdressen.push(url);
    var a = document.createElement('a');
    a.href = url;
    a.download = bestandsnaam; // vaste naam, nooit de naam van het kind
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { trekIn(url); }, 60000);
  }

  function meldActie(tekst, isFout) {
    el.actiemelding.textContent = tekst;
    el.actiemelding.classList.toggle('is-fout', !!isFout);
  }

  function metBezig(taak) {
    if (bezig) { return; }
    bezig = true;
    el.acties.setAttribute('aria-busy', 'true');
    el.actieKnoppen.forEach(function (k) { k.disabled = true; });
    var werk = document.createElement('canvas');
    Promise.resolve()
      .then(function () { return D.laadAfbeeldingen(); })
      .then(function () { return taak(werk); })
      .catch(function () { meldActie('Dat lukte nu niet. Probeer het nog een keer, of kies Printen.', true); })
      .then(function () {
        D.wis(werk);
        bezig = false;
        el.acties.removeAttribute('aria-busy');
        el.actieKnoppen.forEach(function (k) { k.disabled = false; });
      });
  }

  function downloadPdf() {
    meldActie('De pdf wordt gemaakt…');
    metBezig(function (werk) {
      if (eigen(staat.thema)) {
        // Prinses en Zeemeermin: echte tekst en ingesloten lettertypes in plaats van één plaatje
        return D.maakTekstPdf(gegevens(false)).then(function (blob) {
          bewaar(blob, 'diploma-intellikids.pdf');
          meldActie('Je pdf-download is gestart.');
        });
      }
      D.teken(werk, gegevens(false), 2480);
      return naarBlob(werk, 'image/jpeg', 0.92)
        .then(function (b) { return b.arrayBuffer(); })
        .then(function (buf) {
          bewaar(P.maakPdf(new Uint8Array(buf), werk.width, werk.height), 'diploma-intellikids.pdf');
          meldActie('Je pdf-download is gestart.');
        });
    });
  }

  function downloadAfbeelding() {
    meldActie('De afbeelding wordt gemaakt…');
    metBezig(function (werk) {
      D.teken(werk, gegevens(false), 1654);
      return naarBlob(werk, 'image/png').then(function (b) {
        bewaar(b, 'diploma-intellikids.png');
        meldActie('Je afbeelding-download is gestart.');
      });
    });
  }

  // Prinses en Zeemeermin: direct printen met de inline SVG (echte tekstlagen), niet als rasterafbeelding.
  function printTekstThema() {
    meldActie('Het diploma wordt klaargezet om te printen…');
    metBezig(function () {
      return Promise.resolve().then(function () {
        var svg = eigen(staat.thema).maakSvg(D.themaGegevens(gegevens(false)));
        svg.setAttribute('width', '210mm');
        svg.setAttribute('height', '297mm');
        el.printvlak.textContent = '';
        el.printvlak.appendChild(svg);
        var geladen = Array.prototype.map.call(svg.querySelectorAll('image'), function (im) {
          return new Promise(function (ok) { var i = new Image(); i.onload = ok; i.onerror = ok; i.src = im.getAttribute('href'); });
        });
        return Promise.all(geladen).then(function () {
          return new Promise(function (ok) { requestAnimationFrame(function () { requestAnimationFrame(ok); }); });
        });
      }).then(function () {
        var opruimen = function () {
          el.printvlak.textContent = '';
          window.removeEventListener('afterprint', opruimen);
        };
        window.addEventListener('afterprint', opruimen);
        meldActie('Kies in het printvenster A4, staand.');
        window.print();
      });
    });
  }

  function printen() {
    if (eigen(staat.thema)) { printTekstThema(); return; }
    meldActie('Het diploma wordt klaargezet om te printen…');
    metBezig(function (werk) {
      D.teken(werk, gegevens(false), 2480);
      return naarBlob(werk, 'image/png').then(function (b) {
        var url = URL.createObjectURL(b);
        var img = new Image();
        img.alt = '';
        img.src = url;
        return img.decode().then(function () {
          el.printvlak.textContent = '';
          el.printvlak.appendChild(img);
          var opruimen = function () {
            el.printvlak.textContent = '';
            URL.revokeObjectURL(url);
            window.removeEventListener('afterprint', opruimen);
          };
          window.addEventListener('afterprint', opruimen);
          meldActie('Kies in het printvenster A4, staand.');
          window.print();
        });
      });
    });
  }

  // Knop "Vandaag": vult alleen na een klik de lokale kalenderdatum van dit apparaat in; daarna blijft het veld gewoon aan te passen of te wissen.
  function vulVandaag() {
    var iso = vandaagIso();
    el.datum.value = iso;
    el.datum.dispatchEvent(new Event('change', { bubbles: true }));
    el.datumStatus.textContent = 'Datum ingevuld: ' + datumTekst(iso) + '.';
    el.datumStatus.hidden = false;
  }

  /* ---------- vergroting van het diploma (stap 5) ---------- */

  function openVergroting() {
    var bron = el.svgGroot.firstElementChild;
    if (!bron || typeof el.vergroting.showModal !== 'function') { return; }
    el.vergrotingVak.textContent = '';
    var kopie = bron.cloneNode(true);
    kopie.setAttribute('aria-label', bron.getAttribute('aria-label') || 'Je diploma');
    el.vergrotingVak.appendChild(kopie);
    el.vergroting.showModal();
  }

  function sluitVergroting() {
    if (el.vergroting.open) { el.vergroting.close(); }
  }

  /* ---------- alles wissen ---------- */

  function wisAlles(stil) {
    staat = beginstaat();
    el.voornaam.value = '';
    el.afzender.value = '';
    el.datum.value = staat.datum;
    el.datumStatus.textContent = '';
    el.datumStatus.hidden = true;
    el.tafel.value = '';
    sluitVergroting();
    el.vergrotingVak.textContent = '';
    if (window.IKInschrijving) { window.IKInschrijving.reset(); }
    ['spel', 'prestatie'].forEach(function (g) { herstelKeuze(g, ''); });
    herstelKeuze('thema', I.standaardThema);
    zetWereld(I.standaardThema);
    pasThemaVeldenAan();
    ['spel', 'prestatie', 'tafel', 'voornaam', 'datum', 'afzender', 'thema'].forEach(wisVeldFout);
    [2, 3, 4].forEach(function (s) { toonFoutoverzicht(s, [], false); });
    el.zachteNaam.hidden = true;
    el.prestatieKeuzes.textContent = '';
    D.wis(el.voorbeeldKlein);
    D.wis(el.voorbeeldGroot);
    [el.svgKlein, el.svgGroot].forEach(function (v) { v.textContent = ''; v.hidden = true; });
    el.voorbeeldKlein.hidden = false;
    el.voorbeeldGroot.hidden = false;
    el.voorbeeldGroot.setAttribute('aria-label', '');
    el.printvlak.textContent = '';
    trekAllesIn();
    meldActie('');
    if (!stil) { el.melding.textContent = 'Alles is gewist. Je kunt een nieuw diploma maken.'; }
  }

  /* ---------- start ---------- */

  function init() {
    staat = beginstaat();
    el.stappen = Array.prototype.slice.call(document.querySelectorAll('.stap'));
    el.voortgangItems = Array.prototype.slice.call(document.querySelectorAll('.route__stop'));
    el.voortgangTekst = document.getElementById('voortgang-tekst');
    el.melding = document.getElementById('melding');
    el.spelKeuzes = document.getElementById('spel');
    el.prestatieKeuzes = document.getElementById('prestatie');
    el.prestatieSpel = document.getElementById('prestatie-spel');
    el.tafelVeld = document.getElementById('veld-tafel');
    el.tafel = document.getElementById('tafel');
    el.voornaam = document.getElementById('voornaam');
    el.zachteNaam = document.getElementById('zacht-voornaam');
    el.datum = document.getElementById('datum');
    el.datumHint = document.getElementById('hint-datum');
    el.datumStatus = document.getElementById('datum-status');
    el.afzender = document.getElementById('afzender');
    el.afzenderVeld = document.getElementById('veld-afzender');
    el.themaKeuzes = document.getElementById('thema');
    el.voorbeeldKlein = document.getElementById('voorbeeld-klein');
    el.voorbeeldGroot = document.getElementById('voorbeeld-groot');
    el.voorbeeldKleinVak = el.voorbeeldKlein.parentElement;
    el.svgKlein = document.getElementById('voorbeeld-klein-svg');
    el.svgGroot = document.getElementById('voorbeeld-groot-svg');
    el.acties = document.getElementById('acties');
    el.actieKnoppen = Array.prototype.slice.call(el.acties.querySelectorAll('button'));
    el.actiemelding = document.getElementById('actiemelding');
    el.printvlak = document.getElementById('printvlak');
    if (el.printvlak && el.printvlak.parentNode !== document.body) { el.printvlak.className = 'ikdm-printvlak'; document.body.appendChild(el.printvlak); }
    el.vergroting = document.getElementById('vergroting');
    el.vergrotingVak = document.getElementById('vergroting-vak');

    bouwSpelKeuzes();
    bouwThemaKeuzes();
    bouwTafels();
    herstelKeuze('thema', staat.thema);

    var g = datumGrenzen();
    el.datum.min = g.min;
    el.datum.max = g.max;
    el.datum.value = staat.datum;
    pasThemaVeldenAan();

    document.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-actie]');
      if (!knop) { return; }
      var actie = knop.getAttribute('data-actie');
      if (actie === 'start') { toon(2); }
      else if (actie === 'verder') { verder(); }
      else if (actie === 'terug') { terug(); }
      else if (actie === 'aanpassen') { toon(4); }
      else if (actie === 'pdf') { downloadPdf(); }
      else if (actie === 'png') { downloadAfbeelding(); }
      else if (actie === 'print') { printen(); }
      else if (actie === 'opnieuw') { wisAlles(false); toon(2); }
      else if (actie === 'vandaag') { vulVandaag(); }
      else if (actie === 'vergroot') { openVergroting(); }
      else if (actie === 'sluit-vergroting') { sluitVergroting(); }
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'spel') {
        if (staat.spel !== t.value) { staat.prestatie = ''; staat.tafel = ''; }
        staat.spel = t.value;
        wisVeldFout('spel');
      } else if (t.name === 'prestatie') {
        staat.prestatie = t.value;
        wisVeldFout('prestatie');
        toonTafelVeld();
        verversTafelKaart();
        if (!el.tafelVeld.hidden) { el.tafelVeld.scrollIntoView({ block: 'nearest' }); }
      } else if (t.id === 'tafel') {
        staat.tafel = t.value;
        verversTafelKaart();
        if (t.value) { wisVeldFout('tafel'); }
      } else if (t.name === 'thema') {
        staat.thema = t.value;
        zetWereld(t.value);
        pasThemaVeldenAan();
        wisVeldFout('thema');
        planTekenen();
      } else if (t.id === 'datum') {
        staat.datum = t.value;
        staat.datumGekozen = true; // bewust gekozen: blijft staan bij een ander thema
        el.datumStatus.textContent = '';
        el.datumStatus.hidden = true;
        zetVeldFout('datum', eigen(staat.thema) && !t.value ? '' : controleerDatum(t.value));
        planTekenen();
      }
    });

    el.voornaam.addEventListener('input', function () {
      staat.voornaam = normaliseerNaam(el.voornaam.value);
      el.zachteNaam.hidden = staat.voornaam.indexOf(' ') === -1;
      if (el.voornaam.getAttribute('aria-invalid') === 'true' && !controleerNaam(staat.voornaam)) { wisVeldFout('voornaam'); }
      planTekenen();
    });
    el.voornaam.addEventListener('blur', function () {
      if (el.voornaam.value) { zetVeldFout('voornaam', controleerNaam(normaliseerNaam(el.voornaam.value))); }
    });

    el.afzender.addEventListener('input', function () {
      staat.afzender = normaliseerNaam(el.afzender.value);
      zetVeldFout('afzender', controleerAfzender(staat.afzender));
      planTekenen();
    });

    // Enter in een tekstveld of datum gaat naar de volgende stap, zonder formulier te versturen
    [el.voornaam, el.datum, el.afzender].forEach(function (veld) {
      veld.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); verder(); } });
    });

    // vergroting: klik op de achtergrond sluit (Escape en de knop Sluiten doen dat ook); bij sluiten gaat de focus terug naar de knop
    el.vergroting.addEventListener('click', function (e) { if (e.target === el.vergroting) { sluitVergroting(); } });
    el.vergroting.addEventListener('close', function () { el.vergrotingVak.textContent = ''; });

    // overslaan-link zonder de URL te veranderen
    var overslaan = document.querySelector('.overslaan');
    if (overslaan) {
      overslaan.addEventListener('click', function (e) { e.preventDefault(); var h = document.getElementById('ikdm'); if (h) { h.focus(); } });
    }

    window.addEventListener('resize', planTekenen);
    // verlaten of in de achtergrond cachen: alles wissen
    window.addEventListener('pagehide', function () { wisAlles(true); });

    D.laadAfbeeldingen().then(function () { tekenWereldStalen(); planTekenen(); });
    toon(1, { focus: false });
    document.documentElement.classList.add('js-klaar');
  }

  // Website: de aanmelding bij Shopify verlaat de pagina. De adapter bewaart de invoer daarvoor tijdelijk in het geheugen van dit tabblad (sessionStorage,
  // verlaat het apparaat nooit) en zet hem na de terugkeer terug op stap 5.
  window.IKMaker = {
    exporteer: function () {
      if (!staat || staat.stap !== 5) { return null; }
      return { spel: staat.spel, prestatie: staat.prestatie, tafel: staat.tafel, voornaam: staat.voornaam, afzender: staat.afzender, datum: staat.datum, datumGekozen: !!staat.datumGekozen, thema: staat.thema };
    },
    herstel: function (b) {
      if (!staat || !b || !b.spel || !b.prestatie || !b.thema) { return false; }
      wisAlles(true);
      staat.spel = String(b.spel); staat.prestatie = String(b.prestatie); staat.voornaam = String(b.voornaam || ''); staat.afzender = String(b.afzender || '');
      staat.datum = String(b.datum || ''); staat.datumGekozen = !!b.datumGekozen; staat.thema = String(b.thema);
      el.voornaam.value = staat.voornaam; el.afzender.value = staat.afzender; el.datum.value = staat.datum;
      herstelKeuze('spel', staat.spel); bouwPrestatieKeuzes(); herstelKeuze('prestatie', staat.prestatie); herstelKeuze('thema', staat.thema);
      toonTafelVeld(); if (!el.tafelVeld.hidden) { staat.tafel = String(b.tafel || ''); el.tafel.value = staat.tafel; } verversTafelKaart();
      zetWereld(staat.thema); pasThemaVeldenAan();
      toon(5, { focus: false });
      return true;
    }
  };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
}());


/* ---- adapter instellen ---- */
(function () { function zet() { if (window.IKInschrijving && window.IKDMShopifyAdapter) { window.IKInschrijving.zetAdapter(window.IKDMShopifyAdapter); } } if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', zet); } else { zet(); } }());
